export const SUPPORTED_LANGUAGES = ['fr', 'en'];
export const DEFAULT_LANGUAGE = 'fr';

const PRIVACY_POLICY_SECTIONS = [
  {
    title: 'Introduction',
    paragraphs: [
      'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.',
      'We use Your Personal Data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.',
      'This Privacy Policy has been created with the help of the Privacy Policy Generator from TermsFeed: https://www.termsfeed.com/privacy-policy-generator/.',
    ],
  },
  {
    title: 'Interpretation',
    paragraphs: [
      'The words whose initial letters are capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.',
    ],
  },
  {
    title: 'Definitions',
    paragraphs: ['For the purposes of this Privacy Policy:'],
    items: [
      'Account means a unique account created for You to access our Service or parts of our Service.',
      'Affiliate means an entity that controls, is controlled by, or is under common control with a party, where control means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.',
      'Company, referred to as either the Company, We, Us or Our in this Privacy Policy, refers to ETC company, "El Arbi Zarrouk" Avenue, 8000 Nabeul - Tunisia.',
      'Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.',
      'Country refers to Tunisia.',
      'Device means any device that can access the Service such as a computer, a cell phone or a digital tablet.',
      'Personal Data, or Personal Information, is any information that relates to an identified or identifiable individual. We use Personal Data and Personal Information interchangeably unless a law uses a specific term.',
      'Service refers to the Website.',
      'Service Provider means any natural or legal person who processes the data on behalf of the Company.',
      'Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.',
      'Website refers to ETC company, accessible from https://etc.tn/.',
      'You means the individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
    ],
  },
  {
    title: 'Collecting and Using Your Personal Data',
    paragraphs: [
      'While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You.',
    ],
    items: ['Email address', 'First name and last name', 'Phone number'],
  },
  {
    title: 'Usage Data',
    paragraphs: [
      'Usage Data is collected automatically when using the Service.',
      "Usage Data may include information such as Your Device's Internet Protocol address, browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.",
      "When You access the Service by or through a mobile device, We may collect certain information automatically, including the type of mobile device You use, Your mobile device's unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.",
      'We may also collect information that Your browser sends whenever You visit Our Service or when You access the Service by or through a mobile device.',
    ],
  },
  {
    title: 'Tracking Technologies and Cookies',
    paragraphs: [
      'We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies We use include beacons, tags, and scripts to collect and track information and to improve and analyze Our Service.',
      'Cookies can be Persistent or Session Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser.',
      'Where required by law, we use non-essential cookies only with Your consent. You can withdraw or change Your consent at any time using Our cookie preferences tool, if available, or through Your browser or device settings.',
      'Withdrawing consent does not affect the lawfulness of processing based on consent before its withdrawal.',
    ],
    items: [
      'Cookies or Browser Cookies: a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. If You do not accept Cookies, You may not be able to use some parts of our Service.',
      'Web Beacons: small electronic files that may be used in sections of our Service and emails to count users, track email openings, record the popularity of sections, and verify system and server integrity.',
      'Necessary / Essential Cookies: Session Cookies administered by Us and essential to provide services available through the Website, authenticate users, and prevent fraudulent use of user accounts.',
      'Cookies Policy / Notice Acceptance Cookies: Persistent Cookies administered by Us to identify if users have accepted the use of cookies on the Website.',
      'Functionality Cookies: Persistent Cookies administered by Us to remember choices You make when You use the Website, such as login details or language preference.',
    ],
  },
  {
    title: 'Use of Your Personal Data',
    paragraphs: ['The Company may use Personal Data for the following purposes:'],
    items: [
      'To provide and maintain our Service, including to monitor the usage of our Service.',
      'To manage Your Account and Your registration as a user of the Service.',
      'For the performance of a contract, including the purchase contract for machines, items or services You have purchased, or any other contract with Us through the Service.',
      'To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication regarding updates, informative communications, contracted services, and security updates.',
      'To provide You with news, special offers, and general information about goods, services and events similar to those that You have already purchased or inquired about, unless You have opted not to receive such information.',
      'To manage Your requests to Us.',
      'For business transfers, including evaluating or conducting a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets.',
      'For other purposes such as data analysis, identifying usage trends, determining the effectiveness of promotional campaigns, and improving our Service, machines, services, marketing, and Your experience.',
    ],
  },
  {
    title: 'Sharing Your Personal Data',
    paragraphs: ['We may share Your Personal Data in the following situations:'],
    items: [
      'With Service Providers to monitor and analyze the use of our Service and to contact You.',
      'For business transfers in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business.',
      'With Affiliates, in which case We will require those affiliates to honor this Privacy Policy.',
      'With business partners to offer You certain machines, services or promotions.',
      'With other users, if Our Service offers public areas and You share Personal Data or otherwise interact in those public areas.',
      'With Your consent for any other purpose.',
    ],
  },
  {
    title: 'Retention of Your Personal Data',
    paragraphs: [
      'The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy.',
      'We will retain and use Your Personal Data to the extent necessary to comply with legal obligations, resolve disputes, and enforce our legal agreements and policies.',
      'Where possible, We apply shorter retention periods and reduce identifiability by deleting, aggregating, or anonymizing data.',
      'Unless otherwise stated, the retention periods below are maximum periods and We may delete or anonymize data sooner when it is no longer needed.',
    ],
    items: [
      'User Accounts: retained for the duration of Your account relationship plus up to 24 months after account closure.',
      'Support tickets and correspondence: retained up to 24 months from ticket closure.',
      'Chat transcripts: retained up to 24 months for quality assurance and staff training purposes.',
      'Website analytics data, cookies, IP addresses, and device identifiers: retained up to 24 months from collection.',
      'Server logs, IP addresses, and access times: retained up to 24 months for security monitoring and troubleshooting.',
      'Usage Data may be retained longer only where necessary for security, fraud prevention, or legal compliance.',
    ],
  },
  {
    title: 'Extended Retention and Deletion',
    paragraphs: [
      'We may retain Personal Data beyond the periods stated above where required by legal obligation, legal claims, Your explicit request, or technical limitations such as backup systems scheduled for routine deletion.',
      'You may request information about how long We will retain Your Personal Data by contacting Us.',
      'When retention periods expire, We securely delete or anonymize Personal Data.',
    ],
    items: [
      'Deletion: Personal Data is removed from Our systems and no longer actively processed.',
      'Backup retention: residual copies may remain in encrypted backups for a limited period and are not restored except where necessary for security, disaster recovery, or legal compliance.',
      'Anonymization: in some cases, We convert Personal Data into anonymous statistical data that cannot be linked back to You and may be retained indefinitely for research and analytics.',
    ],
  },
  {
    title: 'Transfer of Your Personal Data',
    paragraphs: [
      "Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located.",
      'This means that information may be transferred to and maintained on computers located outside of Your state, province, country or other governmental jurisdiction where data protection laws may differ.',
      'Where required by applicable law, We will ensure that international transfers of Your Personal Data are subject to appropriate safeguards and supplementary measures where appropriate.',
      'The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy.',
    ],
  },
  {
    title: 'Delete Your Personal Data',
    paragraphs: [
      'You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.',
      'Our Service may give You the ability to delete certain information about You from within the Service.',
      'You may update, amend, or delete Your information at any time by signing in to Your Account, if You have one, and visiting the account settings section.',
      'You may also contact Us to request access to, correct, or delete any Personal Data that You have provided to Us.',
      'Please note that We may need to retain certain information when We have a legal obligation or lawful basis to do so.',
    ],
  },
  {
    title: 'Disclosure of Your Personal Data',
    paragraphs: [
      'If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.',
      'Under certain circumstances, the Company may be required to disclose Your Personal Data if required by law or in response to valid requests by public authorities.',
      'The Company may disclose Your Personal Data in the good faith belief that such action is necessary to comply with a legal obligation, protect and defend the rights or property of the Company, prevent or investigate possible wrongdoing, protect personal safety, or protect against legal liability.',
    ],
  },
  {
    title: 'Security of Your Personal Data',
    paragraphs: [
      'The security of Your Personal Data is important to Us, but no method of transmission over the Internet or method of electronic storage is 100% secure.',
      'While We strive to use commercially reasonable means to protect Your Personal Data, We cannot guarantee its absolute security.',
    ],
  },
  {
    title: "Children's Privacy",
    paragraphs: [
      'Our Service does not address anyone under the age of 16. We do not knowingly collect personally identifiable information from anyone under the age of 16.',
      'If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.',
      'If We become aware that We have collected Personal Data from anyone under the age of 16 without verification of parental consent, We take steps to remove that information from Our servers.',
      "If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.",
    ],
  },
  {
    title: 'Links to Other Websites',
    paragraphs: [
      "Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site.",
      'We strongly advise You to review the Privacy Policy of every site You visit.',
      'We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.',
    ],
  },
  {
    title: 'Changes to this Privacy Policy',
    paragraphs: [
      'We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.',
      'We will let You know via email and/or a prominent notice on Our Service prior to the change becoming effective and update the Last updated date at the top of this Privacy Policy.',
      'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
    ],
  },
  {
    title: 'Contact Us',
    paragraphs: ['If You have any questions about this Privacy Policy, You can contact Us:'],
    items: ['By email: sales@etc.tn', 'By phone: 0021626363025'],
  },
];

const PRIVACY_POLICY_SECTIONS_FR = [
  {
    title: 'Introduction',
    paragraphs: [
      'La présente Politique de confidentialité décrit Nos politiques et procédures concernant la collecte, l’utilisation et la divulgation de Vos informations lorsque Vous utilisez le Service, et Vous informe de Vos droits en matière de confidentialité ainsi que de la manière dont la loi Vous protège.',
      'Nous utilisons Vos Données personnelles afin de fournir et d’améliorer le Service. En utilisant le Service, Vous acceptez la collecte et l’utilisation des informations conformément à la présente Politique de confidentialité.',
      'Cette Politique de confidentialité a été créée avec l’aide du générateur de politique de confidentialité de TermsFeed : https://www.termsfeed.com/privacy-policy-generator/.',
    ],
  },
  {
    title: 'Interprétation',
    paragraphs: [
      'Les mots dont la première lettre est en majuscule ont la signification définie dans les conditions ci-dessous. Ces définitions ont le même sens qu’elles apparaissent au singulier ou au pluriel.',
    ],
  },
  {
    title: 'Définitions',
    paragraphs: ['Aux fins de la présente Politique de confidentialité :'],
    items: [
      'Compte désigne un compte unique créé pour Vous permettre d’accéder à Notre Service ou à certaines parties de Notre Service.',
      'Affilié désigne une entité qui contrôle, est contrôlée par, ou est sous contrôle commun avec une partie, le contrôle signifiant la détention de 50 % ou plus des actions, participations ou autres titres donnant droit au vote pour l’élection des administrateurs ou d’une autre autorité de gestion.',
      'Société, désignée par les termes la Société, Nous, Notre ou Nos dans la présente Politique de confidentialité, désigne ETC company, Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie.',
      'Cookies désigne de petits fichiers placés sur Votre ordinateur, appareil mobile ou tout autre appareil par un site web, contenant notamment des informations relatives à Votre historique de navigation sur ce site.',
      'Pays désigne la Tunisie.',
      'Appareil désigne tout appareil pouvant accéder au Service, tel qu’un ordinateur, un téléphone mobile ou une tablette numérique.',
      'Données personnelles, ou Informations personnelles, désigne toute information se rapportant à une personne identifiée ou identifiable. Nous utilisons les termes Données personnelles et Informations personnelles de manière interchangeable, sauf lorsqu’une loi emploie un terme spécifique.',
      'Service désigne le Site web.',
      'Prestataire de services désigne toute personne physique ou morale qui traite les données pour le compte de la Société.',
      'Données d’utilisation désigne les données collectées automatiquement, générées par l’utilisation du Service ou par l’infrastructure du Service elle-même.',
      'Site web désigne ETC company, accessible depuis https://etc.tn/.',
      'Vous désigne la personne qui accède au Service ou l’utilise, ou la société ou autre entité juridique pour le compte de laquelle cette personne accède au Service ou l’utilise, selon le cas.',
    ],
  },
  {
    title: 'Collecte et utilisation de Vos Données personnelles',
    paragraphs: [
      'Lorsque Vous utilisez Notre Service, Nous pouvons Vous demander de Nous fournir certaines informations personnellement identifiables pouvant être utilisées pour Vous contacter ou Vous identifier.',
    ],
    items: ['Adresse email', 'Prénom et nom', 'Numéro de téléphone'],
  },
  {
    title: 'Données d’utilisation',
    paragraphs: [
      'Les Données d’utilisation sont collectées automatiquement lors de l’utilisation du Service.',
      'Les Données d’utilisation peuvent inclure des informations telles que l’adresse IP de Votre Appareil, le type de navigateur, la version du navigateur, les pages de Notre Service que Vous consultez, l’heure et la date de Votre visite, le temps passé sur ces pages, les identifiants uniques d’appareil et d’autres données de diagnostic.',
      'Lorsque Vous accédez au Service par un appareil mobile, Nous pouvons collecter automatiquement certaines informations, notamment le type d’appareil mobile utilisé, l’identifiant unique de Votre appareil mobile, l’adresse IP de Votre appareil mobile, Votre système d’exploitation mobile, le type de navigateur Internet mobile utilisé, les identifiants uniques d’appareil et d’autres données de diagnostic.',
      'Nous pouvons également collecter les informations que Votre navigateur envoie chaque fois que Vous visitez Notre Service ou lorsque Vous y accédez par un appareil mobile.',
    ],
  },
  {
    title: 'Technologies de suivi et Cookies',
    paragraphs: [
      'Nous utilisons des Cookies et des technologies de suivi similaires pour suivre l’activité sur Notre Service et stocker certaines informations. Les technologies de suivi que Nous utilisons comprennent notamment les balises, tags et scripts afin de collecter et suivre des informations, ainsi que d’améliorer et analyser Notre Service.',
      'Les Cookies peuvent être persistants ou de session. Les Cookies persistants restent sur Votre ordinateur personnel ou appareil mobile lorsque Vous êtes hors ligne, tandis que les Cookies de session sont supprimés dès que Vous fermez Votre navigateur web.',
      'Lorsque la loi l’exige, Nous utilisons les cookies non essentiels uniquement avec Votre consentement. Vous pouvez retirer ou modifier Votre consentement à tout moment via Notre outil de préférences de cookies, s’il est disponible, ou via les paramètres de Votre navigateur ou appareil.',
      'Le retrait du consentement n’affecte pas la licéité du traitement fondé sur le consentement avant son retrait.',
    ],
    items: [
      'Cookies ou Cookies de navigateur : petit fichier placé sur Votre Appareil. Vous pouvez demander à Votre navigateur de refuser tous les Cookies ou de Vous signaler lorsqu’un Cookie est envoyé. Si Vous n’acceptez pas les Cookies, certaines parties de Notre Service peuvent ne pas fonctionner.',
      'Balises web : petits fichiers électroniques pouvant être utilisés dans certaines sections de Notre Service et dans Nos emails pour compter les utilisateurs, suivre les ouvertures d’emails, mesurer la popularité de certaines sections et vérifier l’intégrité du système et du serveur.',
      'Cookies nécessaires / essentiels : Cookies de session administrés par Nous, indispensables pour fournir les services disponibles via le Site web, authentifier les utilisateurs et prévenir l’utilisation frauduleuse des comptes.',
      'Cookies de politique / acceptation des cookies : Cookies persistants administrés par Nous afin d’identifier si les utilisateurs ont accepté l’utilisation des cookies sur le Site web.',
      'Cookies de fonctionnalité : Cookies persistants administrés par Nous afin de mémoriser les choix que Vous effectuez lorsque Vous utilisez le Site web, comme les informations de connexion ou la préférence de langue.',
    ],
  },
  {
    title: 'Utilisation de Vos Données personnelles',
    paragraphs: ['La Société peut utiliser les Données personnelles aux fins suivantes :'],
    items: [
      'Fournir et maintenir Notre Service, y compris surveiller l’utilisation de Notre Service.',
      'Gérer Votre Compte et Votre inscription en tant qu’utilisateur du Service.',
      'Exécuter un contrat, notamment le contrat d’achat des machines, articles ou services que Vous avez achetés, ou tout autre contrat conclu avec Nous via le Service.',
      'Vous contacter par email, appels téléphoniques, SMS ou autres formes équivalentes de communication électronique concernant les mises à jour, communications informatives, services contractés et mises à jour de sécurité.',
      'Vous fournir des actualités, offres spéciales et informations générales sur des biens, services et événements similaires à ceux que Vous avez déjà achetés ou au sujet desquels Vous Vous êtes renseigné, sauf si Vous avez choisi de ne pas recevoir ces informations.',
      'Gérer Vos demandes adressées à Nous.',
      'Traiter des opérations commerciales, notamment l’évaluation ou la réalisation d’une fusion, cession, restructuration, réorganisation, dissolution ou autre vente ou transfert de tout ou partie de Nos actifs.',
      'Poursuivre d’autres finalités telles que l’analyse de données, l’identification des tendances d’utilisation, l’évaluation de l’efficacité des campagnes promotionnelles et l’amélioration de Notre Service, de Nos machines, services, marketing et de Votre expérience.',
    ],
  },
  {
    title: 'Partage de Vos Données personnelles',
    paragraphs: ['Nous pouvons partager Vos Données personnelles dans les situations suivantes :'],
    items: [
      'Avec des Prestataires de services afin de surveiller et analyser l’utilisation de Notre Service et de Vous contacter.',
      'Dans le cadre d’opérations commerciales, notamment en lien avec une fusion, vente d’actifs de la Société, financement ou acquisition de tout ou partie de Notre activité.',
      'Avec Nos Affiliés, auquel cas Nous leur demanderons de respecter la présente Politique de confidentialité.',
      'Avec des partenaires commerciaux afin de Vous proposer certains machines, services ou promotions.',
      'Avec d’autres utilisateurs, si Notre Service propose des espaces publics et que Vous partagez des Données personnelles ou interagissez dans ces espaces publics.',
      'Avec Votre consentement pour toute autre finalité.',
    ],
  },
  {
    title: 'Conservation de Vos Données personnelles',
    paragraphs: [
      'La Société conservera Vos Données personnelles uniquement aussi longtemps que nécessaire aux fins énoncées dans la présente Politique de confidentialité.',
      'Nous conserverons et utiliserons Vos Données personnelles dans la mesure nécessaire pour respecter Nos obligations légales, résoudre des litiges et faire appliquer Nos accords et politiques.',
      'Lorsque cela est possible, Nous appliquons des durées de conservation plus courtes et réduisons l’identifiabilité en supprimant, agrégeant ou anonymisant les données.',
      'Sauf indication contraire, les durées de conservation ci-dessous sont des durées maximales et Nous pouvons supprimer ou anonymiser les données plus tôt lorsqu’elles ne sont plus nécessaires.',
    ],
    items: [
      'Comptes utilisateurs : conservés pendant la durée de Votre relation de compte, puis jusqu’à 24 mois après la fermeture du compte.',
      'Tickets d’assistance et correspondances : conservés jusqu’à 24 mois après la clôture du ticket.',
      'Transcriptions de chat : conservées jusqu’à 24 mois à des fins d’assurance qualité et de formation du personnel.',
      'Données d’analyse du site web, cookies, adresses IP et identifiants d’appareil : conservés jusqu’à 24 mois à compter de la collecte.',
      'Journaux serveur, adresses IP et heures d’accès : conservés jusqu’à 24 mois à des fins de surveillance de sécurité et de dépannage.',
      'Les Données d’utilisation peuvent être conservées plus longtemps uniquement lorsque cela est nécessaire pour la sécurité, la prévention de la fraude ou la conformité légale.',
    ],
  },
  {
    title: 'Conservation prolongée et suppression',
    paragraphs: [
      'Nous pouvons conserver les Données personnelles au-delà des périodes indiquées ci-dessus lorsque cela est requis par une obligation légale, des réclamations juridiques, Votre demande explicite ou des limitations techniques telles que des systèmes de sauvegarde programmés pour une suppression de routine.',
      'Vous pouvez Nous contacter pour demander des informations sur la durée de conservation de Vos Données personnelles.',
      'Lorsque les périodes de conservation expirent, Nous supprimons ou anonymisons les Données personnelles de manière sécurisée.',
    ],
    items: [
      'Suppression : les Données personnelles sont retirées de Nos systèmes et ne sont plus traitées activement.',
      'Conservation des sauvegardes : des copies résiduelles peuvent subsister dans des sauvegardes chiffrées pendant une période limitée et ne sont restaurées que lorsque cela est nécessaire pour la sécurité, la reprise après sinistre ou la conformité légale.',
      'Anonymisation : dans certains cas, Nous transformons les Données personnelles en données statistiques anonymes ne pouvant plus Vous être rattachées, qui peuvent être conservées indéfiniment à des fins de recherche et d’analyse.',
    ],
  },
  {
    title: 'Transfert de Vos Données personnelles',
    paragraphs: [
      'Vos informations, y compris les Données personnelles, sont traitées dans les bureaux opérationnels de la Société et dans tout autre lieu où se trouvent les parties impliquées dans le traitement.',
      'Cela signifie que les informations peuvent être transférées vers des ordinateurs situés en dehors de Votre État, province, pays ou autre juridiction gouvernementale, et y être conservées, lorsque les lois de protection des données peuvent différer.',
      'Lorsque la loi applicable l’exige, Nous veillerons à ce que les transferts internationaux de Vos Données personnelles soient soumis à des garanties appropriées et à des mesures supplémentaires lorsque cela est nécessaire.',
      'La Société prendra toutes les mesures raisonnablement nécessaires pour s’assurer que Vos données sont traitées de manière sécurisée et conformément à la présente Politique de confidentialité.',
    ],
  },
  {
    title: 'Suppression de Vos Données personnelles',
    paragraphs: [
      'Vous avez le droit de supprimer ou de demander que Nous Vous aidions à supprimer les Données personnelles que Nous avons collectées à Votre sujet.',
      'Notre Service peut Vous permettre de supprimer certaines informations Vous concernant directement depuis le Service.',
      'Vous pouvez mettre à jour, modifier ou supprimer Vos informations à tout moment en Vous connectant à Votre Compte, si Vous en avez un, et en accédant à la section des paramètres du compte.',
      'Vous pouvez également Nous contacter pour demander l’accès, la correction ou la suppression des Données personnelles que Vous Nous avez fournies.',
      'Veuillez noter que Nous pouvons devoir conserver certaines informations lorsque Nous avons une obligation légale ou une base légitime pour le faire.',
    ],
  },
  {
    title: 'Divulgation de Vos Données personnelles',
    paragraphs: [
      'Si la Société est impliquée dans une fusion, une acquisition ou une vente d’actifs, Vos Données personnelles peuvent être transférées. Nous Vous informerons avant que Vos Données personnelles ne soient transférées et soumises à une autre Politique de confidentialité.',
      'Dans certaines circonstances, la Société peut être tenue de divulguer Vos Données personnelles si la loi l’exige ou en réponse à des demandes valides des autorités publiques.',
      'La Société peut divulguer Vos Données personnelles de bonne foi lorsqu’une telle action est nécessaire pour respecter une obligation légale, protéger et défendre les droits ou biens de la Société, prévenir ou enquêter sur d’éventuels actes répréhensibles, protéger la sécurité des personnes ou se prémunir contre une responsabilité juridique.',
    ],
  },
  {
    title: 'Sécurité de Vos Données personnelles',
    paragraphs: [
      'La sécurité de Vos Données personnelles est importante pour Nous, mais aucune méthode de transmission sur Internet ni aucune méthode de stockage électronique n’est sécurisée à 100 %.',
      'Bien que Nous Nous efforcions d’utiliser des moyens commercialement raisonnables pour protéger Vos Données personnelles, Nous ne pouvons pas garantir leur sécurité absolue.',
    ],
  },
  {
    title: 'Confidentialité des enfants',
    paragraphs: [
      'Notre Service ne s’adresse pas aux personnes de moins de 16 ans. Nous ne collectons pas sciemment d’informations personnellement identifiables auprès de personnes de moins de 16 ans.',
      'Si Vous êtes parent ou tuteur et que Vous savez que Votre enfant Nous a fourni des Données personnelles, veuillez Nous contacter.',
      'Si Nous apprenons que Nous avons collecté des Données personnelles auprès d’une personne de moins de 16 ans sans vérification du consentement parental, Nous prenons des mesures pour supprimer ces informations de Nos serveurs.',
      'Si Nous devons Nous appuyer sur le consentement comme base légale du traitement de Vos informations et que Votre pays exige le consentement d’un parent, Nous pouvons exiger le consentement de Votre parent avant de collecter et d’utiliser ces informations.',
    ],
  },
  {
    title: 'Liens vers d’autres sites web',
    paragraphs: [
      'Notre Service peut contenir des liens vers d’autres sites web qui ne sont pas exploités par Nous. Si Vous cliquez sur un lien tiers, Vous serez redirigé vers le site de ce tiers.',
      'Nous Vous conseillons vivement de consulter la Politique de confidentialité de chaque site que Vous visitez.',
      'Nous n’avons aucun contrôle sur le contenu, les politiques de confidentialité ou les pratiques de sites ou services tiers, et n’assumons aucune responsabilité à leur égard.',
    ],
  },
  {
    title: 'Modifications de la présente Politique de confidentialité',
    paragraphs: [
      'Nous pouvons mettre à jour Notre Politique de confidentialité de temps à autre. Nous Vous informerons de toute modification en publiant la nouvelle Politique de confidentialité sur cette page.',
      'Nous Vous informerons par email et/ou par un avis visible sur Notre Service avant que la modification ne prenne effet, et mettrons à jour la date de dernière mise à jour en haut de la présente Politique de confidentialité.',
      'Nous Vous conseillons de consulter régulièrement la présente Politique de confidentialité. Les modifications prennent effet lorsqu’elles sont publiées sur cette page.',
    ],
  },
  {
    title: 'Nous contacter',
    paragraphs: ['Si Vous avez des questions concernant la présente Politique de confidentialité, Vous pouvez Nous contacter :'],
    items: ['Par email : sales@etc.tn', 'Par téléphone : 0021626363025'],
  },
];

export const translations = {
  en: {
    common: {
      language: 'Language',
      translationLanguage: 'Translation Language',
      englishShort: 'EN',
      frenchShort: 'FR',
      home: 'Home',
      backHome: 'Back Home',
      pageNotFoundMessage: "The page you are looking for doesn't exist or has been moved.",
      general: 'General',
      yes: 'Yes',
      no: 'No',
      noImage: 'No image',
      all: 'All',
      cancel: 'Cancel',
      previous: 'Previous',
      next: 'Next',
      saving: 'Saving...',
      related: 'Related',
      website: 'Website',
      unknown: 'Unknown',
      product: 'Machine',
      loading: 'Loading...',
      sparePart: 'Spare Part',
      itemsCount: '{{count}} items',
      showMore: 'Show more',
      showLess: 'Show less',
      priceOnRequest: 'Price on request',
      errorLoadingData: 'No machine available for now',
      retry: 'retry later',
    },
    mailTemplate: {
      companyLine: 'ETC Company | Essid Trading Company | Arbi Zarrouk Avenue 8000 Nabeul - Tunisie',
      registrationLine: 'ETC Company | Essid Trading Company | Arbi Zarrouk Avenue 8000 Nabeul - Tunisie',
      privacyPolicyLink: 'Privacy Policy',
      contactComplianceNotice:
        'NOTICE: This message is intended for the addressee only and may contain confidential information; unauthorized use is prohibited. Please review our Privacy Policy regarding data processing.',
      contactComplianceReply: 'Reply to this message to continue the conversation with the customer.',
      contactComplianceRegistration: 'ETC Company | Essid Trading Company registration details available on request | Arbi Zarrouk Avenue 8000 Nabeul - Tunisie',
      contactEyebrow: 'ETC Company',
      contactTitle: 'New contact request',
      contactIntro: 'A visitor submitted the website contact form.',
      contactPreheaderVisitor: 'New contact request from website visitor',
      contactPreheaderFrom: 'New contact request from {{name}}',
      contactSubjectPrefix: 'New contact request',
      contactSubjectWithSubject: 'New contact request: {{subject}}',
      contactSubjectFrom: 'New contact request from {{name}}',
      contactTextTitle: 'New contact request from {{name}}',
      contactTextTitleVisitor: 'New contact request from website visitor',
      contactTextSubject: 'Subject: {{subject}}',
      contactTextEmail: 'Email: {{email}}',
      contactTextPhone: 'Phone: {{phone}}',
      contactTextInquiry: 'Inquiry type: {{inquiryType}}',
      contactLabelName: 'Name',
      contactLabelSubject: 'Subject',
      contactLabelEmail: 'Email',
      contactLabelPhone: 'Phone',
      contactLabelInquiry: 'Inquiry type',
      contactLabelMessage: 'Message',
      contactFieldEmpty: 'Not provided',
      contactValueFallback: 'Website visitor',
      resetEyebrow: 'ETC Company',
      resetTitle: 'Reset your password',
      resetIntro: 'You requested a password reset for your ETC account.',
      resetPreheader: 'Password reset request',
      resetSubject: 'Reset your password',
      resetBodyPrompt: 'Click the button below to create a new password.',
      resetCta: 'Reset password',
      resetExpireNote: 'This link will expire in 1 hour. If you did not request this, you can safely ignore the email.',
      resetTextTitle: 'You requested a password reset.',
      resetTextLink: 'Reset your password using this link: {{url}}',
      resetTextExpire: 'This link will expire in 1 hour.',
      resetTextIgnore: 'If you did not request this, you can ignore this email.',
      quoteEyebrow: 'ETC Company',
      quoteTitle: 'Request for Quote {{number}}',
      quoteIntro: 'Your quote request has been reviewed and converted into a request for quote summary.',
      quotePreheader: 'Purchase order {{number}}',
      quoteSubject: 'Request for Quote {{number}}',
      quoteTextTitle: 'Request for Quote {{number}}',
      quoteTextCustomer: 'Customer: {{name}}',
      quoteTextSubtotal: 'Subtotal: {{amount}} {{currency}}',
      quoteTextQuotedSubtotal: 'Quoted subtotal: {{amount}} {{currency}}',
      quoteTextInterest: 'Interest: {{percent}}% = {{amount}} {{currency}}',
      quoteTextTva: 'VAT: {{percent}}% = {{amount}} {{currency}}',
      quoteTextFinalTotal: 'Final total: {{amount}} {{currency}}',
      quoteTextNotes: 'Notes: {{note}}',
      quoteTableItem: 'Item',
      quoteTableQty: 'Qty',
      quoteTableUnit: 'Unit',
      quoteTableTotal: 'Total',
      quoteTableItemKind: 'product',
      quoteTableItemKindFallback: 'item',
      quoteTableItemNameFallback: 'Item',
      quoteTableEmpty: 'No items',
      quoteLabelSubtotal: 'Subtotal',
      quoteLabelQuotedSubtotal: 'Quoted subtotal',
      quoteLabelInterest: 'Interest',
      quoteLabelTva: 'VAT',
      quoteLabelFinalTotal: 'Final total',
      quoteLabelCustomer: 'Customer',
      quoteNoteLabel: 'Customer note',
      quoteInterestLine: 'Interest: {{percent}}% ({{amount}} {{currency}})',
      quoteFooter: 'This request for quote was generated from the ETC website quote request workflow. If you need changes, reply to this email.',
      rejectionTitle: 'Request for Quote {{number}} declined',
      rejectionIntro: 'The request has been reviewed and declined.',
      rejectionPreheader: 'Purchase order {{number}} declined',
      rejectionSubject: 'Request for Quote {{number}} declined',
      rejectionTextTitle: 'Purchase order {{number}} has been declined.',
      rejectionTextCustomer: 'Customer: {{name}}',
      rejectionTextReason: 'Reason: {{reason}}',
      rejectionTextReply: 'If you would like to discuss this request, please reply to this email.',
      rejectionLabelCustomer: 'Customer',
      rejectionLabelReason: 'Reason',
      rejectionFooter: 'If you would like to discuss this request, please reply to this email.',
      inquiryProducts: 'Machines',
      inquirySpareParts: 'Spare Parts',
      inquiryAfterSales: 'After-Sales Support',
      inquiryOther: 'Other',
      previewSampleItemName: 'Forklift Tire',
      previewSampleCustomer: 'Sarah Johnson',
      previewSampleContactName: 'Sarah Johnson',
      previewSampleContactEmail: 'sarah@example.com',
      previewSampleContactSubject: 'Pricing request',
      previewSampleContactMessage: 'Hello, I would like to know the availability and price for a forklift tire set.',
      previewSampleQuoteNote: 'Please confirm delivery availability for next week.',
    },
    promoNotice: {
      title: 'Promotions are live',
      description: 'Browse featured offers and active promos in one place.',
      action: 'Browse promotions',
      dismiss: 'Dismiss',
      close: 'Close notification',
    },
    components: {
      imageUpload: {
        chooseImage: 'Choose image',
        dragDropLabel: 'Drag and drop an image here, or click to choose',
        invalidImageType: 'Please choose an image file.',
        maxFileSizeLabel: 'Maximum file size: {{maxSize}}',
        maxFileSizeExceeded: 'Image is too large. Maximum allowed is {{maxSize}}.',
        optimizedUploadHint: 'Images are optimized automatically before upload.',
        cannotLoadCurrentImage: 'Cannot load current image.',
        canvasNotAvailable: 'Canvas not available.',
        imageSizeNotReady: 'Image size is not ready yet.',
        failedRenderImage: 'Failed to render edited image.',
        loading: 'Loading...',
        edit: 'Edit',
        currentImageAlt: 'Current',
        title: 'Image Upload',
        processing: 'Processing...',
        reposition: 'Reposition',
        cropProfilePhoto: 'Crop Profile Photo',
        dragAdjustZoom: 'Drag image and adjust zoom.',
        closeEditor: 'Close image editor',
        close: 'Close',
        editPreviewAlt: 'Edit preview',
        zoom: 'Zoom',
        reset: 'Reset',
        uploading: 'Uploading...',
        applyCrop: 'Apply Crop',
      },
      customNumberInput: {
        increaseValue: 'Increase value',
        decreaseValue: 'Decrease value',
      },
      customSelect: {
        placeholder: 'Select an option',
        searchPlaceholder: 'Search...',
        emptyText: 'No results found',
      },
      customDateInput: {
        openDatePicker: 'Open date picker',
        openDateTimePicker: 'Open date and time picker',
        clearDate: 'Clear date',
        toggleCalendar: 'Toggle calendar',
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        sun: 'Su',
        mon: 'Mo',
        tue: 'Tu',
        wed: 'We',
        thu: 'Th',
        fri: 'Fr',
        sat: 'Sa',
      },
      compatibleSpareParts: {
        title: 'Compatible spare parts',
        hint: 'Select the spare parts that go with this product.',
        searchPlaceholder: 'Search spare parts',
        emptyText: 'No spare parts available yet.',
        noMatchesText: 'No spare parts match your search.',
        selected: 'selected',
        manual: 'Manual',
        autoMatched: 'Auto-matched',
        suggestionHint:
          'Suggestions are based on specs, brand, and model signals. Manual selections still win, and saved links sync both ways.',
        general: 'General',
        inStock: 'In stock',
        outOfStock: 'Out of stock',
      },
      compatibleProducts: {
        title: 'Compatible products',
        hint: 'Choose the products that this spare part fits.',
        searchPlaceholder: 'Search products',
        emptyText: 'No products have been added yet.',
        noMatchesText: 'No products match your search.',
        unclassified: 'Unclassified',
      },
      dataTable: {
        searchPlaceholder: 'Search...',
        emptyText: 'No data found.',
        resultsCount: '{{count}} result(s)',
        updatingResults: 'Updating table results',
        updating: 'Updating...',
        tryAdjustingSearch: 'Try adjusting your search query.',
        createNewItem: 'Create a new item to get started.',
        clearSearch: 'Clear search',
        pageOf: 'Page {{page}} of {{total}}',
        rows: 'Rows:',
        prev: 'Prev',
        next: 'Next',
      },
      toolbar: {
        selectedCount: '{{count}} selected',
        saveAll: 'Save All',
        deleteSelected: 'Delete Selected',
        pasteJson: 'Paste JSON',
        saving: 'Saving...',
        deleting: 'Deleting...',
        clear: 'Clear',
        exportCsv: 'Export CSV',
        exportingCsv: 'Exporting CSV...',
        exportJson: 'Export JSON',
        exportingJson: 'Exporting JSON...',
        importCsvJson: 'Import CSV/JSON',
        importing: 'Importing...',
      },
      confirmModal: {
        title: 'Confirm action',
        description: 'Are you sure you want to continue?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        processing: 'Processing...',
      },
      feedback: {
        loadingTitle: 'Loading...',
        loadingDescription: 'Please wait while data is fetched.',
        errorTitle: 'Something went wrong',
        errorDescription: 'An unexpected error occurred.',
        tryAgain: 'Try again',
        emptyTitle: 'No data found',
        emptyDescription: 'There are no records to display.',
      },
      tour: {
        start: 'Start tour',
        noGuide: 'No guide available',
        badge: 'Tour',
        skip: 'Skip tour',
        back: 'Back',
        next: 'Next',
        finish: 'Finish',
        close: 'Close tour',
        stepOf: 'Step {{step}} of {{total}}',
      },
    },
    header: {
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      nav: {
        home: 'Home',
        about: 'About Us',
        services: 'Services',
        promotions: 'Promotions',
        products: 'Machines',
        spareParts: 'Spare Parts',
        contact: 'Contact',
      },
      session: 'Session...',
      menu: 'Menu',
      cart: {
        title: 'Shopping Cart',
        items: 'items',
        item: 'item',
        qty: 'Qty',
        total: 'Total',
        emptyTitle: 'Your cart is empty',
        emptyText: 'Add machines to see them here.',
        viewCart: 'View Cart',
        continue: 'Continue',
        requestHistory: 'Request History',
      },
      account: {
        profileSettings: 'Profile Settings',
        requestHistory: 'Request History',
        logout: 'Logout',
      },
      auth: {
        login: 'Login',
        signup: 'Sign Up',
      },
    },
    titlebar: {
      routes: {
        about: 'About Us',
        services: 'Services',
        promotions: 'Promotions',
        contact: 'Contact',
        privacy: 'Privacy',
        terms: 'Terms',
        legal: 'Legal',
        products: 'Machines',
        productCategories: 'Machine Categories',
        productDetails: 'Machine Details',
        spareParts: 'Spare Parts',
        sparePartDetails: 'Spare Part Details',
        account: 'My Account',
        cart: 'Cart',
        login: 'Login',
        signup: 'Sign Up',
        forgotPassword: 'Forgot Password',
        resetPassword: 'Reset Password',
        notFound: 'Page Not Found',
      },
    },
    footer: {
      logoAlt: 'ETC Company',
      brandText:
        'At ETC, we help you save on new forklifts, stackers, and quality pallet trucks.',
      contactTeam: 'Contact Our Team',
      phone: 'Phone',
      email: 'E-mail',
      headquarters: 'Head Office',
      headquartersAddress: 'Arbi Zarrouk Avenue 8000 Nabeul - Tunisie',
      showroom: 'Showroom',
      showroomAddress: 'On GP1, 2 Zroud River, 2014 Megrine El Riadh 8000 Nabeul - Tunisia',
      workHours: 'Working Hours',
      weekdayHours: 'Monday to Friday 8:00 - 18:00',
      saturdayHours: 'Saturday 8:00 - 12:00',
      copyrights: 'Copyrights',
      rights: 'All rights reserved by ETC.',
      developedBy: 'Developed by Vizora',
      facebook: 'Facebook',
      instagram: 'Instagram',
      simpleRights: 'ETC Company. All rights reserved.',
      simpleMadeBy: 'Made by Vizora',
    },
    legalPages: {
      privacy: {
        path: '/privacy',
        metaTitle: 'Privacy Policy',
        metaDescription:
          'Read how ETC Company collects, uses, discloses, retains, transfers, and protects personal data when You use the Service.',
        eyebrow: 'Privacy',
        title: 'Privacy Policy',
        description:
          'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service.',
        lastUpdatedLabel: 'Last updated',
        lastUpdated: 'May 03, 2026',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        contactTitle: 'Contact us',
        nextTitle: 'Privacy questions?',
        nextDescription:
          'If You have any questions about this Privacy Policy, You can contact ETC Company by email or phone.',
        contactLink: 'Contact us',
        sections: PRIVACY_POLICY_SECTIONS,
      },
      terms: {
        path: '/terms',
        metaTitle: 'Terms of Use',
        metaDescription:
          'Read the ETC Company website terms covering accounts, quotes, machine information, orders, and acceptable use.',
        eyebrow: 'Terms',
        title: 'Terms of Use',
        description:
          'These terms govern access to the ETC Company website and the use of online features such as machine browsing, account areas, carts, and quote requests.',
        lastUpdatedLabel: 'Last updated',
        lastUpdated: 'May 3, 2026',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        contactTitle: 'Commercial contact',
        nextTitle: 'Questions about a quote?',
        nextDescription:
          'Commercial terms for equipment, spare parts, delivery, warranty, and payment may be confirmed in a formal quote, invoice, or written agreement.',
        contactLink: 'Talk to sales',
        sections: [
          {
            title: 'Use of the website',
            paragraphs: [
              'You agree to use the website for lawful business and informational purposes. You must not interfere with website security, attempt unauthorized access, submit misleading information, or use the website in a way that may disrupt service for others.',
              'ETC Company may update, suspend, or restrict access to parts of the website when needed for maintenance, security, or business reasons.',
            ],
          },
          {
            title: 'Accounts and requests',
            paragraphs: [
              'Some features may require an account or contact details. You are responsible for keeping your login information confidential and for the accuracy of information submitted through your account or quote requests.',
              'ETC Company may review, accept, reject, archive, or follow up on quote requests according to machine availability and commercial requirements.',
            ],
          },
          {
            title: 'Machine information',
            paragraphs: [
              'Machine descriptions, specifications, images, compatibility details, prices, promotions, and availability are provided for general reference. They may change without notice and should be confirmed before any purchase or operational decision.',
              'Images and technical information may differ from the final machine configuration, accessories, stock condition, or supplier updates.',
            ],
          },
          {
            title: 'Quotes, orders, and payments',
            paragraphs: [
              'Submitting a cart, contact form, or quote request does not create a binding sale by itself. A transaction is confirmed only when ETC Company issues and accepts the applicable commercial document or written agreement.',
              'Payment, delivery, installation, warranty, and after-sales conditions may vary by machine, stock status, customer profile, and destination.',
            ],
          },
          {
            title: 'Intellectual property',
            paragraphs: [
              'The website, brand elements, text, images, machine presentation, interface, and other content are owned by ETC Company or used with permission from suppliers and partners.',
              'You may not copy, reproduce, modify, scrape, distribute, or reuse website content for commercial purposes without prior written permission.',
            ],
          },
          {
            title: 'Liability',
            paragraphs: [
              'ETC Company works to keep website information accurate and available, but does not guarantee that the website will always be uninterrupted, error-free, or fully up to date.',
              'To the fullest extent permitted by applicable law, ETC Company is not liable for indirect losses, loss of business, or decisions made solely from unconfirmed website information.',
            ],
          },
        ],
      },
      legal: {
        path: '/legal',
        metaTitle: 'Legal Notice',
        metaDescription:
          'Legal notice for ETC Company, including publisher contact details, site responsibility, and content ownership.',
        eyebrow: 'Legal',
        title: 'Legal Notice',
        description:
          'This notice identifies the publisher of the ETC Company website and summarizes legal information related to site content and contact details.',
        lastUpdatedLabel: 'Last updated',
        lastUpdated: 'May 3, 2026',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        contactTitle: 'Company contact',
        nextTitle: 'Need official details?',
        nextDescription:
          'For company registration details, supplier documentation, or administrative requests, contact ETC Company directly.',
        contactLink: 'Request details',
        sections: [
          {
            title: 'Website publisher',
            paragraphs: [
              'This website is published by ETC Company, also known as Essid Trading Company, a Tunisian company serving professional customers with warehouse equipment, spare parts, and operational support.',
            ],
            items: [
              'Headquarters: Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
              'Showroom: Sur GP1, 2 Oued Zroud, 2014 Mgrine El Riadh 8000 Nabeul - Tunisie',
              'Email: sales@etc.tn',
              'Phone: +216 26 363 025 / +216 72 363 000',
            ],
          },
          {
            title: 'Publication responsibility',
            paragraphs: [
              'The website is managed by ETC Company for presentation of its machines, services, contact channels, quote requests, and customer account features.',
              'Requests about publication, correction, removal, or administrative details can be sent to the contact email listed on this page.',
            ],
          },
          {
            title: 'Hosting and technical operation',
            paragraphs: [
              'The website is hosted and operated using the technical infrastructure selected by ETC Company and its technical providers.',
              'For security, maintenance, and continuity reasons, hosting or technical providers may change without prior notice.',
            ],
          },
          {
            title: 'Content ownership',
            paragraphs: [
              'Unless otherwise stated, all website content, including text, layout, machine presentation, images, graphics, logos, and interface elements, is owned by ETC Company or used with authorization.',
              'Supplier names, machine names, trademarks, and logos remain the property of their respective owners.',
            ],
          },
          {
            title: 'Accuracy of information',
            paragraphs: [
              'ETC Company makes reasonable efforts to keep the information on this website current. Machine details, stock availability, prices, promotions, and technical information remain subject to confirmation.',
              'Website content does not replace formal commercial documents, supplier documentation, warranty terms, invoices, or signed agreements.',
            ],
          },
          {
            title: 'Applicable rules',
            paragraphs: [
              'Use of the website and commercial relations with ETC Company are subject to the applicable laws and the written agreements or commercial documents issued for each transaction.',
              'Any unresolved dispute may be handled by the competent authorities or courts according to the applicable rules.',
            ],
          },
        ],
      },
    },
    home: {
      hero: {
        eyebrow: 'Machines',
        titleLine1: 'Our Machine',
        titleLine2: 'Range',
        prevMedia: 'Previous card',
        nextMedia: 'Next card',
        completeCollection: 'Complete collection',
        fuelElectric: 'Electric',
        fuelDiesel: 'Diesel',
        fuelLpg: 'LPG',
        leadTimeSingle: '{{count}} days',
        leadTimeRange: '{{min}}-{{max}} days',
        noSlidesAvailable: 'No slides available',
      },
      services: {
        eyebrow: 'Services',
        titleLine1: 'We Provide What Is ',
        titleLine2: 'Needed For Our Clients',
        titleLine3: '',
        sideNote: 'Precision engineered solutions for modern digital infrastructure.',
        discoverMore: 'Discover More',
      },
      cta: {
        eyebrow: 'Industrial Intelligence',
        titleLine1: 'Contact Us',
        titleLine2: 'Now',
        description:
          'Whether you need details on our latest models, financing, or spare parts, our experts are ready to help.',
        button: 'Contact us',
        imageAlt: 'ETC equipment',
      },
      catalog: {
        eyebrow: 'Catalog',
        title: 'Built For Real Warehouse Work',
        viewAll: 'View Full Catalog',
        explore: 'Explore',
      },
      showcase: {
        prevSlide: 'Previous slide',
        nextSlide: 'Next slide',
      },
      imageParallax: {
        eyebrow: 'Field View',
        titleLine1: 'Built For Harsh',
        titleLine2: 'Industrial Reality',
        description:
          'High-performance handling systems engineered for demanding environments and long-term reliability.',
      },
      videoBanner: {
        eyebrow: 'Field Operations',
        titleLine1: 'Powering Productivity',
        titleLine2: 'On Every Terrain',
        description:
          'High-performance machinery, dependable support, and delivery speed built for modern industrial operations.',
      },
      promotions: {
        bannerEyebrow: 'Promotions',
        bannerTitle: 'See the latest featured offers',
        bannerDescription: 'Check active promotions at a glance while they are still live.',
        bannerButton: 'Browse promotions',
        eyebrow: 'Offers and Promos',
        titleLine1: 'Limited-Time',
        titleLine2: 'Offers',
        description:
          'Active offers are highlighted here while they last, so you can act quickly on the most relevant machines and spare parts.',
        productLabel: 'Machine',
        sparePartLabel: 'Spare Part',
        quoteOnRequest: 'Quote on request',
        tailoredOffer: 'Available while active',
        viewOffer: 'View offer',
        emptyTitle: 'No active offers right now',
        emptyDescription:
          'Mark a machine or spare part as promoted in the admin panel and it will appear here while the offer is active.',
      },
    },
    servicesPage: {
      items: [
        {
          description:
            "We do not just sell a brand; we sell a solution for specific weight and terrain requirements. Our inventory is curated to balance durability with affordability.\n\nThe AXOR Edge: By developing our private label, AXOR by Essid, we have cut out the \"brand tax\" of traditional imports. You get the same lift capacity and hydraulic reliability without paying for a logo.\n\nBrand Versatility: We maintain active partnerships with global leaders like Niuli and JAC. This allows us to provide a tiered catalog - from manual pallet trucks for light warehousing to heavy-duty internal combustion forklifts for industrial use - at price points that keep your capital liquid.",
        },
        {
          description:
            "In the heavy machinery world, the sale is just the beginning. A machine that is not moving is a liability.\n\nTechnical Agility: Our service structure is built to bypass corporate bureaucracy. When a hydraulic seal fails or an engine throws a code, our decision-making is localized and fast.\n\nParts Infrastructure: We do not just \"order\" parts when you call; we maintain a strategic stock of high-wear components. Our goal is to ensure that \"After-Sales\" means a technician is on-site with the correct part, rather than a customer waiting on a six-week shipping manifest.",
        },
        {
          description:
            "Preventive maintenance protects uptime before a breakdown appears. We structure each intervention around your operating rhythm to avoid disruption.\n\nScheduled inspections: We check lifting systems, hydraulic circuits, safety points, and battery/charging behavior to detect wear early.\n\nWear-part replacement: High-wear components are replaced proactively with compatible parts so your equipment keeps running with stable performance.\n\nCorrective interventions: When an issue appears, our technicians diagnose quickly, apply the right fix, and return the unit to service with clear maintenance notes for your team.",
        },
      ],
    },
    productsPage: {
      loading: 'Loading machines...',
      hero: {
        eyebrow: 'Machine Catalog',
        title: 'Discover Equipment Built For Daily Throughput',
        description:
          'Compare manual and electric stackers in one structured catalog. Filter by category and search quickly to find the right fit for your operation.',
        totalProducts: 'Total Machines',
        availableInCatalog: 'Available in catalog',
        categories: 'Categories',
        structuredFiltering: 'Structured for fast filtering',
        focus: 'Focus',
        warehouseReady: 'Warehouse Ready',
        reliabilityPerformance: 'Reliability and practical performance',
      },
      categoriesHero: {
        titleLine1: 'Find Your Next',
        titleLine2: 'Machine by Category',
        description:
          'Browse every machine family in one place and move straight to the machines that match your work, specs, and budget.',
      },
      filters: {
        eyebrow: 'Browse',
        title: 'Filter Machines',
        showing: 'Showing',
        of: 'of',
        products: 'machines',
        search: 'Search',
        searchPlaceholder: 'Name or description',
        category: 'Category',
      },
      grid: {
        noMatchesTitle: 'No machines match your filters',
        noMatchesText: 'Try a different search term or category.',
        viewDetails: 'View Details',
      },
      support: {
        eyebrow: 'Need Guidance',
        title: 'Get Help Choosing The Right Equipment',
        description:
          'Tell us your lifting requirements and our team can recommend the best configuration.',
        contactSales: 'Contact Sales',
      },
    },
    sparePartsPage: {
      loading: 'Loading spare parts...',
      hero: {
        eyebrow: 'Spare Parts',
        title: 'Keep Your Fleet Running Without Downtime',
        titleLine1: 'Keep Your Fleet Running',
        titleLine2: 'Without Downtime',
        description:
          'Browse replacement components built for compatibility and quick swap-outs. Filter by category and search parts faster.',
        totalParts: 'Total Parts',
        readyInCatalog: 'Ready in catalog',
        categories: 'Categories',
        organizedByUseCase: 'Organized by use case',
        priority: 'Priority',
        continuity: 'Continuity',
        minimalInterruption: 'Designed for minimal interruption',
      },
      filters: {
        eyebrow: 'Browse',
        title: 'Filter Spare Parts',
        showing: 'Showing',
        of: 'of',
        parts: 'spare parts',
        search: 'Search',
        searchPlaceholder: 'Name or description',
        category: 'Category',
      },
      grid: {
        addedToCart: 'added to cart.',
        noMatchesTitle: 'No spare parts match your filters',
        noMatchesText: 'Try a different search term or category.',
        addToCart: 'Add to Cart',
        viewDetails: 'View Details',
      },
      support: {
        eyebrow: 'Fast Support',
        title: "Can't Find The Right Spare Part?",
        description:
          "Share your equipment details and we'll help you match the compatible replacement quickly.",
        requestAssistance: 'Request Assistance',
      },
    },
    cartPage: {
      eyebrow: 'Cart',
      title: 'Your Shopping Cart',
      inCart: 'in your cart',
      clearCart: 'Clear Cart',
      emptyTitle: 'Your cart is empty',
      emptyText: 'Add machines from the catalog to start building your order.',
      browseProducts: 'Browse Machines',
      qty: 'Qty',
      removeItem: 'Remove item',
      summary: 'Summary',
      requestOverview: 'Request overview',
      product: 'Machine',
      action: 'Action',
      items: 'Items',
      total: 'Total',
      lineTotal: 'Line total',
      pricesHiddenNote: 'Prices are hidden for now. Request a quote to receive pricing.',
      heroSubtitle: 'Review your items, add a note, and send a polished quote request that matches the rest of the site.',
      noteLabel: 'Note for the quote',
      notePlaceholder: 'Add any delivery, stock, or order notes...',
      requestQuote: 'Request Quote',
      requestingQuote: 'Sending request...',
      loginToRequest: 'Sign in to submit the quote request.',
      requestSuccess: 'Quote request {{requestNumber}} sent successfully.',
      requestFailed: 'Failed to submit quote request',
      requestHistory: 'Request History',
      removeItemConfirmTitle: 'Remove item?',
      removeItemDescriptionNamed: 'Are you sure you want to remove {{name}} from your cart?',
      removeItemDescriptionGeneric: 'Are you sure you want to remove this item from your cart?',
      pendingRequest: 'Pending request',
      pending: 'Pending',
      pendingNotice: 'Your cart is locked while this request is being reviewed.',
      pendingRequestEmptyText: 'Your request is pending review, so the cart is empty for now.',
      requestMovedToHistory: 'Your request has been moved to history.',
      continueShopping: 'Continue Shopping',
    },
      accountPage: {
        title: 'Profile Settings',
        subtitle: 'Update your profile information shown in your website account.',
        accountSettings: 'Account Settings',
        accountDescription: 'Manage your public account details and profile avatar.',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone',
        phonePlaceholder: '+216 00 000 000',
        email: 'Email',
        accountType: 'Account Type',
        customer: 'Customer',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      discard: 'Discard',
      continueShopping: 'Continue Shopping',
      logout: 'Log Out',
      uploading: 'Uploading...',
      upload: 'Upload',
      uploadHint: 'Upload a photo to personalize your account.',
        removePhoto: 'Remove Photo',
        profilePictureUpdated: 'Profile picture updated.',
        saveSuccess: 'Profile settings saved.',
        saveFailed: 'Failed to save profile settings.',
        updatePictureFailed: 'Failed to update profile picture.',
        requestHistoryEyebrow: 'Account',
        requestHistoryTitle: 'Request History',
        requestHistorySubtitle: 'Track quote requests, their status, and the final request for quote.',
        requestHistoryLoadFailed: 'Failed to load request history.',
        pendingRequest: 'Pending request',
        requestDetails: 'Request details',
        requestDetailsSubtitle: 'Check the current status, totals, and line items for this request.',
        previewPdf: 'Preview PDF',
        previewPdfLoadingButton: 'Preparing preview...',
        previewPdfTitle: 'PDF preview',
        previewPdfEyebrow: 'PDF preview',
        previewPdfSubtitle: 'Review the generated request for quote without leaving the page.',
        previewPdfLoading: 'Loading PDF preview...',
        previewPdfEmpty: 'No PDF available.',
        previewPdfFailed: 'Unable to open the PDF preview.',
        previewPdfFrame: 'PDF preview',
        closePreview: 'Close',
        backToHistory: 'Back to history',
        backToAccount: 'Back to account',
        requestSummary: 'Request summary',
        contact: 'Contact',
        requestItems: 'Items',
        updatedAt: 'Updated',
        quotePrice: 'Quote price',
        lineTotal: 'Line total',
        summary: 'Summary',
        quotedSubtotal: 'Quoted subtotal',
        interestPercent: 'Interest %',
        interestAmount: 'Interest amount',
        tvaPercent: 'TVA %',
        tvaAmount: 'TVA amount',
        finalTotal: 'Final total',
        notes: 'Notes',
        customerNote: 'Customer note',
        adminNote: 'Admin note',
        rejectionReason: 'Rejection reason',
        timeline: 'Timeline',
        currentStatus: 'Current status',
        timelineSubmitted: 'Submitted',
        timelineSubmittedDetail: 'Request created',
        timelineReviewing: 'Under review',
        timelineReviewingDetail: 'Admin is preparing the quote',
        timelineQuoted: 'Quoted',
        timelineQuotedDetail: 'Price has been calculated',
        timelineClosed: 'Closed',
        timelineClosedDetail: 'Final review',
        timelineSent: 'Sent',
        timelineSentDetail: 'Quote sent',
        timelineDeclined: 'Declined',
        timelineDeclinedDetail: 'Request declined',
        timelineArchived: 'Archived',
        timelineArchivedDetail: 'Archived',
        backToCart: 'Back to cart',
        viewRequestDetails: 'View details',
        loadingRequests: 'Loading requests...',
        noRequestsTitle: 'No requests yet',
        noRequestsText: 'Your submitted quote requests will appear here once you request a quote.',
        pendingRequestBanner: 'Your latest request is still pending review and remains available in the cart for now.',
      },
    auth: {
      login: {
        title: 'Welcome Back',
        subtitle: 'Sign in to access your account and orders.',
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        forgotPassword: 'Forgot password?',
        failed: 'Failed to sign in.',
        invalidCredentials: 'Invalid credentials.',
        emailAndPasswordRequired: 'Email and password are required.',
        emailInvalid: 'Please enter a valid email address.',
        passwordRequired: 'Password is required.',
        tooManyRequests: 'Too many login attempts. Please try again later.',
        signingIn: 'Signing In...',
        signIn: 'Sign In',
        errorTitle: 'Sign-in failed',
        errorDetail: 'We could not sign you in. Double-check your credentials and try again.',
        noAccount: 'No account yet?',
        createOne: 'Create one',
      },
      signup: {
        title: 'Create Account',
        subtitle: 'Set up your profile in under a minute.',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone',
        phonePlaceholder: '+216 00 000 000',
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        password: 'Password',
        passwordPlaceholder: 'At least 6 characters',
        firstNameRequired: 'First name is required.',
        lastNameRequired: 'Last name is required.',
        phoneRequired: 'Phone is required.',
        phoneInvalid: 'Please enter a valid phone number.',
        emailRequired: 'Email is required.',
        emailInvalid: 'Please enter a valid email address.',
        passwordRequired: 'Password is required.',
        passwordLength: 'Password must be at least 6 characters.',
        failed: 'Failed to create account.',
        emailAndPasswordRequired: 'Email and password are required.',
        userAlreadyExists: 'An account with this email already exists.',
        tooManyRequests: 'Too many signup attempts. Please try again later.',
        creatingAccount: 'Creating Account...',
        createAccount: 'Create Account',
        errorTitle: 'Account creation failed',
        errorDetail: 'We could not create your account right now. Check the highlighted fields and try again.',
        alreadyRegistered: 'Already registered?',
        signIn: 'Sign in',
        publicSignup: 'Public signup',
        newAccountDescription: '{{fullName}} ({{email}}) - Signed up on website',
        successTitle: 'Account created',
        successDetail: 'Your account is ready. You can now sign in to manage your orders.',
      },
      forgot: {
        title: 'Forgot Password',
        subtitle: 'Enter your email and we will send you a reset link.',
        email: 'Email',
        emailPlaceholder: 'you@example.com',
        emailRequired: 'Email is required.',
        emailInvalid: 'Please enter a valid email address.',
        requestFailed: 'Failed to request password reset',
        tooManyRequests: 'Too many password reset requests. Please try again later.',
        successMessage: 'If this email exists, a reset link has been sent.',
        successTitle: 'Reset link sent',
        successDetail: 'If this email exists in our system, a reset link has been sent.',
        errorTitle: 'Could not send the link',
        errorDetail: 'We could not process your request right now. Double-check your email and try again.',
        sending: 'Sending...',
        sendResetLink: 'Send Reset Link',
        rememberedPassword: 'Remembered your password?',
        backToLogin: 'Back to login',
      },
      reset: {
        title: 'Reset Password',
        subtitle: 'Choose a new password for your account.',
        verifying: 'Verifying reset link...',
        invalidLink: 'This reset link is invalid or expired.',
        invalidToken: 'Invalid or expired token.',
        passwordRequired: 'Password is required.',
        passwordLength: 'Password must be at least 6 characters.',
        passwordMismatch: 'Passwords do not match.',
        confirmPasswordRequired: 'Please confirm your new password.',
        failed: 'Failed to reset password',
        tooManyRequests: 'Too many password reset attempts. Please try again later.',
        success: 'Password reset successful. You can now log in.',
        successTitle: 'Password updated',
        successDetail: 'Your password has been changed successfully. You can now sign in with your new password.',
        errorTitle: 'Could not reset password',
        errorDetail: 'We could not reset your password right now. Check the highlighted fields and try again.',
        newPassword: 'New Password',
        newPasswordPlaceholder: 'Enter new password',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Confirm new password',
        resetting: 'Resetting...',
        resetPassword: 'Reset Password',
        backToLogin: 'Back to login',
      },
      turnstile: {
        helper: 'This verification helps us block bots and abusive traffic.',
        error: 'Verification failed. Please refresh the challenge.',
        required: 'Please complete the verification challenge.',
        retry: 'Verification failed. Please try again.',
        unavailable: 'Verification service unavailable. Please try again.',
      },
    },
    productDetails: {
      loading: 'Loading...',
      loadFailed: 'Failed to load machine.',
      closeGallery: 'Close gallery',
      openImageGallery: 'Open image gallery',
      imageAlt: 'Machine image',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      price: 'Price',
      priceHint: 'Includes standard configuration',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      onlyLeftInStock: 'Only {{count}} machines left in stock',
      keyDetails: 'Key details',
      specsIncluded: 'Specs included',
      maxCapacity: 'Max Capacity',
      powerSource: 'Power Source',
      addToCart: 'Add to Cart',
      addedToCart: 'added to cart.',
      requestQuote: 'Request Quote',
      compatibleSpareParts: 'Compatible spare parts',
      compatibleSparePartsDescription:
        'These parts are linked to this machine and are the best place to start when you need replacement or maintenance items.',
      safetyTitle: 'Safety',
      safetyDescription: 'Inspected and ready for safe operation.',
      safetyWarrantyTitle: 'Safety & Warranty',
      warrantyTitle: 'Warranty',
      warrantyDescription: 'Coverage details available on request.',
      inventory: 'Stock',
      category: 'Category',
      type: 'Type',
      showroomAvailability: 'Availability',
      showroomLabel: 'Showroom',
      available: 'Available',
      unavailable: 'Unavailable',
      technicalSpecifications: 'Technical Specifications',
      specificationColumn: 'Spécification',
      valueColumn: 'Measurement / Value',
      noTechnicalSpecifications: 'No technical specifications available.',
      specsSubtitle: 'Comprehensive mechanical and operational data for this machine.',
      specsDisclaimer:
        'All measurements provided are standard factory specifications. Performance values are based on nominal operating conditions. Optional attachments may alter rated capacity and dimensions.',
      specsGroupPerformance: 'Performance',
      specsGroupDimensions: 'Dimensions',
      specsGroupWheelsChassis: 'Wheels & Chassis',
      specsGroupWeight: 'Weight',
      noImage: 'No image',
      visualComingSoon: 'Visual coming soon',
    },
    sparePartDetails: {
      loading: 'Loading...',
      loadFailed: 'Failed to load spare part.',
      price: 'Price',
      stock: 'Stock',
      addToCart: 'Add to Cart',
      category: 'Category',
      stockStatus: 'Stock Status',
      inStockLabel: 'Available now',
      onlyLeftInStock: 'Only {{count}} parts left in stock',
      outOfStock: 'Out of stock',
      reference: 'Reference',
      notAvailable: 'Not available',
      closeGallery: 'Close gallery',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      imageAlt: 'Spare part image',
      openImageGallery: 'Open image gallery',
      zoomImage: 'Zoom image',
      noImagesTitle: 'No visuals available',
      noImagesDescription: 'This spare part is currently listed without uploaded images.',
      keyDetails: 'Key details',
      quickOverview: 'Quick overview',
      purchaseSupportTitle: 'Purchase support',
      qualityCheckTitle: 'Quality Check',
      qualityCheckDescription: 'Selected parts verified for fit, function, and dependable daily use.',
      orderSupportTitle: 'Order Support',
      orderSupportDescription: 'Need help confirming compatibility? Our team can guide you before checkout.',
      partInformation: 'Part Information',
      partInformationSubtitle: 'A quick technical and commercial overview for this spare part.',
      specificationColumn: 'Spécification',
      valueColumn: 'Measurement / Value',
      partDetailsGroup: 'Part details',
      partInformationDisclaimer: 'Availability and pricing may change depending on stock movement and supplier updates.',
    },
    aboutPage: {
      hero: {
        eyebrow: 'About ETC Company',
        title: 'Trusted Warehouse Equipment Partner in Tunisia',
        titleLine1: 'Trusted Warehouse',
        titleLine2: 'Equipment Partner in Tunisia',
        description:
          'Essid Trading Company (ETC) is a prominent Tunisian enterprise dedicated to excellence in international trade and distribution.',
        description2:
          'With a focus on high-quality agricultural equipment, industrial solutions, and specialized machines, ETC has established itself as a reliable partner in the Tunisian market.\n\nDriven by a commitment to modernization and customer satisfaction, the company continues to expand its reach, most recently through the inauguration of its third showroom in Hammam Sousse, ensuring direct access to its diverse portfolio of premium services and machines.',
        highlightsTitle: 'Key Highlights of ETC Company',
        highlightsTitleLine1: 'Key Highlights of',
        highlightsTitleLine2: 'ETC Company',
        highlights: [
          {
            title: 'Industry Leadership',
            detail: 'Specializing in agricultural machinery, industrial equipment, and trade studies.',
          },
          {
            title: 'Expanding Footprint',
            detail: 'Strategic presence across Tunisia, including dedicated showrooms to better serve local and regional clients.',
          },
          {
            title: 'Quality & Innovation',
            detail: 'A reputation built on sourcing top-tier machines and implementing modern digital solutions for business management.',
          },
        ],
        metrics: {
          experienceLabel: 'Years of Experience',
          experienceValue: '15+',
          clientsLabel: 'Estimated Clients',
          clientsValue: '1,000+',
        },
        stats: [
          { label: 'Operating Focus', value: 'B2B Warehousing', detail: 'Built for daily operational realities' },
          { label: 'Market Presence', value: 'Tunisia', detail: 'Serving local industrial and logistics demand' },
          { label: 'Commitment', value: 'Long-Term Support', detail: 'From purchase to maintenance lifecycle' },
        ],
      },
      offer: {
        eyebrow: 'What We Offer',
        title: 'End-To-End Equipment Support',
        titleLine1: 'End-To-End',
        titleLine2: 'Equipment Support',
        items: [
          {
            title: 'Material Handling Equipment',
            description:
              'Manual and electric stackers selected for reliability, operator comfort, and long-term usage in demanding environments.',
          },
          {
            title: 'Spare Parts Availability',
            description:
              'A dedicated spare-part catalog to reduce downtime and keep your fleet available for continuous operations.',
          },
          {
            title: 'Preventive Maintenance Service',
            description:
              'Scheduled inspections, wear-part replacement, and corrective interventions to keep your equipment reliable and reduce unplanned downtime.',
          },
        ],
      },
      videoBanner: {
        eyebrow: 'Operations',
        titleLine1: 'Built For',
        titleLine2: 'Daily Reliability',
        description:
          'From equipment selection to spare parts, ETC supports operational continuity for warehouses and industrial teams.',
      },
      reputation: {
        eyebrow: 'Réputation en Tunisie',
        title: 'Known for reliability, practical guidance, and lasting service',
        titleLine1: 'Reliable Guidance',
        titleLine2: 'and Lasting Service',
        cards: [
          {
            title: 'Operational Trust',
            description:
              'Businesses across Tunisia rely on ETC Company for equipment that performs consistently in daily warehouse cycles.',
          },
          {
            title: 'Réputation de service',
            description:
              'Our team is recognized for clear recommendations, fast support flow, and strong attention to customer continuity.',
          },
          {
            title: 'Machine Confidence',
            description:
              'We prioritize dependable stackers and compatible spare parts that help customers avoid unnecessary downtime.',
          },
          {
            title: 'Long-Term Partnership',
            description:
              'ETC Company aims to be a long-term operations partner, not only a supplier, through sustained post-purchase support.',
          },
        ],
      },
      team: {
        eyebrow: 'Our Team',
        title: 'People Behind ETC Company',
        titleLine1: 'People Behind',
        titleLine2: 'ETC Company',
        description:
          'A practical team focused on helping businesses choose the right equipment and maintain uptime.',
        featuredLabel: 'Featured member',
        featuredHint: 'Tap a portrait below to change the selection.',
        rosterTitle: 'Team roster',
        rosterHint: 'Tap a face to spotlight a member.',
        membersLabel: 'Members',
        selectedBadge: 'Selected',
        memberBioLabel: 'About this member',
      },
      shortcuts: {
        eyebrow: 'Shortcuts',
        title: 'Quick Access To Main Pages',
        titleLine1: 'Quick Access To',
        titleLine2: 'Main Pages',
        openPage: 'Open Page',
          items: [
            {
              title: 'Machines',
              description:
                'Browse the full catalog with filtering and specifications.',
            },
            {
              title: 'Spare Parts',
              description: 'Find compatible replacement parts to keep your operations running.',
            },
            {
              title: 'Contact',
              description: 'Reach ETC Company for support, quotes, and technical guidance.',
            },
            {
              title: 'Services',
              description: 'Explore our service coverage for equipment support, parts, and after-sales guidance.',
            },
          ],
      },
    },
    contactPage: {
      hero: {
        eyebrow: 'Contact ETC',
        title: "Let's Talk About Your Next Equipment Need",
        description:
          'Reach our team for machine recommendations, spare-part support, pricing details, and availability.',
        stats: [
          { label: 'Response Target', value: 'Same Day', detail: 'Fast initial support' },
          { label: 'Request Types', value: 'Machines + Parts', detail: 'Commercial and technical' },
          { label: 'Support Style', value: 'Practical', detail: 'Clear recommendations' },
        ],
      },
      channels: {
        eyebrow: 'Channels',
        titleLine1: 'Inside Our',
        titleLine2: 'Showrooms',
        description:
          'Each showroom is designed to help you move quickly from question to solution. Visit the location nearest you, meet our team, explore the equipment in person, and get clear guidance on machines, spare parts, and service support for your operation.',
        showroomTitles: {
          nabeul: 'Nabeul Store',
          tunis: 'Tunis Showroom',
          sousse: 'Sousse Showroom',
        },
        items: [
          {
            title: 'Email',
            value: 'sales@etc-company.com',
            hint: 'Best for quote requests and technical requirements',
          },
          {
            title: 'Phone',
            value: '+216 00 000 000',
            hint: 'Direct coordination for urgent needs',
          },
          {
            title: 'Location',
            value: 'Tunis, Tunisia',
            hint: 'Warehouse equipment and spare-part support',
          },
          {
            title: 'Working Hours',
            value: 'Mon - Fri, 08:00 - 18:00',
            hint: 'Same-day response during business hours',
          },
        ],
        loading: 'Loading...',
        openMap: 'Open map',
        mapUnavailableTitle: 'Map preview unavailable',
        mapUnavailableDescription: 'Google Maps is blocked in this browser. Use the direct map link instead.',
      },
      form: {
        eyebrow: 'Inquiry Form',
        title: 'Send Your Request',
        description:
          "Share your needs and we'll respond with recommended machines, spare parts, and next steps.",
        fullName: 'Full Name',
        fullNamePlaceholder: 'Your name',
        email: 'Email',
        emailPlaceholder: 'you@company.com',
        subject: 'Subject',
        subjectPlaceholder: 'What can we help you with?',
        phone: 'Phone',
        phonePlaceholder: '+216 ...',
        inquiryType: 'Inquiry Type',
        inquiryTypePlaceholder: 'Select an inquiry type',
        options: {
          products: 'Machines',
          spareParts: 'Spare Parts',
          afterSales: 'After-Sales Support',
          other: 'Other',
        },
        message: 'Message',
        messagePlaceholder: 'Tell us what you need...',
        note: 'We will reply from sales as soon as possible.',
        requiredNote: 'Fields marked with * are required.',
        sending: 'Sending...',
        sendMessage: 'Send Message',
        successTitle: 'Message sent',
        successDetail: 'Thank you. Our sales team will review your request and get back to you shortly.',
        success: 'Your message has been sent. We will get back to you soon.',
        errors: {
        failed: 'We could not send your message right now.',
        tooManyRequests: 'Too many contact requests. Please try again later.',
        required: 'Please fill in the required fields.',
        nameRequired: 'Please enter your name.',
        emailRequired: 'Please enter your email address.',
        subjectRequired: 'Please enter a subject.',
        phoneRequired: 'Please enter your phone number.',
          inquiryTypeRequired: 'Please select an inquiry type.',
          messageRequired: 'Please enter your message.',
          invalidEmail: 'Please enter a valid email address.',
        },
      },
      faq: {
        eyebrow: 'Need Help?',
        titleLine1: 'Frequently Asked',
        titleLine2: 'Questions',
        description: 'A few quick answers to help you reach the right team and move faster.',
        tipTitle: 'Fastest route',
        tipDescription:
          'Use the form for quotes, machine matching, spare parts, or after-sales support. We route messages to the right team.',
        tipNote: 'If your request is urgent, include the machine name, model, and any reference numbers.',
        items: [
          {
            question: 'What should I include in my message?',
            answer:
              'Share the machine or spare-part name, model, quantity, location, and any photos or reference numbers. The more context you include, the faster we can answer.',
          },
          {
            question: 'Can I ask about both machines and spare parts?',
            answer:
              'Yes. Send everything in one request and we will direct it to the right person so you get a complete answer.',
          },
          {
            question: 'How quickly do you reply?',
            answer:
              'We aim to reply the same business day whenever possible, especially for commercial and technical requests.',
          },
          {
            question: 'Can I visit a showroom before ordering?',
            answer:
              'Absolutely. You can visit the nearest showroom to see equipment in person and get guidance before making a decision.',
          },
        ],
      },
      cta: {
        eyebrow: 'Fast Path',
        title: 'Prefer To Browse First?',
        description:
          'Explore our machine and spare-part catalogs, then contact us with specific references.',
        viewProducts: 'View Machines',
        viewSpareParts: 'View Spare Parts',
      },
    },
    admin: {
      editNavigation: {
        browsing: 'Browsing',
        browsingEntity: 'Browsing {{entity}}',
        position: '{{current}} of {{total}}',
        totalItems: '{{total}} {{entity}}',
        products: 'products',
        spareParts: 'spare parts',
        previous: 'Previous',
        next: 'Next',
        cancel: 'Cancel',
        saving: 'Saving...',
        unsavedTitle: 'Save changes before leaving?',
        unsavedDescription:
          'You have unsaved changes. Save them before opening the next item, continue without saving, or cancel and stay here.',
        continueWithoutSaving: 'Do not save',
        saveAndContinue: 'Save and continue',
      },
      navLabels: {
        dashboard: 'Dashboard',
        search: 'Global Search',
        products: 'Products',
        brands: 'Brands',
        showrooms: 'Showrooms',
        producttypes: 'Product Types',
        spareparts: 'Spare Parts',
        requests: 'Requests',
        promos: 'Promos',
        users: 'Users',
        team: 'Team',
        divers: 'Divers',
        trash: 'Trash',
        audit: 'History Log',
        health: 'Operational Health',
      },
      navChildren: {
        products: {
          add: 'Add Product',
          list: 'Products List',
          types: 'Product Types',
          addBrand: 'Add Brand',
          brandsList: 'Brands List',
        },
        brands: {
          add: 'Add Brand',
          list: 'Brands List',
        },
        showrooms: {
          add: 'Add Showroom',
          list: 'Showrooms List',
        },
        spareparts: {
          add: 'Add Spare Part',
          list: 'Spare Parts List',
          categories: 'Categories',
        },
        requests: {
          list: 'User Requests',
        },
        promos: {
          list: 'Promos List',
          add: 'Add Promo',
        },
        users: {
          add: 'Add User',
          list: 'Users List',
        },
        team: {
          add: 'Add Team Member',
          list: 'Team List',
        },
        divers: {
          guides: 'Guides',
          audit: 'History Log',
          health: 'Operational Health',
        },
      },
      guides: {
        title: 'Guide Book',
        pageTitle: 'Guide Book',
        pageSubtitle: 'A quick help library for when an admin is stuck.',
        introEyebrow: 'Help Library',
        introTitle: 'Start with the task you need',
        introDescription:
          'Open a guide card to see the shortest path through a task, then jump to the matching admin page. On that page, the ? button opens the focused tour.',
        step1Label: 'Step 1',
        step1Text: 'Choose a guide',
        step2Label: 'Step 2',
        step2Text: 'Open the linked page',
        step3Label: 'Step 3',
        step3Text: 'Use the ? button',
        quickReferencesEyebrow: 'Quick references',
        quickReferencesTitle: 'Three help panels to keep open',
        quickReferencesDescription: 'A cheat sheet, quick troubleshooting, and common walkthrough examples.',
        referenceLabel: 'Reference',
        referenceText: 'Fast support reminder',
        cardCount: '{{count}} guides',
        focusedTourReminder: 'Use the ? button on each page for a focused tour.',
        subtitle: 'A quick help library for when an admin is stuck.',
        introEyebrow: 'Help Library',
        introTitle: 'Start with the task you need',
        introDescription:
          'Open a guide card to see the shortest path through a task, then jump to the matching admin page. On that page, the ? button opens the focused tour.',
        searchPlaceholder: 'Search guides, pages, or tasks...',
        loadingTitle: 'Loading guides...',
        loadingDescription: 'Preparing the help library.',
        noPermission: 'You do not have permission to access the guide library.',
        emptyTitle: 'No guides found',
        emptyDescription: 'Try a different keyword or browse the full set of guides below.',
        openPage: 'Open page',
      },
      sidebar: {
        collapse: 'Collapse sidebar',
        expand: 'Expand sidebar',
        lightMode: 'Light Mode',
        darkMode: 'Dark Mode',
        exitToWebsite: 'Exit to website',
        profileSettings: 'Profile Settings',
        logout: 'Logout',
      },
      header: {
        sessionExpiresIn: 'Session expires in',
        live: 'Live',
        maintenance: 'Maintenance',
        searchPlaceholder: 'Search products, users, audit...',
        search: 'Search',
        notifications: 'Notifications',
        noNewEvents: 'No notifications right now.',
        noNotificationsDescription: 'There are no notifications right now. New activity will appear here.',
        dismissNotification: 'Dismiss notification',
      },
      notifications: {
        newAccountCreated: 'New account created',
        newUserAccountCreated: 'A new user account was created.',
        quoteRequestTitle: 'Quote request {{requestNumber}}',
        quoteRequestDescription: 'A customer has submitted a new quote request.',
        quoteRequestDescriptionWithCustomer: 'A customer has submitted a new quote request for {{customerName}}.',
        quoteRequestSource: 'Quote requests',
        legacyNotification: 'Legacy notification',
        adminPanel: 'Admin panel',
        moreAvailable: '{{count}} more notifications available',
        centerViewAll: 'View all notifications',
        centerTitle: 'Notification Center',
        centerSubtitle: 'Review the latest admin activity in one place.',
        centerEyebrow: 'Dashboard',
        centerClearAll: 'Clear all',
        centerEmptyTitle: 'No notifications yet',
        centerEmptyDescription: 'New quote requests, user signups, and other activity will appear here.',
        centerBackToDashboard: 'Back to dashboard',
        centerOpenLabel: 'Open',
        justNow: 'Just now',
        minutesAgo: '{{count}} min ago',
        hoursAgo: '{{count}} h ago',
        daysAgoWithDate: '{{count}} d ago ({{date}} {{time}})',
      },
      session: {
        expired: 'Session expired. Please log in again.',
        expiringSoon: 'Session will expire soon. Re-login to continue.',
      },
      entry: {
        redirecting: 'Redirecting to admin...',
      },
      login: {
        title: 'ETC Admin',
        subtitle: 'Login to manage products',
        adminEmail: 'Admin Email',
        emailPlaceholder: 'admin@example.com',
        bootstrapHint: 'Use the configured admin email and bootstrap password for the first admin login.',
        password: 'Password',
        passwordPlaceholder: 'Enter password',
        invalidCredentials: 'Invalid credentials',
        loginFailed: 'Login failed',
        passwordRequired: 'Password is required.',
        tooManyRequests: 'Too many login attempts. Please try again later.',
        roleNotAllowed: 'User role is not allowed for admin access.',
        notConfigured: 'Admin login is not configured on this deployment.',
        bootstrapNotConfigured: 'Bootstrap admin login is not configured on this deployment.',
        databaseUnavailable: 'Database connection failed.',
        loggingIn: 'Logging in...',
        login: 'Login',
        backToWebsite: 'Back to website',
      },
      brands: {
        title: 'Brands',
        subtitle: 'Manage brand names and logo assets.',
        listTitle: 'Brands',
        listSubtitle: 'Manage brand names and logo assets.',
        addTitle: 'Add Brand',
        addSubtitle: 'Create or update a brand and its logo.',
        editTitle: 'Edit Brand',
        addBrand: 'Add brand',
        editBrand: 'Edit brand',
        brandName: 'Brand name',
        brandNamePlaceholder: 'Enter brand name',
        brandLogo: 'Brand logo',
        brandLogoHint: 'Upload a logo or brand mark for the selector and badges.',
        uploadLogo: 'Upload logo',
        uploading: 'Uploading...',
        imageUploaded: 'Image uploaded.',
        removeLogo: 'Remove logo',
        noLogo: 'No logo',
        listModeTitle: 'Brands list',
        editHelper: 'Update the brand details from this form.',
        addHelper: 'Create a brand once, then reuse it in products.',
        addTourLabel: 'Add brand tour',
        addTourIntroTitle: 'Create a brand record',
        addTourIntroDescription:
          'Use this guided form to name the brand, upload a logo, and save a clean registry entry that can be reused across the catalog.',
        addTourIntroHint: 'Start with the identity details',
        addTourNameTitle: 'Brand name',
        addTourNameDescription:
          'Enter the official brand name exactly as it should appear in selectors, badges, and product records.',
        addTourNameHint: 'Name the brand clearly',
        addTourLogoTitle: 'Brand logo',
        addTourLogoDescription:
          'Upload the logo or mark used in the brand picker so the identity stays consistent everywhere it appears.',
        addTourLogoHint: 'Add the visual identity',
        addTourSaveTitle: 'Save or cancel',
        addTourSaveDescription:
          'Use the action bar to save the brand or cancel and return to the list once the details are ready.',
        addTourSaveHint: 'Finish the form',
        loadFailed: 'Failed to load brands.',
        loadSingleFailed: 'Failed to load brand.',
        createFailed: 'Failed to create brand.',
        updateFailed: 'Failed to update brand.',
        deleteFailed: 'Failed to delete brand.',
        createdSuccess: 'Brand created.',
        updatedSuccess: 'Brand updated.',
        deletedSuccess: 'Brand deleted.',
        nameRequired: 'Brand name is required.',
          logoRequired: 'Brand logo is required.',
          logoRequired: 'Le logo de la marque est requis.',
        alreadyExists: 'Brand already exists.',
        uploadFailed: 'Upload failed.',
        noReadPermission: 'You do not have permission to view brands.',
        noWritePermission: 'You do not have permission to add brands.',
        noDeletePermission: 'You do not have permission to delete brands.',
        confirmDeleteTitle: 'Delete brand?',
        confirmDeleteDescription: 'This will remove the brand from the registry.',
        saveBrand: 'Save brand',
        updateBrand: 'Update brand',
      },
      profile: {
        noPermission: 'You do not have permission to access profile settings.',
        defaultEmail: 'admin@etc-company.local',
        defaultRole: 'Admin',
        uploadFailed: 'Upload failed',
        pictureUploaded: 'Profile picture uploaded.',
        saveFailed: 'Failed to save profile.',
        saveSuccess: 'Profile settings saved.',
        layoutTitle: 'Profile Settings',
        layoutSubtitle: 'Update what appears in the admin credential bar.',
        accountSettings: 'Account Settings',
        accountDescription: 'Manage your admin profile and visible account info',
        displayName: 'Display Name',
        nameRequired: 'Display name is required.',
        email: 'Email',
        roleLabel: 'Role Label',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        discard: 'Discard',
        upload: 'Upload',
        uploadHint: 'Upload a photo to make your admin account more personal.',
        removePhoto: 'Remove Photo',
      },
      health: {
        title: 'Operational Health',
        subtitle: 'Monitor runtime, database, and system reliability.',
        noPermission: 'You do not have permission to view operational health.',
        loadFailed: 'Failed to load operational health.',
        loadingTitle: 'Loading health metrics...',
        loadingDescription: 'Checking system and database status.',
        unavailable: 'Operational health unavailable',
        noData: 'No data returned from health endpoint.',
        warning: 'Health check warning',
        checkedAt: 'Checked at',
        refreshing: 'Refreshing...',
        refresh: 'Refresh',
        apiResponse: 'API Response',
        dbLatency: 'DB Latency',
        unavailableShort: 'Unavailable',
        uptime: 'Uptime',
        auditFailures1h: 'Audit Failures (1h)',
        database: 'Database',
        runtime: 'Runtime',
        datasetCounts: 'Dataset Counts',
        status: 'Status',
        connected: 'Connected',
        disconnected: 'Disconnected',
        connectionState: 'Connection state',
        latency: 'Latency',
        error: 'Error',
        environment: 'Environment',
        nodeVersion: 'Node',
        processId: 'PID',
        memoryRss: 'Memory RSS',
        heapUsed: 'Heap Used',
        products: 'Products',
        users: 'Users',
        auditLogs: 'Audit Logs',
        failures24h: 'Failures (24h)',
      },
      audit: {
        title: 'History Log',
        subtitle: 'Track admin actions across the dashboard.',
        noPermission: 'You do not have permission to view history log.',
        tourLabel: 'Audit tour',
        tourIntroTitle: 'Audit history at a glance',
        tourIntroDescription:
          'Use this walkthrough to review admin activity, filter the timeline, and open linked records when you need to trace a change.',
        tourIntroHint: 'Start with the filters',
        tourFiltersTitle: 'Filter the history log',
        tourFiltersDescription:
          'Choose a status, narrow the search, and clear the log when you need a focused view of recent actions.',
        tourFiltersHint: 'Focus the timeline',
        tourTableTitle: 'Inspect events and details',
        tourTableDescription:
          'Scan the activity rows, open the details column, and follow the linked entity or actor to investigate what happened.',
        tourTableHint: 'Review the event list',
        loadFailed: 'Failed to load history log.',
        clearFailed: 'Failed to clear history log.',
        cleared: 'History log cleared.',
        loadingTitle: 'Loading history log...',
        loadingDescription: 'Retrieving recent activity entries.',
        failedTitle: 'Failed to load history log',
        clearing: 'Clearing...',
        clearHistory: 'Clear History',
        allStatuses: 'All statuses',
        successOnly: 'Success only',
        failureOnly: 'Failure only',
        searchPlaceholder: 'Search action, actor, entity...',
        emptyText: 'No history events found.',
        when: 'When',
        action: 'Action',
        entity: 'Entity',
        actor: 'Actor',
        status: 'Status',
        details: 'Details',
        administrator: 'Administrator',
        unknown: 'unknown',
        deleteTitle: 'Delete history log?',
        deleteDescription: 'Are you sure you want to delete?',
        delete: 'Delete',
      },
      promo: {
        title: 'Promotion',
        productHint: 'Highlight this product with a promo badge or discounted price.',
        sparePartHint: 'Highlight this spare part with a promo badge or discounted price.',
        active: 'Active',
        inactive: 'Inactive',
        enable: 'Enable promo',
        featured: 'Feature on listings',
        kind: 'Promo type',
        colorTone: 'Color tone',
        discountPercent: 'Discount (%)',
        discountPercentPlaceholder: '20',
        discountPercentHint: 'Enter the percentage off, like 20 for 20% off.',
        labelEn: 'Badge label (EN)',
        labelEnPlaceholder: 'Promo',
        labelFr: 'Badge label (FR)',
        labelFrPlaceholder: 'Promo',
        startsAt: 'Starts at',
        startsAtPlaceholder: 'Select date and time',
        endsAt: 'Ends at',
        endsAtPlaceholder: 'Select date and time',
        kindBadgeOnly: 'Badge only',
        kindDiscountedPrice: 'Discounted price',
        colorOrange: 'Orange',
        colorBeige: 'Beige',
        colorSecondary: 'Secondary',
        colorBlack: 'Black',
      },
      promos: {
        title: 'Promos',
        subtitle: 'Review every active, upcoming, and expired promo in one place.',
        noPermission: 'You do not have permission to view promos.',
        loadingTitle: 'Loading promos...',
        loadingDescription: 'Collecting offers from products and spare parts.',
        loadFailed: 'Failed to load promos.',
        productsLoadFailed: 'Failed to load products.',
        sparePartsLoadFailed: 'Failed to load spare parts.',
        saveFailed: 'Failed to save promo.',
        removeFailed: 'Failed to remove promo.',
        saveDisabledHint: 'Enable promo to save changes.',
        savePromo: 'Save promo',
        searchPlaceholder: 'Search by ID, item, promo, type, or status...',
        emptyText: 'No promos match the current filters.',
        helper: 'Use the filters to narrow promos by item type, promo kind, or live status.',
        all: 'All',
        active: 'Active',
        upcoming: 'Upcoming',
        expired: 'Expired',
        products: 'Products',
        spareParts: 'Spare Parts',
        product: 'Product',
        sparePart: 'Spare Part',
        badgeOnly: 'Badge only',
        discountedPrice: 'Discounted price',
        totalPromos: 'Total promos',
        activePromos: 'Active promos',
        upcomingPromos: 'Upcoming promos',
        expiredPromos: 'Expired promos',
        featuredPromos: 'Featured promos',
        discountedPromos: 'Discounted promos',
        addPromo: 'Add promo',
        addHelper: 'Choose an item and configure its promo from this form only.',
        addTourLabel: 'Add promo tour',
        addTourIntroTitle: 'Create a promo',
        addTourIntroDescription:
          'Use this editor to choose the target item, configure the promo rule, and confirm the details before you publish it.',
        addTourIntroHint: 'Start with the item',
        addTourSelectionTitle: 'Choose the item',
        addTourSelectionDescription:
          'Start by deciding whether the promo belongs to a product or a spare part, then select the exact record from the catalog.',
        addTourSelectionHint: 'Select the target item',
        addTourFieldsTitle: 'Configure the promo',
        addTourFieldsDescription:
          'Set the label, dates, visibility, and discount options so the promotion matches the campaign you want to run.',
        addTourFieldsHint: 'Define the promo rules',
        addTourSaveTitle: 'Save or remove',
        addTourSaveDescription:
          'Use the action buttons to save the promo or remove it once the campaign is no longer needed.',
        addTourSaveHint: 'Finish the editor',
        editPromo: 'Edit promo',
        editHelper: 'Update the selected item promo from this form only.',
        updatePromo: 'Update promo',
        editPromoAction: 'Edit promo',
        listModeTitle: 'Promos list',
        listModeDescription: 'Browse active and scheduled promos without the editor.',
        removePromo: 'Remove promo',
        removing: 'Removing...',
        removed: 'Promo removed.',
        confirmRemove: 'Remove this promo?',
        item: 'Item',
        id: 'ID',
        type: 'Type',
        promoKind: 'Promo kind',
        status: 'Status',
        period: 'Period',
        featured: 'Featured',
        price: 'Price',
        actions: 'Actions',
        openItem: 'Open item',
        managePromos: 'Manage promos',
        quickAdd: 'Quick add',
        addProductPromo: 'Add product promo',
        addSparePartPromo: 'Add spare-part promo',
      },
      search: {
        title: 'Global Search',
        subtitle: 'Search products, users, and audit logs from one place.',
        noPermission: 'You do not have permission to use global search.',
        loadTitle: 'Loading search...',
        loadDescription: 'Preparing unified search results.',
        searchFailed: 'Search failed.',
        searchPlaceholder: 'Search by name, email, action...',
        allEntities: 'All entities',
        products: 'Products',
        users: 'Users',
        auditOnly: 'Audit only',
        anyStatus: 'Any status',
        success: 'Success',
        failure: 'Failure',
        hint: 'Leave query empty to browse recent items with selected filters.',
        searching: 'Searching...',
        search: 'Search',
        totalMatches: 'Total Matches',
        failedTitle: 'Search failed',
        noProductMatches: 'No product matches.',
        noUserMatches: 'No user matches.',
        noAuditMatches: 'No audit matches.',
        noPermissionEntity: 'No permission to view this entity.',
        unnamedUser: 'Unnamed User',
        noSlug: 'no-slug',
        showMore: 'Show {{count}} more',
        showLess: 'Show less',
      },
      userRequests: {
        title: 'User Requests',
        subtitle: 'Review quote requests, calculate pricing, and send the final request for quote.',
        tourLabel: 'User requests tour',
        tourIntroTitle: 'Review quote requests at a glance',
        tourIntroDescription:
          'Use this page to monitor incoming quote requests, narrow the queue, and open a request when it needs review.',
        tourIntroHint: 'Start with the queue',
        tourArchiveTitle: 'Automatic archiving',
        tourArchiveDescription:
          'Sent and declined requests are archived automatically after 7 days, so this notice explains when older items leave the active queue.',
        tourArchiveHint: 'No manual cleanup needed',
        tourFiltersTitle: 'Search and filter the queue',
        tourFiltersDescription:
          'Use the status, client, and search controls together to isolate requests by customer, date, or current state.',
        tourFiltersHint: 'Refine the list',
        tourTableTitle: 'Scan the request table',
        tourTableDescription:
          'Each row shows the request number, customer, item count, status, total, and creation date so you can compare requests quickly.',
        tourTableHint: 'Read the key columns',
        tourActionsTitle: 'Open a request',
        tourActionsDescription:
          'Use the Review button in the last column to open a request and continue into the detailed editor.',
        tourActionsHint: 'Drill into a request',
        reviewTourLabel: 'Request review tour',
        reviewTourIntroTitle: 'Review a quote request in detail',
        reviewTourIntroDescription:
          'Use this page to inspect the customer, adjust the quote, and finish the request with a saved PDF or a sent reply.',
        reviewTourIntroHint: 'Start with the overview',
        reviewTourTopActionsTitle: 'Back, preview, save, and print',
        reviewTourTopActionsDescription:
          'These buttons return you to the list, open a live PDF preview, save a PDF copy, or print the request for quote.',
        reviewTourTopActionsHint: 'Start with the utilities',
        reviewTourOverviewTitle: 'Request overview',
        reviewTourOverviewDescription:
          'This card shows the request number, timestamps, customer identity, totals, and notes that explain the context quickly.',
        reviewTourOverviewHint: 'Check the request summary',
        reviewTourItemsTitle: 'Quote line items',
        reviewTourItemsDescription:
          'Adjust the quote price for each line here. The totals update immediately so you can compare requested and quoted values.',
        reviewTourItemsHint: 'Tune each line',
        reviewTourSummaryTitle: 'Status and totals',
        reviewTourSummaryDescription:
          'Use the summary panel to confirm mail status, request status, requested subtotal, quoted subtotal, interest, and final total.',
        reviewTourSummaryHint: 'Verify the numbers',
        reviewTourActionsTitle: 'Admin notes and final actions',
        reviewTourActionsDescription:
          'Add internal notes or a rejection reason, then save a draft, send the quote, reject the request, or archive it.',
        reviewTourActionsHint: 'Finish the workflow',
        archiveNoticeTitle: 'Automatic archive notice',
        archiveNoticeText: 'Sent and declined requests are archived automatically after 7 days.',
        archiveNoticeHint: 'No manual cleanup needed',
        clientFilter: 'Client',
        allClients: 'All clients',
        clientFilterSearch: 'Search clients...',
        noClients: 'No clients found',
        loadFailed: 'Failed to load requests.',
        errorTitle: 'Unable to load requests',
        forbidden: 'You do not have permission to view quote requests.',
        searchPlaceholder: 'Search by request number, customer, or status',
        empty: 'No quote requests yet',
        filterStatus: 'Filter status',
        refresh: 'Refresh',
        requestNo: 'Request #',
        customer: 'Customer',
        items: 'Items',
        status: 'Status',
        total: 'Total',
        createdAt: 'Created',
        actions: 'Actions',
        review: 'Review',
        purchaseOrder: 'Request for Quote',
        reviewTitle: 'Request Review',
        reviewSubtitle: 'Prepare the request for quote, add interest, or reject with a reason.',
        backToList: 'Back to list',
        exportPdf: 'Export PDF',
        savePdf: 'Save PDF',
        previewPdf: 'Preview PDF',
        previewPdfLoadingButton: 'Preparing preview...',
        previewPdfTitle: 'PDF preview',
        previewPdfEyebrow: 'PDF preview',
        previewPdfSubtitle: 'Review the generated request for quote without leaving the page.',
        previewPdfLoading: 'Loading PDF preview...',
        previewPdfEmpty: 'No PDF available.',
        previewPdfFailed: 'Unable to open the PDF preview.',
        previewPdfFrame: 'PDF preview',
        closePreview: 'Close',
        savingPdf: 'Saving PDF...',
        htmlSource: 'HTML source',
        printPdf: 'Print',
        printingPdf: 'Printing...',
        pdfSaved: 'PDF saved.',
        pdfFailed: 'Failed to save PDF.',
        printFailed: 'Unable to open the print dialog.',
        printUnavailable: 'Printing is not available in this browser.',
        mailStatus: 'Mail status',
        mailStatusFailed: 'Failed to load mail status.',
        mailChecking: 'Checking...',
        mailConnected: 'Mail connected',
        mailNotConfigured: 'Mail not configured',
        mailPreviewTo: 'Preview copy',
        requestedSubtotal: 'Requested subtotal',
        quotedSubtotal: 'Quoted subtotal',
        currentStatus: 'Current status',
        updatedAt: 'Updated',
        contactDetails: 'Contact details',
        customerNote: 'Customer note',
        noCustomerNote: 'No customer note provided.',
        noPhone: 'No phone provided',
        noRejectionReason: 'No rejection reason yet.',
        quoteItems: 'Quote items',
        quoteItemsHelp: 'Adjust the price for each line before sending the request for quote.',
        quotePrice: 'Quote price',
        quantity: 'Quantity',
        unit: 'unit',
        lineTotal: 'Line total',
        summary: 'Summary',
        interestPercent: 'Interest %',
        interestAmount: 'Interest amount',
        tvaPercent: 'TVA %',
        tvaAmount: 'TVA amount',
        productTvaLabel: 'Product',
        sparePartTvaLabel: 'Spare part',
        pdfRequiresSave: 'Save the request before generating the PDF.',
        finalTotal: 'Final total',
        adminNote: 'Admin note',
        adminNotePlaceholder: 'Add payment, delivery, or stock notes here',
        rejectionReason: 'Rejection reason',
        rejectionReasonPlaceholder: 'Explain why the request was declined',
        signature: 'Authorized signature',
        signaturePlaceholder: 'Approval and stamp area',
        saving: 'Saving...',
        sending: 'Sending...',
        rejecting: 'Rejecting...',
        archiving: 'Archiving...',
        saveQuote: 'Save draft',
        sendQuote: 'Send quote',
        rejectRequest: 'Reject request',
        archiveRequest: 'Archive request',
        sendConfirmTitle: 'Send this quote to the customer?',
        sendConfirmDescription:
          'The customer will receive the quote email with the current prices, interest, and totals. Make sure all line items are reviewed before sending.',
        sendConfirm: 'Send quote',
        rejectConfirmTitle: 'Reject this quote request?',
        rejectConfirmDescription:
          'The request will be marked as declined and the rejection reason will be saved with it. You can still update the reason from the editor before confirming.',
        rejectConfirm: 'Reject request',
        cancelConfirm: 'Cancel',
        quoteSaved: 'Draft saved successfully.',
        quoteSent: 'Quote sent successfully.',
        requestDeclined: 'Request declined.',
        requestArchived: 'Request archived.',
        saveFailed: 'Failed to save request.',
        rejectionReasonRequired: 'Please add a rejection reason before declining.',
        archivedAtLabel: 'Archived on {{date}} - read only.',
        loading: 'Loading request...',
        delete: 'Delete',
        deleting: 'Deleting...',
        cancel: 'Cancel',
        selectAll: 'Select all visible rows',
        selectRow: 'Select this request',
        clearSelection: 'Clear selection',
        selectedCount: '{{count}} selected',
        bulkDelete: 'Delete {{count}}',
        bulkDeleteTitle: 'Delete selected requests?',
        bulkDeleteDescription:
          '{{count}} request will be moved to the trash. You can restore them from the trash page later.',
        bulkDeleteConfirm: 'Delete {{count}}',
        bulkDeleteSuccess: '{{count}} request moved to the trash.',
        singleDeleteTitle: 'Delete this request?',
        singleDeleteDescription:
          'Request {{requestNumber}} ({{customerName}}) will be moved to the trash. You can restore it from the trash page later.',
        singleDeleteConfirm: 'Delete request',
        deleteFailed: 'Failed to delete the request.',
        deleteSuccess: 'Request {{requestNumber}} moved to the trash.',
      },
      trash: {
        title: 'Trash',
        subtitle: 'Recover deleted products, product types, spare parts, showrooms, team members, and users.',
        noPermission: 'You do not have permission to view trash.',
        loadFailed: 'Failed to load trash.',
        restoreFailed: 'Failed to restore item.',
        restoreSuccess: 'Item restored successfully.',
        restoreItemsFailed: 'Failed to restore items.',
        deleteItemsFailed: 'Failed to delete items.',
        restoredCount: 'Restored',
        deletedCount: 'Deleted',
        loadingTitle: 'Loading trash...',
        loadingDescription: 'Retrieving deleted items.',
        failedTitle: 'Failed to load trash',
        restoring: 'Restoring...',
        restoreAll: 'Restore All',
        deleting: 'Deleting...',
        deleteAll: 'Delete All',
        searchPlaceholder: 'Search deleted items...',
        emptyText: 'Trash is empty.',
        entity: 'Entity',
        item: 'Item',
        deletedAt: 'Deleted At',
        deletedBy: 'Deleted By',
        restore: 'Restore',
        administrator: 'Administrator',
        deleteTitle: 'Delete all items in trash?',
        deleteDescription: 'Are you sure you want to delete?',
        deleteAllLabel: 'Delete All',
        allEntities: 'All entities',
        products: 'Products',
        productTypes: 'Product Types',
        spareParts: 'Spare Parts',
        showrooms: 'Showrooms',
        teamMembers: 'Team Members',
        users: 'Users',
        product: 'Product',
        productType: 'Product Type',
        sparePart: 'Spare Part',
        showroom: 'Showroom',
        team: 'Team Member',
        user: 'User',
        unknown: 'Unknown',
      },
      dashboard: {
        title: 'Dashboard',
        subtitle: 'Monitor products, users, and maintenance at a glance.',
        noPermission: 'You do not have permission to access dashboard.',
        tourLabel: 'Dashboard tour',
        tourIntroTitle: 'Welcome to the dashboard',
        tourIntroDescription:
          'Use this walkthrough to spot site health issues, refresh the data, and jump into maintenance controls without leaving the page.',
        tourIntroHint: 'A fast orientation before you start',
        tourMaintenanceTitle: 'Maintenance controls',
        tourMaintenanceDescription:
          'This panel lets you turn maintenance mode on or off, choose how long it stays active, and apply the change safely when the site needs a pause.',
        tourMaintenanceHint: 'Pause the public site when needed',
        tourFiltersTitle: 'Reporting window and refresh',
        tourFiltersDescription:
          'Pick a reporting window, toggle auto refresh, or pull the latest snapshot so the numbers stay current while you work.',
        tourFiltersHint: 'Tune the live report',
        tourMetricsTitle: 'KPI cards',
        tourMetricsDescription:
          'These cards summarize the numbers that matter most, including new products, user growth, inventory value, alerts, and movement at a glance.',
        tourMetricsHint: 'Read the headline numbers first',
        tourTrendsTitle: 'Charts and trend view',
        tourTrendsDescription:
          'Use the charts and category breakdown to understand what is growing, what is slowing down, and how stock health is changing over time.',
        tourTrendsHint: 'Compare what is moving',
        tourActivityTitle: 'Recent activity',
        tourActivityDescription:
          'Recent product, user, and audit events appear here so you can open the latest changes quickly when something needs attention.',
        tourActivityHint: 'Open the freshest records',
        activityJustNow: 'Just now',
        activityMinutesAgo: '{{count}} min ago',
        activityHoursAgo: '{{count}} h ago',
        activityYesterday: 'Yesterday',
        activityDaysAgo: '{{count}} d ago',
        activityStatusSuccess: 'Successful',
        activityStatusFailure: 'Failed',
        activityBy: 'by {{name}}',
        activityRoleAdmin: 'Admin',
        activityRoleEditor: 'Editor',
        activityRoleViewer: 'Viewer',
        activityViewRecord: 'View record',
        activityEntityProduct: 'Product',
        activityEntityUser: 'User',
        activityEntitySparePart: 'Spare part',
        activityEntityAdmin: 'Admin',
        activityEntitySession: 'Session',
        activityEntityBrand: 'Brand',
        activityEntityShowroom: 'Showroom',
        activityEntityPromo: 'Promo',
        activityEntityRequest: 'Request',
        adminLogin: 'Admin login',
        adminProfileUpdate: 'Admin profile update',
        productCreate: 'Product created',
        productUpdate: 'Product updated',
        productDelete: 'Product deleted',
        userCreate: 'User created',
        userUpdate: 'User updated',
        userDelete: 'User deleted',
        tourRecordsTitle: 'Recent records',
        tourRecordsDescription:
          'Recent products and users are shown here to keep the latest updates visible even when the audit trail is not part of the current view.',
        tourRecordsHint: 'Check the latest entries',
        productsOverviewFailed: 'Failed to load products overview.',
        usersOverviewFailed: 'Failed to load users overview.',
        sparePartsOverviewFailed: 'Failed to load spare parts overview.',
        loadFailed: 'Failed to load dashboard overview.',
        loadDataFailed: 'Dashboard data could not be loaded.',
        loadingTitle: 'Loading dashboard...',
        loadingDescription: 'Gathering key metrics and activity.',
        incompleteTitle: 'Dashboard data is incomplete',
        analyticsWindow: 'Reporting window',
        comparedPrevious: 'compared with previous equivalent period',
        lastUpdated: 'Last updated',
        to: 'to',
        autoRefresh: 'Auto refresh',
        refreshing: 'Refreshing...',
        refreshNow: 'Refresh now',
        qualityNotes: 'Data quality notes',
        excludedRecords: 'records excluded from trend calculations due to missing/invalid dates.',
        productAnomalies: 'Product anomalies',
        invalidPrices: 'invalid prices',
        invalidStockValues: 'invalid stock values',
        rangeLast7: 'Last 7 days',
        rangeLast30: 'Last 30 days',
        rangeLast90: 'Last 90 days',
        rangeLast12m: 'Last 12 months',
        rangeCustom: 'Custom range',
        liveReport: 'Live report',
        overviewEyebrow: 'Overview',
        overviewDescription: 'Primary KPIs at a glance.',
        moreMetricsEyebrow: 'More metrics',
        newProducts: 'New Products',
        newUsers: 'New Users',
        inventoryValueAdded: 'Inventory Value Added',
        stockAlerts: 'Stock Alerts',
        outOfStock: 'out of stock',
        productVelocityDay: 'Product Velocity / Day',
        userVelocityDay: 'User Velocity / Day',
        inStockCoverage: 'In-Stock Coverage',
        averageProductPrice: 'Average Product Price',
        total: 'Total',
        prev: 'Prev',
        products: 'products',
        averageStock: 'Average stock',
        units: 'units',
        uncategorized: 'Uncategorized',
        prevPerDay: 'Prev {{value}}/day',
        stockHealth: 'Stock Health',
        stockHealthy: 'Healthy (>5)',
        stockLow: 'Low (1-5)',
        stockOut: 'Out (0)',
        kpiDepth: 'Key Metrics',
        lowStockRisk: 'Low Stock Risk',
        outOfStockRisk: 'Out of Stock Risk',
        productsCreatedPerDay: 'Products Created / Day',
        usersCreatedPerDay: 'Users Created / Day',
        excludedDateRecords: 'Excluded Date Records',
        invalidProductValues: 'Invalid Product Values',
        productsCountHint: '{{count}} products',
        dayWindow: '{{days}}-day window',
        excludedDateHint: '{{productCount}} product + {{userCount}} user',
        invalidValuesHint: '{{priceCount}} price + {{stockCount}} stock',
        topInventoryValue: 'Top Inventory Value',
        viewAll: 'View all',
        noProductsYet: 'No products yet.',
        stockAtPrice: 'Stock: {{stock}} @ {{price}}',
        analysisEyebrow: 'Analysis',
        analysisBlockTitle: 'Insights overview',
        analysisBlockDescription: 'Key trends, category mix, and stock health at a glance.',
        analysisDescription: 'Monthly product and user growth over the selected period.',
        categoryMomentum: 'Category Momentum',
        compositionEyebrow: 'Composition',
        groups: '{{count}} groups',
        noCategoryTrendData: 'No category trend data available.',
        noCategoryData: 'No category data available.',
        currentPrevious: 'Current {{current}} | Previous {{previous}}',
        statusEyebrow: 'Status',
        diagnosticsEyebrow: 'Diagnostics',
        leadersEyebrow: 'Leaders',
        momentumEyebrow: 'Momentum',
        catalogEyebrow: 'Catalog',
        peopleEyebrow: 'People',
        auditLogEyebrow: 'Audit log',
        recentProducts: 'Recent Products',
        noDate: 'No date',
        noUsersYet: 'No users yet.',
        userAvatarAlt: 'User avatar',
        recentUsers: 'Recent Users',
        coverEyebrow: 'Admin snapshot',
        coverTitle: 'Administrator control center',
        coverDescription:
          'Monitor maintenance, products, users, and recent activity from one place.',
        coverTimeLabel: 'Current time',
        coverDateLabel: 'Current date',
        siteMaintenanceTitle: 'Maintenance control',
        siteMaintenanceControl: 'Settings',
        siteMaintenanceDescription:
          'Pause the public website while you work on backend changes. Admin access remains available the entire time.',
        siteMaintenanceActive: 'Maintenance is enabled.',
        siteMaintenanceInactive: 'Maintenance is off.',
        siteMaintenanceEnabledNotice: 'Public visitors are redirected to the maintenance page.',
        siteMaintenanceDisabledNotice: 'Public visitors can browse the website normally.',
        siteMaintenanceSaving: 'Saving maintenance setting...',
        siteMaintenanceToastOn: 'Maintenance mode enabled.',
        siteMaintenanceToastOff: 'Maintenance mode disabled.',
        siteMaintenanceDurationTitle: 'Duration',
        siteMaintenanceDurationSummary: '{{amount}} {{unit}}',
        siteMaintenanceDurationNone: 'None',
        siteMaintenanceDurationIndefinite: 'Coming soon',
        siteMaintenanceDurationLong: 'Coming soon',
        siteMaintenancePresetNone: 'None',
        siteMaintenancePresetLong: 'Coming soon',
        siteMaintenanceDurationMinute: 'Minute',
        siteMaintenanceDurationMinutes: 'Minutes',
        siteMaintenanceDurationHours: 'Hours',
        siteMaintenanceDurationHour: 'Hour',
        siteMaintenanceDurationDays: 'Days',
        siteMaintenanceDurationDay: 'Day',
        siteMaintenanceDurationAmount: 'Amount',
        siteMaintenanceCustomTime: 'Custom time',
        siteMaintenanceCustomUnit: 'Unit',
        siteMaintenanceCustomHint: 'Up to 12 hours',
        siteMaintenanceEndsAt: 'Ends at',
        siteMaintenanceApply: 'Apply',
        siteMaintenancePendingChanges: 'Unsaved changes',
        siteMaintenanceNoChanges: 'No changes to apply',
        siteMaintenanceTimeLeft: 'Time left',
        siteMaintenanceOverviewState: 'State',
        siteMaintenanceOverviewDuration: 'Duration',
        siteMaintenanceOverviewChanges: 'Changes',
        siteMaintenanceOverviewLive: 'Live',
        siteMaintenanceOverviewMaintenance: 'Maintenance',
        siteMaintenanceOverviewVisitors: 'Visitor access',
        siteMaintenanceOverviewVisitorsOpen: 'Open',
        siteMaintenanceOverviewVisitorsPaused: 'Paused',
        siteMaintenanceOverviewAdmin: 'Admin access',
        siteMaintenanceOverviewAdminOnline: 'Online',
        siteMaintenanceOverviewPending: 'Pending',
        siteMaintenanceOverviewReady: 'Ready',
        recentActivity: 'Recent Activity',
        openAuditTrail: 'Open audit trail',
        noRecentAuditEvents: 'No recent audit events.',
        growthTrendLast6Months: 'Growth Trend (last 6 months)',
        trendProductsUsers: 'Products {{products}} | Users {{users}}',
        productsLabel: 'Products',
        usersLabel: 'Users',
        categoryMix: 'Category Mix',
        durationMinutes15: '15m',
        durationMinutes30: '30m',
        durationMinutes45: '45m',
        durationHours1: '1h',
        durationHours3: '3h',
        durationHours6: '6h',
        durationHours12: '12h',
        durationDays1: '1d',
        durationSeconds15: '15s',
        durationSeconds30: '30s',
        durationSeconds60: '60s',
        durationSeconds120: '120s',
      },
      maintenance: {
        title: 'We are temporarily offline',
        description: 'The website is temporarily unavailable while we make updates.',
        eyebrow: 'Maintenance mode',
        secondary: 'The admin dashboard remains available, so backend work can continue safely.',
        adminAccess: 'Admin access',
        noteLabel: 'Status',
        noteTitle: 'Please check back soon',
        noteBody:
          'We are making improvements in the background and will restore public access when the work is complete.',
        durationLabel: 'Duration',
        durationHour: 'hour',
        durationHours: 'hours',
        durationDay: 'day',
        durationDays: 'days',
        durationValue: '{{amount}} {{unit}}',
        indefinite: 'Coming soon',
        endsAtLabel: 'Ends at',
        noEndDate: 'No fixed end date',
        timeRemainingLabel: 'Time remaining',
        autoReturnNote: 'The website will return automatically when the timer ends.',
        comingSoonNote: 'We will be back soon.',
        remainingDaysHours: '{{days}}d {{hours}}h left',
      },
      users: {
        title: 'Users',
        subtitle: 'Create, edit, and remove accounts with role access.',
        manageSubtitle: 'Manage users and access roles.',
        loadingTitle: 'Loading users...',
        loadingDescription: 'Fetching user accounts and roles.',
        noReadPermission: 'You do not have permission to view users.',
        noWritePermission: 'You do not have permission to add users.',
        noDeletePermission: 'You do not have permission to delete users.',
        noEditPermission: 'You do not have permission to edit users.',
        tourLabel: 'Users tour',
        tourIntroTitle: 'Users at a glance',
        tourIntroDescription:
          'Use this page to review accounts, search the directory, and keep access roles and contact details in sync.',
        tourIntroHint: 'Start with the directory',
        tourToolbarTitle: 'Bulk actions and export',
        tourToolbarDescription:
          'Use the toolbar to delete selected users, export records, and keep list-level changes organized.',
        tourToolbarHint: 'Manage account changes',
        tourTableTitle: 'Search and review users',
        tourTableDescription:
          'Search by name, email, phone, or role, then sort and select rows when you need to act on multiple accounts.',
        tourTableHint: 'Inspect the table',
        addTourLabel: 'Add user tour',
        addTourIntroTitle: 'Create a user account',
        addTourIntroDescription:
          'Use this form to add the person, set a password, and upload an avatar before saving the account.',
        addTourIntroHint: 'Start with the basics',
        addTourBasicsTitle: 'Identity details',
        addTourBasicsDescription:
          'Fill in the first name, last name, email, and phone number so the account can be identified quickly.',
        addTourBasicsHint: 'Enter the contact info',
        addTourAccessTitle: 'Password',
        addTourAccessDescription:
          'Set a password before creating the account so the user can sign in securely.',
        addTourAccessHint: 'Create secure access',
        addTourAvatarTitle: 'Profile photo',
        addTourAvatarDescription:
          'Upload a profile photo so the user looks familiar in lists, notifications, and internal references.',
        addTourAvatarHint: 'Add the avatar',
        addTourSaveTitle: 'Save or discard',
        addTourSaveDescription:
          'Use the buttons at the bottom to create the user or clear the draft and start over.',
        addTourSaveHint: 'Finish the form',
        loadFailed: 'Failed to load users.',
        cannotCreateTitle: 'Cannot create user',
        createFailed: 'Failed to create user.',
        createdSuccess: 'User created successfully.',
        unexpectedError: 'Unexpected error, please try again.',
        firstNameRequired: 'First name is required.',
        lastNameRequired: 'Last name is required.',
        phoneRequired: 'Phone is required.',
        avatarRequired: 'Profile photo is required.',
        emailRequired: 'Email is required.',
        emailAlreadyExists: 'Email already exists.',
        invalidEmail: 'Enter a valid email address.',
        passwordLength: 'Password must be at least 6 characters.',
        passwordRequired: 'Password is required.',
        deletedSuccess: 'User deleted successfully.',
        deleteFailed: 'Delete failed.',
        exportFailed: 'Export failed.',
        importFailed: 'Import failed.',
        uploadFailed: 'Upload failed',
        failedTitle: 'Failed to load users',
        searchPlaceholder: 'Search users...',
        emptyText: 'No users found.',
        saveChanges: 'Save Changes',
        saving: 'Saving...',
        discard: 'Discard',
        upload: 'Upload',
        uploadHint: 'Upload a photo to make your account more personal.',
        removePhoto: 'Remove Photo',
        photoUploaded: 'Photo uploaded.',
        accountSettings: 'Account Settings',
        publicProfileHint: 'Manage your public profile information',
        firstName: 'First Name',
        firstNamePlaceholder: 'Jane',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Doe',
        emailAddress: 'Email Address',
        emailPlaceholder: 'jane@example.com',
        phone: 'Phone',
        phonePlaceholder: '+216 00 000 000',
        role: 'Rôle',
        password: 'Password',
        passwordPlaceholder: 'Minimum 6 characters',
        editor: 'Editor',
        viewer: 'Viewer',
        user: 'User',
        unnamedUser: 'Unnamed User',
        newAccountDescription: '{{fullName}} ({{email}}) - New account created',
        bulkDeleteSuccess: 'Deleted {{count}} user(s).',
        bulkDeleteFailed: '{{count}} user(s) could not be deleted.',
        exportedAs: 'Users exported as {{format}}.',
        importComplete: 'Import complete: {{created}} created, {{updated}} updated, {{skipped}} skipped.',
        selectAllUsers: 'Select all users',
        userCol: 'User',
        emailCol: 'Email',
        phoneCol: 'Phone',
        roleCol: 'Role',
        createdCol: 'Created',
        actionsCol: 'Actions',
        editUser: 'Edit user',
        deleteUser: 'Delete user',
        editTitle: 'Edit User',
        editSubtitle: 'Update user details.',
        loadingSingleTitle: 'Loading user...',
        loadingSingleDescription: 'Retrieving user details.',
        loadSingleFailed: 'Failed to load user.',
        userNotFound: 'User not found.',
        updateFailed: 'Failed to update user.',
        updatedSuccess: 'User updated successfully.',
        unableSave: 'Unable to save user',
        reloadUser: 'Reload user',
        adminRoleLocked: 'Admin role is locked and cannot be changed.',
        newPassword: 'New Password',
        keepCurrentPassword: 'Leave blank to keep current password',
        deleteSelected: 'Delete selected users?',
        deleteSingle: 'Delete this user?',
        deleteManyDesc: 'This will permanently delete',
        deleteManyDescWithCount: 'This will permanently delete {{count}} user(s).',
        actionUndone: 'This action cannot be undone.',
        delete: 'Delete',
      },
      products: {
        title: 'Products',
        subtitle: 'Create, update, and delete product records.',
        loadingTitle: 'Loading products...',
        loadingDescription: 'Fetching the latest product records.',
        loadingSingleTitle: 'Loading product...',
        loadingSingleDescription: 'Retrieving product details.',
        noReadPermission: 'You do not have permission to view products.',
        noWritePermission: 'You do not have permission to add products.',
        noDeletePermission: 'You do not have permission to delete products.',
        noEditPermission: 'You do not have permission to edit products.',
        tourLabel: 'Products tour',
        addTourLabel: 'Add product tour',
        tourIntroTitle: 'Products at a glance',
        tourIntroDescription:
          'Use this page to review the catalog, search by name or filters, and keep product records aligned with current stock.',
        tourIntroHint: 'Start with the list',
        tourToolbarTitle: 'Bulk actions and imports',
        tourToolbarDescription:
          'This toolbar handles bulk selection, exports, imports, and JSON entry so you can update many items faster.',
        tourToolbarHint: 'Manage many items at once',
        tourTableTitle: 'Search, filter, and edit rows',
        tourTableDescription:
          'Use search, type filters, sorting, and row checkboxes to narrow down exactly the products you need.',
        tourTableHint: 'Refine the table',
        addTourIntroTitle: 'Create a product',
        addTourIntroDescription:
          'Use this form to enter the product name, description, pricing, catalog setup, availability, and images before you save.',
        addTourIntroHint: 'Start with the basics',
        addTourBasicsTitle: 'Language, name, description, price, and stock',
        addTourBasicsDescription:
          'Choose the language tab first, then write the product name and description, and enter the price and stock before you move on to the rest of the catalog fields.',
        addTourBasicsHint: 'Write the public copy',
        addTourSpecsTitle: 'Brand and product type',
        addTourSpecsDescription:
          'Choose the brand and product type, then fill the technical fields that apply to this schema.',
        addTourSpecsHint: 'Configure the catalog details',
        addTourAvailabilityTitle: 'Showroom availability',
        addTourAvailabilityDescription:
          'Select the showrooms where this product is available so the catalog matches where customers can find it.',
        addTourAvailabilityHint: 'Choose where it is sold',
        addTourMediaTitle: 'Product images',
        addTourMediaDescription:
          'Upload the main product photos, then reorder them so the strongest image appears first in the gallery.',
        addTourMediaHint: 'Arrange the gallery',
        addTourSaveTitle: 'Save or discard',
        addTourSaveDescription:
          'Use the action bar to save the new product or discard the draft and return to the catalog.',
        addTourSaveHint: 'Finish the form',
        loadFailed: 'Failed to load products.',
        failedTitle: 'Failed to load products',
        productNameRequired: 'Product name is required.',
        categoryRequired: 'Product category is required.',
        brandRequired: 'Product brand is required.',
        requiredSpecField: '{{field}} is required.',
        invalidPrice: 'Price must be a valid positive number.',
        invalidStock: 'Stock must be a valid positive number.',
        createFailed: 'Cannot create product.',
        createdSuccess: 'Product created successfully.',
        deletedSuccess: 'Product deleted successfully.',
        updatedSuccess: 'Product updated.',
        updateFailed: 'Failed to update product.',
        loadSingleFailed: 'Failed to load product.',
        deleteFailed: 'Delete failed.',
        exportFailed: 'Export failed.',
        importFailed: 'Import failed.',
        uploadFailed: 'Upload failed',
        imageUploaded: 'Image uploaded.',
        saveAll: 'Save All',
        addViaJson: 'Add via JSON',
        searchPlaceholder: 'Search products...',
        emptyText: 'No products yet.',
        typeFilter: 'Type',
        settingsTitle: 'Product Settings',
        settingsHint: 'Manage your product details and inventory information',
        productName: 'Product Name',
        productType: 'Product Type',
        productTypeHint: 'Select a type to load its technical specification fields.',
        showroomsTitle: 'Availability',
        showroomsHint: 'Select where this product is available.',
        addShowroom: 'Add showroom',
        showroomLabel: 'Showroom',
        showroomName: 'Showroom name',
        showroomAddress: 'Address',
        showroomPhone: 'Phone',
        showroomEmail: 'Email',
        showroomAvailable: 'Available',
        showroomUnavailable: 'Unavailable',
        removeShowroom: 'Remove showroom',
        showroomsEmpty: 'No showrooms added yet.',
        namePlaceholder: 'Premium Backpack',
        price: 'Price',
        pricePlaceholder: '0.000',
        stock: 'Stock',
        stockPlaceholder: '0',
        specNumberPlaceholder: '0',
        description: 'Description',
        descriptionPlaceholder: 'Describe the product features, materials, and usage.',
        cannotCreate: 'Cannot create product',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        discard: 'Discard',
        addImage: 'Add image',
        imageHint: 'Upload product visuals to improve listing quality.',
        imageLimitHint: '{{current}} / {{count}} images uploaded. You can upload up to {{count}} images.',
        imageLimitReached: 'You can upload up to {{count}} images only.',
        removeImage: 'Remove image',
        imagePreviewAlt: 'preview',
        selectAllProducts: 'Select all products',
        nameCol: 'Name',
        priceCol: 'Price',
        stockCol: 'Stock',
        specsCol: 'Specs',
        specsNone: 'No specs',
        imagesCol: 'Images',
        actionsCol: 'Actions',
        saveChangesAction: 'Save changes',
        savingChangesAction: 'Saving changes',
        bulkSaveSuccess: 'Saved {{count}} product(s).',
        bulkSaveFailed: '{{count}} product(s) could not be saved.',
        bulkDeleteSuccess: 'Deleted {{count}} product(s).',
        bulkDeleteFailed: '{{count}} product(s) could not be deleted.',
        exportedAs: 'Products exported as {{format}}.',
        importComplete: 'Import complete: {{created}} created, {{updated}} updated, {{skipped}} skipped.',
        jsonRequired: 'JSON input is required.',
        jsonObjectOrArray: 'JSON must be an object or an array of objects.',
        invalidJson: 'Invalid JSON format.',
        jsonModalHint: 'Paste valid JSON only. Object or array format is required.',
        jsonPlaceholder: '[{"name":"Product","price":10,"stock":5}]',
        importJson: 'Import JSON',
        importingJson: 'Importing...',
        editProduct: 'Edit product',
        editTitle: 'Edit Product',
        editSubtitle: 'Update product details.',
        unableSave: 'Unable to save product',
        reloadItem: 'Reload product',
        deleteProduct: 'Delete product',
        deleteSelected: 'Delete selected products?',
        deleteSingle: 'Delete this product?',
        deleteManyDesc: 'This will permanently delete',
        deleteManyDescWithCount: 'This will permanently delete {{count}} product(s).',
        actionUndone: 'This action cannot be undone.',
        delete: 'Delete',
        unclassifiedType: 'Unclassified',
        noTechnicalFieldsYet: 'No specific technical fields for this type yet.',
      },
      showrooms: {
        title: 'Showrooms',
        subtitle: 'Manage showroom locations and contact info.',
        listTitle: 'Showrooms',
        listSubtitle: 'Manage showroom locations and contact info.',
        addTitle: 'Add Showroom',
        addSubtitle: 'Create a new showroom location.',
        editTitle: 'Edit Showroom',
        editSubtitle: 'Update showroom details.',
        nameLabel: 'Showroom name',
        nameLabelEn: 'Showroom name (English)',
        nameLabelFr: 'Showroom name (French)',
        addressLabel: 'Address',
        addressLabelEn: 'Address (English)',
        addressLabelFr: 'Address (French)',
        contactLabel: 'Contact',
        actionsLabel: 'Actions',
        statusLabel: 'Status',
        statusActive: 'Active — click to disable',
        statusDisabled: 'Disabled — click to enable',
        statusActiveTitle: 'Visible on the public site',
        statusDisabledTitle: 'Hidden from the public site',
        statusActiveShort: 'Active',
        statusDisabledShort: 'Disabled',
        statusUpdating: 'Updating...',
        activeLabel: 'Active (visible on the public site)',
        activeHelp:
          'Turn this off to hide the showroom from products, the contact page, and the spare-parts page without deleting it.',
        enabledSuccess: 'Showroom is now visible on the public site.',
        disabledSuccess: 'Showroom is now hidden from the public site.',
        phoneLabel: 'Phone',
        emailLabel: 'Email',
        namePlaceholder: 'Main Showroom',
        namePlaceholderEn: 'Main Showroom',
        namePlaceholderFr: 'Showroom principal',
        addressPlaceholder: 'Showroom address',
        addressPlaceholderEn: 'Showroom address',
        addressPlaceholderFr: 'Adresse du showroom',
        phonePlaceholder: '+216 00 000 000',
        addTourLabel: 'Add showroom tour',
        addTourIntroTitle: 'Create a showroom',
        addTourIntroDescription:
          'Use this form to add the showroom name, contact details, and location before you save the new branch.',
        addTourIntroHint: 'Start with the basics',
        addTourBasicsTitle: 'Contact information',
        addTourBasicsDescription:
          'Enter the showroom name, address, phone, and email so customers can reach the location easily.',
        addTourBasicsHint: 'Add the contact details',
        addTourLocationTitle: 'Location preview',
        addTourLocationDescription:
          'Set the latitude and longitude to preview the showroom on the map before you publish it.',
        addTourLocationHint: 'Check the map preview',
        addTourSaveTitle: 'Save or discard',
        addTourSaveDescription:
          'Use the action bar to save the showroom or discard the draft and return to the list.',
        addTourSaveHint: 'Finish the form',
        emailPlaceholder: 'sales@example.com',
        addShowroom: 'Add showroom',
        saveChanges: 'Save Changes',
        saving: 'Saving...',
        discard: 'Discard',
        editShowroom: 'Edit showroom',
        deleteShowroom: 'Move showroom to trash',
        delete: 'Move to Trash',
        deleteSelected: 'Move selected showrooms to trash?',
        deleteManyDescWithCount: '{{count}} showroom(s) will be moved to trash.',
        bulkDeleteSuccess: '{{count}} showroom(s) moved to trash.',
        bulkDeleteFailed: 'Failed to delete {{count}} showroom(s).',
        selectAllShowrooms: 'Select all showrooms',
        selectShowroom: 'Select showroom',
        confirmDelete: 'Move this showroom to trash?',
        confirmDeleteDescription: 'You can restore this showroom later from trash.',
        loadFailed: 'Failed to load showrooms.',
        createFailed: 'Failed to create showroom.',
        updateFailed: 'Failed to update showroom.',
        deleteFailed: 'Failed to delete showroom.',
        createdSuccess: 'Showroom created.',
        updatedSuccess: 'Showroom updated.',
        deletedSuccess: 'Showroom moved to trash.',
        movedToInactiveSuccess:
          'Showroom is still referenced by products, so it was hidden from the public site instead of deleted. You can delete it once the product links are removed.',
        failedTitle: 'Failed to load showrooms',
        searchPlaceholder: 'Search showrooms...',
        emptyText: 'No showrooms yet.',
        nameRequired: 'Showroom name is required.',
        nameEnRequired: 'English showroom name is required.',
        nameFrRequired: 'French showroom name is required.',
        addressEnRequired: 'English showroom address is required.',
        addressFrRequired: 'French showroom address is required.',
        phoneRequired: 'Phone is required.',
        emailRequired: 'Email is required.',
        invalidEmail: 'Enter a valid email address.',
        loading: 'Loading showrooms...',
        loadingTitle: 'Loading showroom...',
        loadingDescription: 'Fetching showroom details.',
        cannotCreate: 'Cannot create showroom',
        unableSave: 'Unable to save showroom',
        reloadItem: 'Reload showroom',
        noReadPermission: 'You do not have permission to view showrooms.',
        noWritePermission: 'You do not have permission to add showrooms.',
        noEditPermission: 'You do not have permission to edit showrooms.',
        noDeletePermission: 'You do not have permission to delete showrooms.',
        mapUnavailableTitle: 'Map preview unavailable',
        mapUnavailableDescription:
          'Google Maps is blocked in this browser. Open the location directly in Google Maps instead.',
        openExternalMap: 'Open in Google Maps',
        unnamed: 'Unnamed',
      },
      team: {
        title: 'Team',
        subtitle: 'Manage team members and their public photos.',
        listTitle: 'Team',
        listSubtitle: 'Manage team members and their public photos.',
        addTitle: 'Add Team Member',
        addSubtitle: 'Create a new team member for the About page.',
        editTitle: 'Edit Team Member',
        editSubtitle: 'Update team member details and image.',
        addTeamMember: 'Add team member',
        nameLabel: 'Full name',
        namePlaceholder: 'Jane Doe',
        genderLabel: 'Gender',
        genderPlaceholder: 'Select gender',
        genderMaleOption: 'Male (Mr.)',
        genderFemaleOption: 'Female (Ms.)',
        roleLabel: 'Rôle',
        rolePlaceholder: 'Role',
        roleEnLabel: 'Role (EN)',
        roleEnPlaceholder: 'Role',
        roleFrLabel: 'Role (FR)',
        roleFrPlaceholder: 'Role',
        sortOrderLabel: 'Sort order',
        dragHint: 'Drag any row to change the public display order. The change saves automatically when you drop it.',
        orderUpdated: 'Team member order updated.',
        orderUpdateFailed: 'Failed to update team member order.',
        photoTitle: 'Member photo',
        photoHint: 'Upload a portrait image for the team section.',
        previewTitle: 'Live preview',
        previewHint: 'This is how the selected member content will look in the admin editor.',
        previewLanguageEnglish: 'English',
        previewLanguageFrench: 'French',
        previewName: 'Team member',
        rolePreview: 'Role',
        uploadImage: 'Upload image',
        uploadHint: 'Drop an image here or click to upload',
        uploadHelper: 'Portrait images work best for the About page carousel.',
        removeImage: 'Remove image',
        imageUploaded: 'Image uploaded.',
        uploading: 'Uploading...',
        uploadFailed: 'Upload failed.',
        photoColumn: 'Photo',
        actionsLabel: 'Actions',
        editMember: 'Edit team member',
        deleteMember: 'Delete team member',
        delete: 'Delete',
        deleteSelected: 'Move selected team members to trash?',
        deleteManyDescWithCount: '{{count}} team member(s) will be moved to trash.',
        bulkDeleteSuccess: '{{count}} team member(s) moved to trash.',
        bulkDeleteFailed: 'Failed to delete {{count}} team member(s).',
        selectAllMembers: 'Select all team members',
        selectMember: 'Select team member',
        confirmDelete: 'Move this team member to trash?',
        confirmDeleteDescription: 'You can restore this team member later from trash.',
        loadFailed: 'Failed to load team members.',
        createFailed: 'Failed to create team member.',
        updateFailed: 'Failed to update team member.',
        deleteFailed: 'Failed to delete team member.',
        createdSuccess: 'Team member created.',
        updatedSuccess: 'Team member updated.',
        deletedSuccess: 'Team member moved to trash.',
        failedTitle: 'Failed to load team members',
        searchPlaceholder: 'Search team members...',
        emptyText: 'No team members yet.',
        nameRequired: 'Team member name is required.',
        genderRequired: 'Team member gender is required.',
        roleRequired: 'Team member role is required.',
        imageRequired: 'Team member photo is required.',
        roleEnRequired: 'English role is required.',
        roleFrRequired: 'French role is required.',
        bioEnRequired: 'English bio is required.',
        bioFrRequired: 'French bio is required.',
        loadingTitle: 'Loading team member...',
        loadingDescription: 'Fetching team member details.',
        cannotCreate: 'Cannot create team member',
        unableSave: 'Unable to save team member',
        reloadItem: 'Reload team member',
        noReadPermission: 'You do not have permission to view team members.',
        noWritePermission: 'You do not have permission to add team members.',
        noEditPermission: 'You do not have permission to edit team members.',
        noDeletePermission: 'You do not have permission to delete team members.',
        unnamed: 'Unnamed',
        addTourLabel: 'Add team member tour',
        addTourIntroTitle: 'Create a team member',
        addTourIntroDescription:
          'Use this form to add the member photo, display name, role details, and sort order before you publish the profile.',
        addTourIntroHint: 'Start with the basics',
        addTourPhotoTitle: 'Member photo',
        addTourPhotoDescription:
          'Upload a portrait image so the member appears with the right visual identity on the About page.',
        addTourPhotoHint: 'Add the photo first',
        addTourDetailsTitle: 'Name and role',
        addTourDetailsDescription:
          'Fill the team member name, gender, sort order, and the role text in both languages.',
        addTourDetailsHint: 'Describe the member',
        addTourPreviewTitle: 'Live preview',
        addTourPreviewDescription:
          'Use the preview card to check how the photo and role text will look on the public site.',
        addTourPreviewHint: 'Verify the final look',
        addTourSaveTitle: 'Save or discard',
        addTourSaveDescription:
          'Use the action bar to save the new member or discard the draft and return to the list.',
        addTourSaveHint: 'Finish the form',
      },
      productTypes: {
        title: 'Product Types',
        subtitle: 'Manage dynamic schemas for product specifications',
        noPermission: 'You do not have permission to manage product types.',
        loadFailed: 'Failed to load product types.',
        typeKeyRequired: 'Type key is required.',
        typeLabelRequired: 'Type label is required.',
        saveFailed: 'Failed to save product type.',
        createdSuccess: 'Product type created.',
        updatedSuccess: 'Product type updated.',
        deleteFailed: 'Failed to delete product type.',
        deletedSuccess: 'Product type moved to trash.',
        uploadFailed: 'Upload failed',
        imageUploaded: 'Image uploaded.',
        typeKeyFormatInvalid:
          'Type key must contain only lowercase letters, digits, and underscores',
        versionInvalid: 'Version must be a positive number',
        typeKeyExists: 'Product type key already exists',
        typeNotFound: 'Product type not found',
        defaultRecreateBlocked: 'Default product types cannot be recreated',
        defaultDeleteBlocked: 'Default product types cannot be deleted',
        typeInUse: 'Product type is currently used by products',
        typeLocked: 'Product type is locked and cannot be deleted',
        lockDeletion: 'Lock deletion',
        unlockDeletion: 'Unlock deletion',
        locked: 'Locked',
        unlocked: 'Unlocked',
        lockEnabled: 'Deletion lock enabled',
        lockDisabled: 'Deletion lock disabled',
        selectTypeToDelete: 'Select a type to delete',
        defaultTypeLabel: {
          unclassified: 'Unclassified',
          forklift: 'Forklift',
          pallet_truck: 'Pallet Truck',
          tractor: 'Tractor',
          stacker: 'Stacker',
        },
        loadingTitle: 'Loading product types...',
        loadingDescription: 'Fetching schema definitions.',
        errorTitle: 'Product type management error',
        availableTypes: 'Available Types',
        selectType: 'Select type',
        new: 'New',
        typeKey: 'Type Key',
        label: 'Label',
        labelEnOptional: 'Label EN (optional)',
        labelFrOptional: 'Label FR (optional)',
        newTypeTourLabel: 'Product type tour',
        newTypeTourIntroTitle: 'Choose or create a product type',
        newTypeTourIntroDescription:
          'Use the list on the left to review existing schema types, lock or unlock deletion, or start a new reusable product type for the catalog.',
        newTypeTourIntroHint: 'Start with the catalog structure',
        newTypeTourBasicsTitle: 'Key, labels, and version',
        newTypeTourBasicsDescription:
          'Set the machine key that powers the schema, write the public label, add the translated labels, and choose a version so future changes stay organized.',
        newTypeTourBasicsHint: 'Define the schema identity',
        newTypeTourImageTitle: 'Type image',
        newTypeTourImageDescription:
          'Upload a banner image so the type is easy to recognize in selectors, cards, and galleries, and use the preview panel to confirm the crop.',
        newTypeTourImageHint: 'Add the visual marker',
        newTypeTourFieldsTitle: 'Technical fields and rules',
        newTypeTourFieldsDescription:
          'Add the technical fields that each product of this type should collect, then open a field to set localization, units, validation rules, and select options.',
        newTypeTourFieldsHint: 'Shape the schema',
        newTypeTourSaveTitle: 'Save or discard',
        newTypeTourSaveDescription:
          'Use the action bar to create or update the type, move it to trash when it is no longer needed, or clear the form and start again.',
        newTypeTourSaveHint: 'Finish the form',
        typeImage: 'Type Image',
        typeImageHint: 'Upload an image for this product type.',
        dragDropTypeImage: 'Drag and drop image here or click to browse',
        uploadTypeImage: 'Upload Image',
        removeTypeImage: 'Remove image',
        imageSettings: 'Image Settings',
        imageRecommendedSize: 'Upload a high-resolution image. Recommended size: 1200x800px.',
        imageFooterHint: 'Image changes are saved when you click Create Type or Update Type.',
        version: 'Version',
        technicalFields: 'Technical Fields',
        addField: 'Add Field',
        noFieldsYet: 'No fields yet for this type.',
        fieldKeyPlaceholder: 'key',
        fieldLabelPlaceholder: 'label',
        fieldLabelEnOptional: 'field label EN (optional)',
        fieldLabelFrOptional: 'field label FR (optional)',
        fieldTypeText: 'text',
        fieldTypeNumber: 'number',
        fieldTypeBoolean: 'boolean',
        fieldTypeSelect: 'select',
        fieldUnitPlaceholder: 'unit',
        fieldMinPlaceholder: 'min',
        fieldMaxPlaceholder: 'max',
        fieldOptionsPlaceholder: 'options (comma separated)',
        required: 'Required',
        remove: 'Remove',
        saving: 'Saving...',
        updateType: 'Update Type',
        createType: 'Create Type',
        newType: 'New Type',
        deleting: 'Moving to trash...',
        deleteType: 'Move Type to Trash',
      },
      spareParts: {
        title: 'Spare Parts',
        subtitle: 'Create, update, and delete spare part records.',
        loadingTitle: 'Loading spare parts...',
        loadingDescription: 'Fetching the latest spare part records.',
        loadingSingleTitle: 'Loading spare part...',
        loadingSingleDescription: 'Retrieving spare part details.',
        noReadPermission: 'You do not have permission to view spare parts.',
        noWritePermission: 'You do not have permission to add spare parts.',
        noDeletePermission: 'You do not have permission to delete spare parts.',
        noEditPermission: 'You do not have permission to edit spare parts.',
        loadFailed: 'Failed to load spare parts.',
        failedTitle: 'Failed to load spare parts',
        nameRequired: 'Spare part name is required.',
        invalidPrice: 'Price must be a valid positive number.',
        invalidStock: 'Stock must be a valid positive number.',
        createFailed: 'Failed to create spare part.',
        createdSuccess: 'Spare part created successfully.',
        deletedSuccess: 'Spare part deleted successfully.',
        updatedSuccess: 'Spare part updated.',
        updateFailed: 'Failed to update spare part.',
        loadSingleFailed: 'Failed to load spare part.',
        deleteFailed: 'Delete failed.',
        exportFailed: 'Export failed.',
        importFailed: 'Import failed.',
        uploadFailed: 'Upload failed',
        imageUploaded: 'Image uploaded.',
        saveAll: 'Save All',
        addViaJson: 'Add via JSON',
        searchPlaceholder: 'Search spare parts...',
        emptyText: 'No spare parts yet.',
        categoryFilter: 'Category',
        settingsTitle: 'Spare Part Settings',
        settingsHint: 'Manage your spare part details and inventory information',
        partName: 'Spare Part Name',
        namePlaceholder: 'Premium Backpack',
        price: 'Price',
        pricePlaceholder: '0.000',
        stock: 'Stock',
        stockPlaceholder: '0',
        description: 'Description',
        descriptionPlaceholder: 'Describe the spare part features, materials, and usage.',
        cannotCreate: 'Cannot create spare part',
        addTourLabel: 'Add spare part tour',
        addTourIntroTitle: 'Create a spare part',
        addTourIntroDescription:
          'Use this form to enter the spare part name, category, pricing, and images before you save the record.',
        addTourIntroHint: 'Start with the basics',
        addTourBasicsTitle: 'Name and description',
        addTourBasicsDescription:
          'Choose the language tab first, then fill the spare part name and description for each language you want to publish.',
        addTourBasicsHint: 'Write the public copy',
        addTourCategoryTitle: 'Category and pricing',
        addTourCategoryDescription:
          'Set the price and stock, then choose the category that best matches the spare part in the catalog.',
        addTourCategoryHint: 'Organize the catalog entry',
        addTourMediaTitle: 'Spare part images',
        addTourMediaDescription:
          'Upload the main images and reorder them so the strongest photo appears first.',
        addTourMediaHint: 'Arrange the gallery',
        addTourSaveTitle: 'Save or discard',
        addTourSaveDescription:
          'Use the action bar to save the spare part or discard the draft and return to the list.',
        addTourSaveHint: 'Finish the form',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        discard: 'Discard',
        addImage: 'Add image',
        imageHint: 'Upload spare part visuals to improve listing quality.',
        imageLimitHint: '{{current}} / {{count}} images uploaded. You can upload up to {{count}} images.',
        imageLimitReached: 'You can upload up to {{count}} images only.',
        removeImage: 'Remove image',
        imagePreviewAlt: 'preview',
        selectAllParts: 'Select all spare parts',
        nameCol: 'Name',
        priceCol: 'Price',
        stockCol: 'Stock',
        imagesCol: 'Images',
        actionsCol: 'Actions',
        saveChangesAction: 'Save changes',
        savingChangesAction: 'Saving changes',
        bulkSaveSuccess: 'Saved {{count}} spare part(s).',
        bulkSaveFailed: '{{count}} spare part(s) could not be saved.',
        bulkDeleteSuccess: 'Deleted {{count}} spare part(s).',
        bulkDeleteFailed: '{{count}} spare part(s) could not be deleted.',
        exportedAs: 'Spare parts exported as {{format}}.',
        importComplete: 'Import complete: {{created}} created, {{updated}} updated, {{skipped}} skipped.',
        jsonRequired: 'JSON input is required.',
        jsonObjectOrArray: 'JSON must be an object or an array of objects.',
        invalidJson: 'Invalid JSON format.',
        jsonModalHint: 'Paste valid JSON only. Object or array format is required.',
        jsonPlaceholder: '[{"name":"Spare part","price":10,"stock":5}]',
        importJson: 'Import JSON',
        importingJson: 'Importing...',
        editPart: 'Edit spare part',
        editTitle: 'Edit Spare Part',
        editSubtitle: 'Update spare part details.',
        unableSave: 'Unable to save spare part',
        reloadItem: 'Reload spare part',
        deletePart: 'Delete spare part',
        deleteSelected: 'Delete selected spare parts?',
        deleteSingle: 'Delete this spare part?',
        deleteManyDesc: 'This will permanently delete',
        deleteManyDescWithCount: 'This will permanently delete {{count}} spare part(s).',
        actionUndone: 'This action cannot be undone.',
        delete: 'Delete',
      },
      sparePartCategories: {
        title: 'Spare Part Categories',
        subtitle: 'Create and organize spare part category labels.',
        loadingTitle: 'Loading spare part categories...',
        loadingDescription: 'Preparing the category manager.',
        refreshing: 'Refreshing categories...',
        listTitle: 'Category Library',
        items: 'categories',
        newCategory: 'New category',
        addCategory: 'Add category',
        empty: 'No categories yet.',
        newDraft: 'New category draft',
        editTitle: 'Edit category',
        createTitle: 'Create category',
        editHint: 'Update the label and lock state for this category.',
        createHint: 'Add a new reusable category for spare parts.',
        label: 'Label',
        required: 'Required',
        labelHint: 'This is the category name shown in the manager and used to build the key.',
        labelEnOptional: 'Label EN (optional)',
        labelFrOptional: 'Label FR (optional)',
        key: 'Key',
        locked: 'Locked',
        loadFailed: 'Failed to load spare part categories.',
        noPermission: 'You do not have permission to manage spare part categories.',
        labelRequired: 'Category label is required.',
        labelEnRequired: 'English category label is required.',
        labelFrRequired: 'French category label is required.',
        saveFailed: 'Failed to save spare part category.',
        createdSuccess: 'Spare part category created.',
        updatedSuccess: 'Spare part category updated.',
        lockedDeleteBlocked: 'Locked categories cannot be deleted.',
        deleteFailed: 'Failed to delete spare part category.',
        deletedSuccess: 'Spare part category deleted.',
        deleteTitle: 'Delete this category?',
        deleteDescription: 'This action will move the category to trash if it is not locked or in use.',
        itemCount: '{{count}} spare part(s)',
      },
    },
  },
  fr: {
    common: {
      language: 'Langue',
      translationLanguage: 'Langue de traduction',
      englishShort: 'EN',
      frenchShort: 'FR',
      home: 'Accueil',
      backHome: "Retour à l'accueil",
      pageNotFoundMessage: 'La page que vous recherchez est introuvable ou a été déplacée.',
      general: 'Général',
      yes: 'Oui',
      no: 'Non',
      noImage: "Pas d'image",
      all: 'Tous',
      cancel: 'Annuler',
      previous: 'Précédent',
      next: 'Suivant',
      saving: 'Enregistrement...',
      related: 'Liés',
      itemsCount: '{{count}} éléments',
      showMore: 'Afficher plus',
      showLess: 'Afficher moins',
      website: 'Site web',
      unknown: 'Inconnu',
      product: 'Machine',
      loading: 'Chargement...',
      sparePart: 'Pièce de rechange',
      priceOnRequest: 'Prix sur demande',
      errorLoadingData: 'Aucune machine disponible pour le moment',
      retry: 'actualiser',
    },
    mailTemplate: {
      companyLine: 'ETC Company | Essid Trading Company | Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
      registrationLine: 'ETC Company | Essid Trading Company | Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
      privacyPolicyLink: 'Politique de confidentialité',
      contactComplianceNotice:
        'AVIS : Ce message est destiné uniquement au destinataire et peut contenir des informations confidentielles ; toute utilisation non autorisée est interdite. Veuillez consulter notre Politique de confidentialité relative au traitement des données.',
      contactComplianceReply: 'Répondez à ce message pour poursuivre la conversation avec le client.',
      contactComplianceRegistration: 'ETC Company | Essid Trading Company - informations d’immatriculation disponibles sur demande | Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
      contactEyebrow: 'ETC Company',
      contactTitle: 'Nouvelle demande de contact',
      contactIntro: 'Un visiteur a soumis le formulaire de contact du site.',
      contactPreheaderVisitor: 'Nouvelle demande de contact depuis le site',
      contactPreheaderFrom: 'Nouvelle demande de contact de {{name}}',
      contactSubjectPrefix: 'Nouvelle demande de contact',
      contactSubjectWithSubject: 'Nouvelle demande de contact : {{subject}}',
      contactSubjectFrom: 'Nouvelle demande de contact de {{name}}',
      contactTextTitle: 'Nouvelle demande de contact de {{name}}',
      contactTextTitleVisitor: 'Nouvelle demande de contact depuis le site',
      contactTextSubject: 'Objet : {{subject}}',
      contactTextEmail: 'E-mail : {{email}}',
      contactTextPhone: 'Téléphone : {{phone}}',
      contactTextInquiry: 'Type de demande : {{inquiryType}}',
      contactLabelName: 'Nom',
      contactLabelSubject: 'Objet',
      contactLabelEmail: 'E-mail',
      contactLabelPhone: 'Téléphone',
      contactLabelInquiry: 'Type de demande',
      contactLabelMessage: 'Message',
      contactFieldEmpty: 'Non renseigné',
      contactValueFallback: 'Visiteur du site',
      resetEyebrow: 'ETC Company',
      resetTitle: 'Réinitialiser votre mot de passe',
      resetIntro: 'Vous avez demandé la réinitialisation de votre mot de passe pour votre compte ETC.',
      resetPreheader: 'Demande de réinitialisation du mot de passe',
      resetSubject: 'Réinitialiser votre mot de passe',
      resetBodyPrompt: 'Cliquez sur le bouton ci-dessous pour créer un nouveau mot de passe.',
      resetCta: 'Réinitialiser le mot de passe',
      resetExpireNote: 'Ce lien expire dans 1 heure. Si vous n’êtes pas à l’origine de cette demande, vous pouvez ignorer cet e-mail en toute sécurité.',
      resetTextTitle: 'Vous avez demandé la réinitialisation de votre mot de passe.',
      resetTextLink: 'Réinitialisez votre mot de passe en utilisant ce lien : {{url}}',
      resetTextExpire: 'Ce lien expire dans 1 heure.',
      resetTextIgnore: 'Si vous n’êtes pas à l’origine de cette demande, vous pouvez ignorer cet e-mail.',
      quoteEyebrow: 'ETC Company',
      quoteTitle: 'Demande de devis {{number}}',
      quoteIntro: 'Votre demande de devis a été examinée et convertie en résumé de demande de devis.',
      quotePreheader: 'Commande {{number}}',
      quoteSubject: 'Demande de devis {{number}}',
      quoteTextTitle: 'Demande de devis {{number}}',
      quoteTextCustomer: 'Client : {{name}}',
      quoteTextSubtotal: 'Sous-total : {{amount}} {{currency}}',
      quoteTextQuotedSubtotal: 'Sous-total devis : {{amount}} {{currency}}',
      quoteTextInterest: 'Intérêt : {{percent}}% = {{amount}} {{currency}}',
      quoteTextTva: 'TVA : {{percent}}% = {{amount}} {{currency}}',
      quoteTextFinalTotal: 'Total final : {{amount}} {{currency}}',
      quoteTextNotes: 'Notes : {{note}}',
      quoteTableItem: 'Article',
      quoteTableQty: 'Qté',
      quoteTableUnit: 'Unité',
      quoteTableTotal: 'Total',
      quoteTableItemKind: 'produit',
      quoteTableItemKindFallback: 'article',
      quoteTableItemNameFallback: 'Article',
      quoteTableEmpty: 'Aucun article',
      quoteLabelSubtotal: 'Sous-total',
      quoteLabelQuotedSubtotal: 'Sous-total devis',
      quoteLabelInterest: 'Intérêt',
      quoteLabelTva: 'TVA',
      quoteLabelFinalTotal: 'Total final',
      quoteLabelCustomer: 'Client',
      quoteNoteLabel: 'Note client',
      quoteInterestLine: 'Intérêt : {{percent}}% ({{amount}} {{currency}})',
      quoteFooter: 'Cette demande de devis a été générée depuis le formulaire de demande de devis du site ETC. Si vous souhaitez y apporter des modifications, répondez à cet e-mail.',
      rejectionTitle: 'Demande de devis {{number}} refusée',
      rejectionIntro: 'La demande a été examinée et refusée.',
      rejectionPreheader: 'Commande {{number}} refusée',
      rejectionSubject: 'Demande de devis {{number}} refusée',
      rejectionTextTitle: 'La commande {{number}} a été refusée.',
      rejectionTextCustomer: 'Client : {{name}}',
      rejectionTextReason: 'Motif : {{reason}}',
      rejectionTextReply: 'Si vous souhaitez discuter de cette demande, merci de répondre à cet e-mail.',
      rejectionLabelCustomer: 'Client',
      rejectionLabelReason: 'Motif',
      rejectionFooter: 'Si vous souhaitez discuter de cette demande, merci de répondre à cet e-mail.',
      inquiryProducts: 'Machines',
      inquirySpareParts: 'Pièces de rechange',
      inquiryAfterSales: 'Support après-vente',
      inquiryOther: 'Autre',
      previewSampleItemName: 'Pneu de chariot élévateur',
      previewSampleCustomer: 'Sarah Johnson',
      previewSampleContactName: 'Sarah Johnson',
      previewSampleContactEmail: 'sarah@example.com',
      previewSampleContactSubject: 'Demande de tarif',
      previewSampleContactMessage: 'Bonjour, je souhaite connaître la disponibilité et le prix pour un jeu de pneus de chariot élévateur.',
      previewSampleQuoteNote: 'Merci de confirmer la disponibilité de livraison pour la semaine prochaine.',
    },
    promoNotice: {
      title: 'Les promotions sont en ligne',
      description: 'Consultez les offres en vedette et les promotions actives au même endroit.',
      action: 'Voir les promotions',
      dismiss: 'Fermer',
      close: 'Fermer la notification',
    },
    components: {
      imageUpload: {
        chooseImage: 'Choisir une image',
        dragDropLabel: 'Glissez-déposez une image ici, ou cliquez pour choisir',
        invalidImageType: 'Veuillez choisir un fichier image.',
        maxFileSizeLabel: 'Taille maximale du fichier : {{maxSize}}',
        maxFileSizeExceeded: "L'image est trop volumineuse. La taille maximale autorisée est {{maxSize}}.",
        optimizedUploadHint: 'Les images sont optimisées automatiquement avant le téléversement.',
        cannotLoadCurrentImage: "Impossible de charger l'image actuelle.",
        canvasNotAvailable: 'Canvas indisponible.',
        imageSizeNotReady: "La taille de l'image n'est pas prête.",
        failedRenderImage: "Échec du rendu de l'image éditée.",
        loading: 'Chargement...',
        edit: 'Modifier',
        currentImageAlt: 'Actuelle',
        title: 'Téléversement image',
        processing: 'Traitement...',
        reposition: 'Repositionner',
        cropProfilePhoto: 'Rogner la photo de profil',
        dragAdjustZoom: "Déplacez l'image et ajustez le zoom.",
        closeEditor: "Fermer l'éditeur d'image",
        close: 'Fermer',
        editPreviewAlt: "Aperçu d'édition",
        zoom: 'Zoom',
        reset: 'Réinitialiser',
        uploading: 'Téléversement...',
        applyCrop: 'Appliquer le rognage',
      },
      customNumberInput: {
        increaseValue: 'Augmenter la valeur',
        decreaseValue: 'Diminuer la valeur',
      },
      dataTable: {
        searchPlaceholder: 'Rechercher...',
        emptyText: 'Aucune donnée trouvée.',
        resultsCount: '{{count}} résultat(s)',
        updatingResults: 'Mise à jour des résultats du tableau',
        updating: 'Mise à jour...',
        tryAdjustingSearch: "Essayez d'ajuster votre recherche.",
        createNewItem: 'Créez un nouvel élément pour commencer.',
        clearSearch: 'Effacer la recherche',
        pageOf: 'Page {{page}} sur {{total}}',
        rows: 'Lignes :',
        prev: 'Préc.',
        next: 'Suiv',
      },
      toolbar: {
        selectedCount: '{{count}} sélectionné(s)',
        saveAll: 'Tout enregistrer',
        deleteSelected: 'Supprimer la sélection',
        pasteJson: 'Coller JSON',
        saving: 'Enregistrement...',
        deleting: 'Suppression...',
        clear: 'Effacer',
        exportCsv: 'Exporter CSV',
        exportingCsv: 'Export CSV...',
        exportJson: 'Exporter JSON',
        exportingJson: 'Export JSON...',
        importCsvJson: 'Importer CSV/JSON',
        importing: 'Import en cours...',
      },
      confirmModal: {
        title: "Confirmer l'action",
        description: 'Voulez-vous vraiment continuer ?',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        processing: 'Traitement...',
      },
      feedback: {
        loadingTitle: 'Chargement...',
        loadingDescription: 'Veuillez patienter pendant la recuperation des données.',
        errorTitle: 'Une erreur est survenue',
        errorDescription: 'Une erreur inattendue est survenue.',
        tryAgain: 'Reessayer',
        emptyTitle: 'Aucune donnée trouvee',
        emptyDescription: 'Aucun enregistrement à afficher.',
      },
      tour: {
        start: 'Démarrer la visite',
        noGuide: 'Aucun guide disponible',
        badge: 'Visite',
        skip: 'Ignorer la visite',
        back: 'Précédent',
        next: 'Suivant',
        finish: 'Terminer',
        close: 'Fermer la visite',
        stepOf: 'Étape {{step}} sur {{total}}',
      },
    },
    header: {
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu',
      nav: {
        home: 'Accueil',
        about: 'À propos',
        services: 'Services',
        promotions: 'Promotions',
        products: 'Machines',
        spareParts: 'Pièces de rechange',
        contact: 'Contact',
      },
      session: 'Session...',
      menu: 'Menu',
      cart: {
        title: 'Panier',
        items: 'articles',
        item: 'article',
        qty: 'Qt',
        total: 'Total',
        emptyTitle: 'Votre panier est vide',
        emptyText: 'Ajoutez des machines pour les voir ici.',
        viewCart: 'Voir le panier',
        continue: 'Continuer',
        requestHistory: 'Historique des demandes',
      },
      account: {
        profileSettings: 'Paramètres du profil',
        requestHistory: 'Historique des demandes',
        logout: 'Déconnexion',
      },
      auth: {
        login: 'Connexion',
        signup: 'Inscription',
      },
    },
    titlebar: {
      routes: {
        about: 'À propos',
        services: 'Services',
        promotions: 'Promotions',
        contact: 'Contact',
        privacy: 'Confidentialité',
        terms: 'Conditions',
        legal: 'Mentions légales',
        products: 'Machines',
        productCategories: 'Catégories de machines',
      productDetails: 'Détails de la machine',
        spareParts: 'Pièces de rechange',
        sparePartDetails: 'Détails de la pièce',
        account: 'Mon compte',
        cart: 'Panier',
        login: 'Connexion',
        signup: 'Inscription',
        forgotPassword: 'Mot de passe oublié',
        resetPassword: 'Réinitialiser le mot de passe',
        notFound: 'Page introuvable',
      },
    },
    footer: {
      logoAlt: 'ETC Company',
      brandText:
        'Chez ETC, nous sommes là pour vous faire économiser sur de nouveaux chariots élévateurs, gerbeurs et transpalettes de qualité.',
      contactTeam: 'Contactez notre équipe',
      phone: 'Téléphone',
      email: 'E-mail',
      headquarters: 'Siège',
      headquartersAddress: 'Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
      showroom: 'Showroom',
      showroomAddress: 'Sur GP1, 2 Oued Zroud, 2014 Mgrine El Riadh 8000 Nabeul - Tunisie',
      workHours: 'Horaire de travail',
      weekdayHours: 'Lundi au vendredi 8:00 - 18:00',
      saturdayHours: 'Samedi 8:00 - 12:00',
      copyrights: 'Copyrights',
      rights: 'Tous droits réservés par ETC.',
      developedBy: 'Développé par Vizora',
      facebook: 'Facebook',
      instagram: 'Instagram',
      simpleRights: 'ETC Company. Tous droits réservés.',
      simpleMadeBy: 'Réalisé par Vizora',
    },
    legalPages: {
      privacy: {
        path: '/privacy',
        metaTitle: 'Politique de confidentialité',
        metaDescription:
          'Lisez comment ETC Company collecte, utilise, divulgue, conserve, transfère et protège les données personnelles lorsque Vous utilisez le Service.',
        eyebrow: 'Confidentialité',
        title: 'Politique de confidentialité',
        description:
          'La présente Politique de confidentialité décrit Nos politiques et procédures concernant la collecte, l’utilisation et la divulgation de Vos informations lorsque Vous utilisez le Service.',
        lastUpdatedLabel: 'Mise à jour',
        lastUpdated: '3 mai 2026',
        emailLabel: 'E-mail',
        phoneLabel: 'Téléphone',
        contactTitle: 'Contactez-nous',
        nextTitle: 'Questions sur la confidentialité ?',
        nextDescription:
          'Si vous avez des questions concernant la présente Politique de confidentialité, vous pouvez contacter ETC Company par e-mail ou par téléphone.',
        contactLink: 'Contactez-nous',
        sections: PRIVACY_POLICY_SECTIONS_FR,
      },
      terms: {
        path: '/terms',
        metaTitle: 'Conditions d’utilisation',
        metaDescription:
          'Consultez les conditions du site ETC Company concernant les comptes, devis, informations machines, commandes et usages autorisés.',
        eyebrow: 'Conditions',
        title: 'Conditions d’utilisation',
        description:
          'Ces conditions encadrent l’accès au site ETC Company et l’utilisation des fonctionnalités en ligne, notamment le catalogue, les espaces compte, les paniers et les demandes de devis.',
        lastUpdatedLabel: 'Mise à jour',
        lastUpdated: '3 mai 2026',
        emailLabel: 'Email',
        phoneLabel: 'Téléphone',
        contactTitle: 'Contact commercial',
        nextTitle: 'Question sur un devis ?',
        nextDescription:
          'Les conditions commerciales relatives aux équipements, pièces, livraisons, garanties et paiements peuvent être confirmées dans un devis, une facture ou un accord écrit.',
        contactLink: 'Contacter la vente',
        sections: [
          {
            title: 'Utilisation du site',
            paragraphs: [
              'Vous acceptez d’utiliser le site à des fins légales, professionnelles et informatives. Vous ne devez pas compromettre la sécurité du site, tenter un accès non autorisé, transmettre des informations trompeuses ou utiliser le site d’une manière pouvant perturber le service.',
              'ETC Company peut mettre à jour, suspendre ou limiter l’accès à certaines parties du site pour des raisons de maintenance, de sécurité ou d’activité.',
            ],
          },
          {
            title: 'Comptes et demandes',
            paragraphs: [
              'Certaines fonctionnalités peuvent nécessiter un compte ou des coordonnées. Vous êtes responsable de la confidentialité de vos identifiants et de l’exactitude des informations transmises via votre compte ou vos demandes de devis.',
              'ETC Company peut examiner, accepter, refuser, archiver ou suivre les demandes de devis selon la disponibilité des machines et les exigences commerciales.',
            ],
          },
          {
            title: 'Informations machines',
            paragraphs: [
              'Les descriptions, spécifications, images, compatibilités, prix, promotions et disponibilités sont fournis à titre indicatif. Ils peuvent évoluer sans préavis et doivent être confirmés avant tout achat ou décision opérationnelle.',
              'Les images et informations techniques peuvent différer de la configuration finale, des accessoires, de l’état du stock ou des mises à jour fournisseur.',
            ],
          },
          {
            title: 'Devis, commandes et paiements',
            paragraphs: [
              'L’envoi d’un panier, d’un formulaire de contact ou d’une demande de devis ne constitue pas à lui seul une vente ferme. Une transaction est confirmée uniquement lorsque ETC Company émet et accepte le document commercial ou l’accord écrit applicable.',
              'Les conditions de paiement, livraison, installation, garantie et service après-vente peuvent varier selon la machine, l’état du stock, le profil client et la destination.',
            ],
          },
          {
            title: 'Propriété intellectuelle',
            paragraphs: [
              'Le site, les éléments de marque, textes, images, présentations machines, interfaces et autres contenus appartiennent à ETC Company ou sont utilisés avec l’autorisation de fournisseurs et partenaires.',
              'Vous ne pouvez pas copier, reproduire, modifier, extraire, distribuer ou réutiliser le contenu du site à des fins commerciales sans autorisation écrite préalable.',
            ],
          },
          {
            title: 'Responsabilité',
            paragraphs: [
              'ETC Company s’efforce de maintenir les informations du site exactes et disponibles, sans garantir que le site sera toujours ininterrompu, sans erreur ou parfaitement à jour.',
              'Dans les limites permises par la loi applicable, ETC Company n’est pas responsable des pertes indirectes, pertes d’activité ou décisions prises uniquement sur la base d’informations non confirmées du site.',
            ],
          },
        ],
      },
      legal: {
        path: '/legal',
        metaTitle: 'Mentions légales',
        metaDescription:
          'Mentions légales d’ETC Company, incluant les coordonnées de l’éditeur, la responsabilité du site et la propriété des contenus.',
        eyebrow: 'Mentions légales',
        title: 'Mentions légales',
        description:
          'Cette page identifie l’éditeur du site ETC Company et résume les informations légales relatives aux contenus et coordonnées du site.',
        lastUpdatedLabel: 'Mise à jour',
        lastUpdated: '3 mai 2026',
        emailLabel: 'Email',
        phoneLabel: 'Téléphone',
        contactTitle: 'Contact société',
        nextTitle: 'Besoin d’informations officielles ?',
        nextDescription:
          'Pour les informations d’immatriculation, documents fournisseur ou demandes administratives, contactez directement ETC Company.',
        contactLink: 'Demander les détails',
        sections: [
          {
            title: 'Éditeur du site',
            paragraphs: [
              'Ce site est édité par ETC Company, également connue sous le nom Essid Trading Company, société tunisienne qui accompagne les clients professionnels avec des équipements de manutention, des pièces de rechange et un support opérationnel.',
            ],
            items: [
              'Siège: Avenue El Arbi Zarrouk, 8000 Nabeul - Tunisie',
              'Showroom: Sur GP1, 2 Oued Zroud, 2014 Mgrine El Riadh 8000 Nabeul - Tunisie',
              'Email: sales@etc.tn',
              'Téléphone: +216 26 363 025 / +216 72 363 000',
            ],
          },
          {
            title: 'Responsabilité de publication',
            paragraphs: [
              'Le site est géré par ETC Company pour présenter ses machines, services, canaux de contact, demandes de devis et fonctionnalités de compte client.',
              'Les demandes relatives à la publication, correction, suppression ou aux informations administratives peuvent être envoyées à l’adresse email indiquée sur cette page.',
            ],
          },
          {
            title: 'Hébergement et exploitation technique',
            paragraphs: [
              'Le site est hébergé et exploité au moyen de l’infrastructure technique sélectionnée par ETC Company et ses prestataires techniques.',
              'Pour des raisons de sécurité, de maintenance et de continuité, les prestataires d’hébergement ou techniques peuvent évoluer sans préavis.',
            ],
          },
          {
            title: 'Propriété des contenus',
            paragraphs: [
              'Sauf mention contraire, les contenus du site, notamment textes, mises en page, présentations machines, images, graphismes, logos et interfaces, appartiennent à ETC Company ou sont utilisés avec autorisation.',
              'Les noms fournisseurs, noms machines, marques et logos restent la propriété de leurs titulaires respectifs.',
            ],
          },
          {
            title: 'Exactitude des informations',
            paragraphs: [
              'ETC Company met en œuvre des efforts raisonnables pour maintenir les informations du site à jour. Les détails machines, stocks, prix, promotions et informations techniques restent soumis à confirmation.',
              'Les contenus du site ne remplacent pas les documents commerciaux formels, documentations fournisseur, conditions de garantie, factures ou accords signés.',
            ],
          },
          {
            title: 'Règles applicables',
            paragraphs: [
              'L’utilisation du site et les relations commerciales avec ETC Company sont soumises aux lois applicables ainsi qu’aux accords écrits ou documents commerciaux émis pour chaque transaction.',
              'Tout litige non résolu peut être traité par les autorités ou juridictions compétentes selon les règles applicables.',
            ],
          },
        ],
      },
    },
    home: {
      hero: {
        eyebrow: 'Machines',
        titleLine1: 'Notre Gamme',
        titleLine2: 'De Machines',
        prevMedia: 'Média précédent',
        nextMedia: 'Média suivant',
        completeCollection: 'Collection compléte',
        fuelElectric: 'Électrique',
        fuelDiesel: 'Diesel',
        fuelLpg: 'GPL',
        leadTimeSingle: '{{count}} jours',
        leadTimeRange: '{{min}}-{{max}} jours',
        noSlidesAvailable: 'Aucune carte disponible',
      },
      services: {
        eyebrow: 'Services',
        titleLine1: 'Vos besoins',
        titleLine2: 'notre priorité',
        sideNote: 'Des solutions de précision conçues pour une infrastructure industrielle moderne.',
        discoverMore: 'Découvrir plus',
      },
      cta: {
        eyebrow: 'Intelligence Industrielle',
        titleLine1: 'Contactez-nous',
        titleLine2: 'Dès maintenant',
        description:
          "Que vous recherchiez des informations sur nos derniers modèles, des contrats de financement ou des pièces de rechange, nos équipes d'experts peuvent vous aider.",
        button: 'Contactez-nous',
        imageAlt: 'Équipement ETC',
      },
      catalog: {
        eyebrow: 'Catalogue',
        title: 'Conçu pour le travail réel en entrepôt',
        viewAll: 'Voir le catalogue',
        explore: 'Explorer',
      },
      showcase: {
        prevSlide: 'Diapositive précédente',
        nextSlide: 'Diapositive suivante',
      },
      imageParallax: {
        eyebrow: 'Vue terrain',
        titleLine1: 'Conçu pour la',
        titleLine2: 'réalité industrielle',
        description:
          'Des systèmes de manutention haute performance, adaptés aux environnements exigeants et à la fiabilité à long terme.',
      },
      videoBanner: {
        eyebrow: 'Opérations terrain',
        titleLine1: 'La productivité',
        titleLine2: 'sur tous les terrains',
        description:
          'Des machines performantes, un support fiable et une exécution rapide pour les opérations industrielles modernes.',
      },
      promotions: {
        bannerEyebrow: 'Promotions',
        bannerTitle: 'Voir les offres en cours',
        bannerDescription: "Consultez les promotions actives tant qu'elles sont encore disponibles.",
        bannerButton: 'Voir les promotions',
        eyebrow: 'Offres et promos',
        titleLine1: 'Offres',
        titleLine2: 'limitées',
        description:
          "Les offres actives sont mises en avant ici tant qu'elles sont disponibles, afin de vous aider à agir rapidement sur les meilleures opportunités.",
        productLabel: 'Machine',
        sparePartLabel: 'Pièce de rechange',
        quoteOnRequest: 'Devis sur demande',
        tailoredOffer: 'Disponible pendant la promotion',
        viewOffer: "Voir l'offre",
        emptyTitle: 'Aucune offre active pour le moment',
        emptyDescription:
          "Marquez une machine ou une pièce de rechange comme mise en avant dans l'administration et il apparaîtra ici tant que l'offre est active.",
      },
    },
    servicesPage: {
      items: [
        {
          description:
            "Nous ne vendons pas seulement une marque ; nous vendons une solution adaptée aux exigences de poids et de terrain. Notre inventaire est sélectionné pour équilibrer durabilité et accessibilité.\n\nL'avantage AXOR : en développant notre marque propre, AXOR by Essid, nous éliminons la \"taxe de marque\" des importations classiques. Vous obtenez la même capacité de levage et la même fiabilité hydraulique sans payer pour un logo.\n\nPolyvalence des marques : nous maintenons des partenariats actifs avec des leaders mondiaux comme Niuli et JAC. Cela nous permet de proposer un catalogue par niveau, des transpalettes manuels pour le stockage léger aux chariots thermiques lourds pour un usage industriel, à des niveaux de prix qui préservent votre trésorerie.",
        },
        {
          description:
            "Dans le monde des machines lourdes, la vente n'est que le début. Une machine à l'arrêt est une responsabilité.\n\nAgilité technique : notre structure de service est conçue pour contourner la bureaucratie. Lorsqu'un joint hydraulique lâche ou qu'un moteur remonte un code, notre prise de décision est locale et rapide.\n\nInfrastructure pièces : nous ne faisons pas que « commander » des pièces à votre appel ; nous maintenons un stock stratégique de composants à forte usure. Notre objectif est que l'après-vente signifie un technicien sur site avec la bonne pièce, et non un client qui attend un manifeste d'expédition de six semaines.",
        },
        {
          description:
            "La maintenance préventive protège votre disponibilité avant qu’une panne n’apparaisse. Nous organisons chaque intervention selon votre rythme d’exploitation pour limiter l’impact opérationnel.\n\nInspections planifiées : nous contrôlons les systèmes de levage, les circuits hydrauliques, les points de sécurité et le comportement batterie/recharge pour détecter l’usure à temps.\n\nRemplacement des pièces d’usure : les composants à forte sollicitation sont remplacés de façon anticipée avec des pièces compatibles pour maintenir des performances stables.\n\nInterventions correctives : lorsqu’un incident survient, nos techniciens diagnostiquent rapidement, appliquent la bonne correction et remettent l’équipement en service avec un compte rendu clair pour votre équipe.",
        },
      ],
    },
    productsPage: {
      hero: {
        eyebrow: 'Catalogue machines',
        title: 'Découvrez des équipements conçus pour un débit quotidien',
        description:
          'Comparez des gerbeurs manuels et électriques dans un catalogue structuré. Filtrez par catégorie et recherchez rapidement.',
        totalProducts: 'Total machines',
        availableInCatalog: 'Disponibles au catalogue',
        categories: 'Catégories',
        structuredFiltering: 'Filtrage structuré',
        focus: 'Focus',
        warehouseReady: "Prêt pour l'entrepôt",
        reliabilityPerformance: 'Fiabilité et performance pratique',
      },
      categoriesHero: {
        titleLine1: 'Trouvez votre prochain',
        titleLine2: 'machine par catégorie',
        description:
          'Parcourez toutes les familles de machines au même endroit et accédez directement aux machines adaptées à votre usage, vos spécifications et votre budget.',
      },
      filters: {
        eyebrow: 'Parcourir',
        title: 'Filtrer les machines',
        showing: 'Affichage',
        of: 'sur',
        products: 'machines',
        search: 'Recherche',
        searchPlaceholder: 'Nom ou description',
        category: 'Catégorie',
      },
      grid: {
        noMatchesTitle: 'Aucune machine ne correspond à vos filtres',
        noMatchesText: 'Essayez une autre recherche ou catégorie.',
        viewDetails: 'Voir les détails',
      },
      support: {
        eyebrow: "Besoin d'orientation",
        title: "Obtenez de l'aide pour choisir le bon équipement",
        description:
          'Partagez vos besoins de levage et notre équipe recommandera la meilleure configuration.',
        contactSales: 'Contacter ventes',
      },
    },
    sparePartsPage: {
      hero: {
        eyebrow: 'Pièces de rechange',
        title: 'Gardez votre flotte opérationnelle sans interruption',
        titleLine1: 'Gardez votre flotte opérationnelle',
        titleLine2: 'sans interruption',
        description:
          'Parcourez des composants compatibles pour des remplacements rapides. Filtrez et trouvez vos pièces plus vite.',
        totalParts: 'Total pièces',
        readyInCatalog: 'Disponibles au catalogue',
        categories: 'Catégories',
        organizedByUseCase: 'Organisées par usage',
        priority: 'Priorité',
        continuity: 'Continuité',
        minimalInterruption: "Conçu pour un minimum d'interruption",
      },
      filters: {
        eyebrow: 'Parcourir',
        title: 'Filtrer les pièces',
        showing: 'Affichage',
        of: 'sur',
        parts: 'pièces',
        search: 'Recherche',
        searchPlaceholder: 'Nom ou description',
        category: 'Catégorie',
      },
      grid: {
        addedToCart: 'ajouté au panier.',
        noMatchesTitle: 'Aucune pièce ne correspond à vos filtres',
        noMatchesText: 'Essayez une autre recherche ou catégorie.',
        addToCart: 'Ajouter au panier',
        viewDetails: 'Voir les détails',
      },
      support: {
        eyebrow: 'Support rapide',
        title: 'Vous ne trouvez pas la bonne pièce ?',
        description:
          'Partagez les détails de votre équipement et nous vous aiderons à trouver la pièce compatible rapidement.',
        requestAssistance: "Demander de l'aide",
      },
    },
    cartPage: {
      eyebrow: 'Panier',
      title: 'Votre panier',
      inCart: 'dans votre panier',
      clearCart: 'Vider le panier',
      emptyTitle: 'Votre panier est vide',
      emptyText: 'Ajoutez des machines du catalogue pour préparer votre commande.',
      browseProducts: 'Voir les machines',
      qty: 'Qt',
      removeItem: 'Supprimer article',
      summary: 'Résumé',
      requestOverview: 'Aperçu de la demande',
      product: 'Machine',
      action: 'Action',
      items: 'Articles',
      total: 'Total',
      lineTotal: 'Total ligne',
      pricesHiddenNote: 'Les prix sont masqués pour le moment. Demandez un devis pour obtenir le tarif.',
      heroSubtitle:
        'Vérifiez vos articles, ajoutez une note, puis envoyez une demande de devis plus soignée et cohérente avec le reste du site.',
      noteLabel: 'Note pour le devis',
      notePlaceholder: 'Ajoutez ici des notes de livraison, de stock ou de commande...',
      requestQuote: 'Demander un devis',
      requestingQuote: 'Envoi de la demande...',
      loginToRequest: 'Connectez-vous pour envoyer la demande de devis.',
      requestSuccess: 'Demande de devis {{requestNumber}} envoyée avec succès.',
      requestFailed: "Échec de l'envoi de la demande de devis",
      requestHistory: 'Historique des demandes',
      removeItemConfirmTitle: 'Supprimer l’article ?',
      removeItemDescriptionNamed: 'Voulez-vous vraiment supprimer {{name}} de votre panier ?',
      removeItemDescriptionGeneric: 'Voulez-vous vraiment supprimer cet article de votre panier ?',
      pendingRequest: 'Demande en attente',
      pending: 'En attente',
      pendingNotice: 'Votre panier est verrouillé pendant que cette demande est en cours de traitement.',
      pendingRequestEmptyText: 'Votre demande est en cours de traitement, le panier est donc vide pour le moment.',
      requestMovedToHistory: 'Votre demande a été déplacée vers l’historique.',
      continueShopping: 'Continuer les achats',
    },
    accountPage: {
      title: 'Paramètres du profil',
      subtitle: 'Mettez à jour les informations affichées dans votre compte.',
      accountSettings: 'Paramètres du compte',
      accountDescription: 'Gérez les détails publics de votre compte et votre avatar.',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Téléphone',
        phonePlaceholder: '+216 00 000 000',
        email: 'E-mail',
        accountType: 'Type de compte',
        customer: 'Client',
      saving: 'Enregistrement...',
      saveChanges: 'Enregistrer',
      discard: 'Annuler',
      continueShopping: 'Continuer les achats',
      logout: 'Se déconnecter',
      uploading: 'Téléversement...',
      upload: 'Téléverser',
      uploadHint: 'Ajoutez une photo pour personnaliser votre compte.',
      removePhoto: 'Retirer la photo',
      profilePictureUpdated: 'Photo de profil mise à jour.',
      saveSuccess: 'Paramètres enregistrés.',
      saveFailed: 'Échec de sauvegarde du profil.',
      updatePictureFailed: 'Échec de mise à jour de la photo de profil.',
      requestHistoryEyebrow: 'Compte',
      requestHistoryTitle: 'Historique des demandes',
      requestHistorySubtitle: 'Suivez les demandes de devis, leur statut et la demande de devis finale.',
      requestHistoryLoadFailed: "Échec du chargement de l'historique des demandes.",
      pendingRequest: 'Demande en attente',
      requestDetails: 'Détails de la demande',
      requestDetailsSubtitle: 'Consultez le statut actuel, les totaux et les lignes de cette demande.',
      previewPdf: 'Aperçu PDF',
      previewPdfLoadingButton: "Préparation de l'aperçu...",
      previewPdfTitle: 'Aperçu PDF',
      previewPdfEyebrow: 'Aperçu PDF',
      previewPdfSubtitle: 'Consultez la demande de devis générée sans quitter la page.',
      previewPdfLoading: "Chargement de l'aperçu PDF...",
      previewPdfEmpty: 'Aucun PDF disponible.',
      previewPdfFailed: "Impossible d'ouvrir l'aperçu PDF.",
      previewPdfFrame: 'Aperçu PDF',
      closePreview: 'Fermer',
      backToHistory: "Retour à l'historique",
      backToAccount: 'Retour au compte',
      requestSummary: 'Résumé de la demande',
      contact: 'Contact',
      requestItems: 'Articles',
      updatedAt: 'Mis à jour',
      quotePrice: 'Prix du devis',
      lineTotal: 'Total ligne',
      summary: 'Résumé',
      quotedSubtotal: 'Sous-total devis',
      interestPercent: 'Intérêt %',
      interestAmount: "Montant de l'intérêt",
      tvaPercent: 'TVA %',
      tvaAmount: 'Montant de la TVA',
      finalTotal: 'Total final',
      notes: 'Notes',
      customerNote: 'Note client',
      adminNote: 'Note admin',
      rejectionReason: 'Motif de refus',
      timeline: 'Chronologie',
      currentStatus: 'Statut actuel',
      timelineSubmitted: 'Soumise',
      timelineSubmittedDetail: 'Demande créée',
      timelineReviewing: 'En cours de traitement',
      timelineReviewingDetail: "L'admin prépare le devis",
      timelineQuoted: 'Devis calculé',
      timelineQuotedDetail: 'Le prix a été calculé',
      timelineClosed: 'Clôturée',
      timelineClosedDetail: 'Revue finale',
      timelineSent: 'Envoyée',
      timelineSentDetail: 'Devis envoyé',
      timelineDeclined: 'Refusée',
      timelineDeclinedDetail: 'Demande refusée',
      timelineArchived: 'Archivée',
      timelineArchivedDetail: 'Archivée',
      backToCart: 'Retour au panier',
      viewRequestDetails: 'Voir les détails',
      loadingRequests: 'Chargement des demandes...',
      noRequestsTitle: 'Aucune demande pour le moment',
      noRequestsText: "Vos demandes de devis apparaîtront ici une fois qu'elles seront envoyées.",
      pendingRequestBanner: 'Votre dernière demande est encore en cours de traitement et reste disponible dans le panier pour le moment.',
    },
    auth: {
      login: {
        title: 'Bon retour',
        subtitle: 'Connectez-vous pour accéder à votre compte et vos commandes.',
        email: 'Email',
        emailPlaceholder: 'vous@exemple.com',
        password: 'Mot de passe',
        passwordPlaceholder: 'Entrez votre mot de passe',
        forgotPassword: 'Mot de passe oublié ?',
        failed: 'Échec de la connexion.',
        invalidCredentials: 'Identifiants invalides.',
        emailAndPasswordRequired: 'L e-mail et le mot de passe sont requis.',
        emailInvalid: 'Veuillez saisir une adresse e-mail valide.',
        passwordRequired: 'Le mot de passe est requis.',
        tooManyRequests: 'Trop de tentatives de connexion. Reessayez plus tard.',
        signingIn: 'Connexion...',
        signIn: 'Se connecter',
        errorTitle: 'Échec de la connexion',
        errorDetail: 'Nous n avons pas pu vous connecter. Vérifiez vos identifiants et réessayez.',
        noAccount: 'Pas encore de compte ?',
        createOne: 'Créer un compte',
      },
      signup: {
        title: 'Créer un compte',
        subtitle: "Configurez votre profil en moins d'une minute.",
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Téléphone',
        phonePlaceholder: '+216 00 000 000',
        email: 'Email',
        emailPlaceholder: 'vous@exemple.com',
        password: 'Mot de passe',
        passwordPlaceholder: 'Au moins 6 caractères',
        firstNameRequired: 'Le prénom est requis.',
        lastNameRequired: 'Le nom est requis.',
        phoneRequired: 'Le téléphone est requis.',
        phoneInvalid: 'Veuillez saisir un numéro de téléphone valide.',
        emailRequired: 'L e-mail est requis.',
        emailInvalid: 'Veuillez saisir une adresse e-mail valide.',
        passwordRequired: 'Le mot de passe est requis.',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caractères.',
        failed: 'Échec de la création du compte.',
        emailAndPasswordRequired: 'L e-mail et le mot de passe sont requis.',
        userAlreadyExists: 'Un compte avec cet e-mail existe déjà.',
        tooManyRequests: 'Trop de tentatives d inscription. Reessayez plus tard.',
        creatingAccount: 'Création du compte...',
        createAccount: 'Créer le compte',
        errorTitle: 'Échec de la création du compte',
        errorDetail: 'Nous n avons pas pu créer votre compte. Vérifiez les champs surlignés et réessayez.',
        alreadyRegistered: 'Déjà inscrit ?',
        signIn: 'Se connecter',
        publicSignup: 'Inscription publique',
        newAccountDescription: '{{fullName}} ({{email}}) - Inscription sur le site',
        successTitle: 'Compte créé',
        successDetail: 'Votre compte est prêt. Vous pouvez maintenant vous connecter pour gérer vos commandes.',
      },
      forgot: {
        title: 'Mot de passe oublié',
        subtitle: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation.',
        email: 'Email',
        emailPlaceholder: 'vous@exemple.com',
        emailRequired: 'E-mail requis',
        emailInvalid: 'Veuillez saisir une adresse e-mail valide.',
        requestFailed: 'Échec de la demande de réinitialisation',
        tooManyRequests: 'Trop de demandes de réinitialisation. Reessayez plus tard.',
        successMessage: 'Si cet e-mail existe, un lien de réinitialisation a été envoyé.',
        successTitle: 'Lien envoyé',
        successDetail: 'Si cet e-mail existe dans notre système, un lien de réinitialisation a été envoyé.',
        errorTitle: 'Impossible d envoyer le lien',
        errorDetail: 'Nous n avons pas pu traiter votre demande. Vérifiez votre e-mail et réessayez.',
        sending: 'Envoi...',
        sendResetLink: 'Envoyer le lien',
        rememberedPassword: 'Vous vous souvenez de votre mot de passe ?',
        backToLogin: 'Retour à la connexion',
      },
      reset: {
        title: 'Réinitialiser le mot de passe',
        subtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
        verifying: 'Vérification du lien...',
        invalidLink: 'Ce lien de réinitialisation est invalide ou expiré.',
        invalidToken: 'Jeton invalide ou expiré.',
        passwordRequired: 'Le mot de passe est requis.',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caractères.',
        passwordMismatch: 'Les mots de passe ne correspondent pas.',
        confirmPasswordRequired: 'Veuillez confirmer votre nouveau mot de passe.',
        failed: 'Échec de la réinitialisation du mot de passe',
        tooManyRequests: 'Trop de tentatives de réinitialisation. Reessayez plus tard.',
        success: 'Mot de passe réinitialisé avec succès. Vous pouvez maintenant vous connecter.',
        successTitle: 'Mot de passe mis à jour',
        successDetail: 'Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.',
        errorTitle: 'Échec de la réinitialisation',
        errorDetail: 'Nous n avons pas pu réinitialiser votre mot de passe. Vérifiez les champs et réessayez.',
        newPassword: 'Nouveau mot de passe',
        newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        confirmPasswordPlaceholder: 'Confirmez le nouveau mot de passe',
        resetting: 'Réinitialisation...',
        resetPassword: 'Réinitialiser le mot de passe',
        backToLogin: 'Retour à la connexion',
      },
      turnstile: {
        helper: 'Cette vérification nous aide à bloquer les robots et le trafic abusif.',
        error: 'Échec de la vérification. Veuillez actualiser le défi.',
        required: 'Veuillez compléter le défi de vérification.',
        retry: 'Échec de la vérification. Veuillez réessayer.',
        unavailable: 'Service de vérification indisponible. Veuillez réessayer.',
      },
    },
    productDetails: {
      loading: 'Chargement...',
      closeGallery: 'Fermer la galerie',
      openImageGallery: "Ouvrir la galerie d'images",
      imageAlt: 'Image de la machine',
      previousImage: 'Image precedente',
      nextImage: 'Image suivante',
      price: 'Prix',
      priceHint: 'Inclut la configuration standard',
      inStock: 'En stock',
      outOfStock: 'Rupture de stock',
      onlyLeftInStock: 'Il ne reste que {{count}} machines en stock',
      keyDetails: 'Détails clés',
      specsIncluded: 'Specifications incluses',
      maxCapacity: 'Capacite max',
      powerSource: "Source d'energie",
      addToCart: 'Ajouter au panier',
      addedToCart: 'ajoute au panier.',
      requestQuote: 'Demander un devis',
      compatibleSpareParts: 'Pièces de rechange compatibles',
      compatibleSparePartsDescription:
        'Ces pièces sont liées à cette machine et constituent le meilleur point de départ pour les opérations de remplacement ou de maintenance.',
      safetyTitle: 'Sécurité',
      safetyDescription: 'Contrôle et prêt pour une utilisation en toute sécurité.',
      safetyWarrantyTitle: 'Sécurité & Garantie',
      warrantyTitle: 'Garantie',
      warrantyDescription: 'Détails de couverture disponibles sur demande.',
      inventory: 'Stock',
      category: 'Catégorie',
      type: 'Type',
      showroomAvailability: 'Disponibilité',
      showroomLabel: 'Showroom',
      available: 'Disponible',
      unavailable: 'Indisponible',
      technicalSpecifications: 'Spécifications techniques',
      specificationColumn: 'Spécification',
      valueColumn: 'Mesure / Valeur',
      noTechnicalSpecifications: 'Aucune spécification technique disponible.',
      specsSubtitle: 'Données mécaniques et opérationnelles complètes pour cette machine.',
      specsDisclaimer:
        "Toutes les mesures fournies correspondent aux spécifications standard usine. Les performances sont basées sur des conditions nominales d'utilisation. Les accessoires optionnels peuvent modifier la capacité nominale et les dimensions.",
      specsGroupPerformance: 'Performance',
      specsGroupDimensions: 'Dimensions',
      specsGroupWheelsChassis: 'Roues & châssis',
      specsGroupWeight: 'Poids',
      noImage: "Pas d'image",
      visualComingSoon: 'Visuel à venir',
    },
    sparePartDetails: {
      loading: 'Chargement...',
      loadFailed: 'Échec du chargement de la pièce.',
      price: 'Prix',
      stock: 'Stock',
      addToCart: 'Ajouter au panier',
      category: 'Catégorie',
      stockStatus: 'État du stock',
      inStockLabel: 'Disponible maintenant',
      onlyLeftInStock: 'Plus que {{count}} pièces en stock',
      outOfStock: 'Rupture de stock',
      reference: 'Référence',
      notAvailable: 'Non disponible',
      closeGallery: 'Fermer la galerie',
      previousImage: 'Image precedente',
      nextImage: 'Image suivante',
      imageAlt: 'Image de la pièce',
      openImageGallery: "Ouvrir la galerie d'images",
        zoomImage: "Agrandir l'image",
      noImagesTitle: 'Aucun visuel disponible',
      noImagesDescription: 'Cette pièce est actuellement publiée sans images.',
      keyDetails: 'Détails clés',
      quickOverview: 'Aperçu rapide',
      purchaseSupportTitle: "Assistance à l'achat",
      qualityCheckTitle: 'Contrôle qualité',
      qualityCheckDescription: 'Pièces sélectionnées et vérifiées pour un usage fiable au quotidien.',
      orderSupportTitle: 'Assistance à la commande',
      orderSupportDescription: "Besoin d'aide pour confirmer la compatibilité ? Notre équipe peut vous guider avant l'achat.",
      partInformation: 'Informations sur la pièce',
      partInformationSubtitle: 'Un aperçu technique et commercial rapide de cette pièce détachée.',
      compatibleProducts: 'Machines compatibles',
      compatibleProductsDescription:
        "Ces machines sont liées à cette pièce afin que vous puissiez retrouver rapidement les machines sur lesquelles elle s'adapte.",
      specificationColumn: 'Spécification',
      valueColumn: 'Mesure / Valeur',
      partDetailsGroup: 'Détails de la pièce',
      partInformationDisclaimer: 'La disponibilité et les prix peuvent évoluer selon le stock et les mises à jour fournisseurs.',
    },
    aboutPage: {
      hero: {
        eyebrow: "À propos d'ETC Company",
        title: "Votre partenaire de confiance pour l'équipement d'entrepôt en Tunisie",
        titleLine1: 'Votre partenaire',
        titleLine2: "de confiance pour l'équipement d'entrepôt en Tunisie",
        description:
          "ETC Company accompagne les entreprises avec des solutions de manutention pratiques, en combinant des équipements fiables, la disponibilité des pièces et une assistance réactive.",
        description2:
          "Animée par un engagement fort en faveur de la modernisation et de la satisfaction client, ETC poursuit son développement en Tunisie avec une approche terrain, centrée sur les besoins réels des professionnels.\n\nCette dynamique s'illustre notamment par l'ouverture de son troisième showroom à Hammam Sousse, afin de rapprocher ses machines et services des entreprises.",
        highlightsTitle: "Points forts d'ETC",
        highlightsTitleLine1: 'Points forts',
        highlightsTitleLine2: "d'ETC",
        highlights: [
          {
            title: 'Expertise sectorielle',
            detail: 'Spécialisée dans les machines agricoles, les équipements industriels et les études commerciales.',
          },
          {
            title: 'Présence en expansion',
            detail: 'Une implantation stratégique en Tunisie, avec des showrooms dédiés pour mieux servir les clients locaux et régionaux.',
          },
          {
            title: 'Qualité et innovation',
            detail: 'Une réputation fondée sur des machines de qualité et des solutions digitales modernes pour la gestion des activités.',
          },
        ],
        metrics: {
          experienceLabel: "Années d'expérience",
          experienceValue: '15+',
          clientsLabel: 'Clients estimés',
          clientsValue: '1 000+',
        },
        stats: [
          { label: 'Focus opérationnel', value: 'Entreposage B2B', detail: 'Pensé pour les réalités quotidiennes' },
          { label: 'Présence sur le marché', value: 'Tunisie', detail: 'Au service des besoins industriels et logistiques locaux' },
          { label: 'Engagement', value: 'Support long terme', detail: "De l'achat à la maintenance" },
        ],
      },
      offer: {
        eyebrow: 'Ce que nous proposons',
        title: 'Un accompagnement de bout en bout pour vos équipements',
        titleLine1: 'Un support pour vos équipements',
        titleLine2: 'de bout en bout',
        items: [
          {
            title: 'Équipements de manutention',
            description:
              'Gerbeurs manuels et électriques sélectionnés pour la fiabilité, le confort opérateur et la durabilité.',
          },
          {
            title: 'Disponibilité des pièces',
            description:
              'Un catalogue dédié de pièces de rechange pour réduire les arrêts et maintenir votre flotte opérationnelle.',
          },
          {
            title: 'Service de maintenance préventive',
            description:
              'Inspections planifiées, remplacement des pièces d usure et interventions correctives pour maintenir vos équipements fiables et limiter les arrêts imprévus.',
          },
        ],
      },
      videoBanner: {
        eyebrow: 'Opérations',
        titleLine1: 'Conçu pour',
        titleLine2: 'la fiabilité quotidienne',
        description:
          'Du choix des équipements aux pièces de rechange, ETC soutient la continuité opérationnelle des entrepôts et des équipes industrielles.',
      },
      reputation: {
        eyebrow: 'Réputation en Tunisie',
        title: 'Reconnus pour leur fiabilité, leurs conseils et un service durable',
        titleLine1: 'Conseils fiables',
        titleLine2: 'et service durable',
        cards: [
          {
            title: 'Confiance opérationnelle',
            description:
              'Des entreprises à travers la Tunisie comptent sur ETC Company pour des équipements performants au quotidien.',
          },
          {
            title: 'Réputation de service',
            description:
              'Notre équipe est reconnue pour des recommandations claires, un support rapide et une forte attention à la continuité client.',
          },
          {
            title: 'Confiance machine',
            description:
              'Nous privilégions des gerbeurs fiables et des pièces compatibles pour limiter les interruptions.',
          },
          {
            title: 'Partenariat long terme',
            description:
              'ETC Company vise un partenariat opérationnel durable, au-delà de la simple fourniture.',
          },
        ],
      },
      team: {
        eyebrow: 'Notre équipe',
        title: 'Les personnes derrière ETC Company',
        titleLine1: 'Les personnes derrière',
        titleLine2: 'ETC Company',
        description:
          'Une équipe pragmatique qui aide les entreprises à choisir le bon équipement et à maintenir la disponibilité.',
        featuredLabel: 'Membre en vedette',
        featuredHint: 'Touchez un portrait ci-dessous pour changer la sélection.',
        rosterTitle: "Membres de l'équipe",
        rosterHint: 'Touchez un visage pour afficher le membre.',
        membersLabel: 'Membres',
        selectedBadge: 'Sélectionné',
        memberBioLabel: 'À propos de ce membre',
      },
      shortcuts: {
        eyebrow: 'Raccourcis',
        title: 'Accès rapide aux pages principales',
        titleLine1: 'Accès rapide aux',
        titleLine2: 'pages principales',
        openPage: 'Ouvrir la page',
          items: [
            {
              title: 'Machines',
              description:
          'Parcourez tout le catalogue avec filtrage, fiches techniques et prix.',
            },
            {
              title: 'Pièces de rechange',
              description: 'Trouvez des pièces compatibles pour maintenir vos opérations.',
            },
            {
              title: 'Contact',
              description: 'Contactez ETC Company pour support, devis et accompagnement technique.',
            },
            {
              title: 'Services',
              description: "Découvrez nos services pour l'accompagnement des équipements, les pièces et l'après-vente.",
            },
          ],
      },
    },
    contactPage: {
      hero: {
        eyebrow: 'Contact ETC',
        title: 'Parlons de votre prochain besoin en équipement',
        description:
          "Contactez notre équipe pour des conseils sur les machines, une assistance pour les pièces, des informations tarifaires et des indications sur la disponibilité.",
        stats: [
          { label: 'Objectif réponse', value: 'Le jour même', détail: 'Premier retour rapide' },
          { label: 'Types de demandes', value: 'Machines + pièces', détail: 'Commercial et technique' },
          { label: 'Style de support', value: 'Pragmatique', détail: 'Recommandations claires' },
        ],
      },
      channels: {
        eyebrow: 'Canaux',
        titleLine1: 'Dans nos',
        titleLine2: 'showrooms',
        description:
          'Chaque showroom est pensé pour vous aider à passer rapidement de la question à la solution. Visitez le point le plus proche, rencontrez notre équipe, découvrez nos équipements et recevez des conseils clairs sur les machines, les pièces de rechange et les services pour votre activité.',
        showroomTitles: {
          nabeul: 'Magasin Nabeul',
          tunis: 'Showroom TUNIS',
          sousse: 'Showroom Sousse',
        },
        items: [
          {
            title: 'Email',
            value: 'sales@etc-company.com',
            hint: 'Idéal pour devis et besoins techniques',
          },
          {
            title: 'Téléphone',
            value: '+216 29 363 055',
            hint: "Coordination directe en cas d'urgence",
          },
          {
            title: 'Localisation',
            value: 'Tunis, Tunisie',
            hint: "Support pour les équipements d'entrepôt et les pièces de rechange",
          },
          {
            title: 'Horaires',
            value: 'Lun - Ven, 08:00 - 18:00',
            hint: 'Réponse dans la journée pendant les heures ouvrables',
          },
        ],
        loading: 'Chargement...',
        openMap: 'Ouvrir la carte',
        mapUnavailableTitle: 'Aperçu de la carte indisponible',
        mapUnavailableDescription:
          'Google Maps est bloqué dans ce navigateur. Utilisez plutôt le lien direct vers la carte.',
      },
      form: {
        eyebrow: 'Formulaire de demande',
        title: 'Envoyez votre demande',
        description:
          'Partagez vos besoins et nous répondrons avec des machines recommandées, des pièces et les prochaines étapes.',
        fullName: 'Nom complet',
        fullNamePlaceholder: 'Votre nom',
        email: 'E-mail',
        emailPlaceholder: 'vous@entreprise.com',
        subject: 'Objet',
        subjectPlaceholder: 'Comment pouvons-nous vous aider ?',
        phone: 'Téléphone',
        phonePlaceholder: '+216 ...',
        inquiryType: 'Type de demande',
        inquiryTypePlaceholder: 'Sélectionnez un type de demande',
        options: {
          products: 'Machines',
          spareParts: 'Pièces de rechange',
          afterSales: 'Support après-vente',
          other: 'Autre',
        },
        message: 'Message',
        messagePlaceholder: 'Expliquez votre besoin...',
        note: 'Nous répondrons depuis les ventes dans les plus brefs délais.',
        requiredNote: 'Les champs marqués avec * sont obligatoires.',
        sending: 'Envoi en cours...',
        sendMessage: 'Envoyer le message',
        successTitle: 'Message envoyé',
        successDetail: 'Merci. Notre équipe commerciale va examiner votre demande et vous répondre rapidement.',
        success: 'Votre message a été envoyé. Nous vous répondrons bientôt.',
        errors: {
          failed: "Impossible d'envoyer votre message pour le moment.",
          required: 'Veuillez remplir les champs obligatoires.',
          nameRequired: 'Veuillez saisir votre nom.',
          emailRequired: 'Veuillez saisir votre adresse e-mail.',
          subjectRequired: 'Veuillez saisir un objet.',
          phoneRequired: 'Veuillez saisir votre numéro de téléphone.',
          inquiryTypeRequired: 'Veuillez sélectionner un type de demande.',
          messageRequired: 'Veuillez saisir votre message.',
          invalidEmail: 'Veuillez saisir une adresse email valide.',
        },
      },
      faq: {
        eyebrow: "Besoin d'aide ?",
        titleLine1: 'Questions',
        titleLine2: 'fréquentes',
        description: 'Quelques réponses rapides pour vous aider à contacter la bonne équipe et avancer plus vite.',
        tipTitle: 'Le plus simple',
        tipDescription:
          'Utilisez le formulaire pour les devis, le choix de machines, les pièces de rechange ou le support après-vente. Nous orientons chaque message vers la bonne équipe.',
        tipNote: 'Si votre demande est urgente, ajoutez le nom de la machine, le modèle et les références disponibles.',
        items: [
          {
            question: 'Que dois-je inclure dans mon message ?',
            answer:
              'Indiquez le nom de la machine ou de la pièce, le modèle, la quantité, le lieu et, si possible, des photos ou des références. Plus vous donnez de contexte, plus nous répondons vite.',
          },
          {
            question: 'Puis-je poser une question sur les machines et les pièces ?',
            answer:
              'Oui. Envoyez tout dans une seule demande et nous la transmettrons à la bonne personne pour vous donner une réponse complète.',
          },
          {
            question: 'Sous quel délai répondez-vous ?',
            answer:
              'Nous essayons de répondre le jour même lorsque cela est possible, surtout pour les demandes commerciales et techniques.',
          },
          {
            question: 'Puis-je visiter un showroom avant de commander ?',
            answer:
              'Bien sûr. Vous pouvez visiter le showroom le plus proche pour voir les équipements en personne et recevoir des conseils avant de décider.',
          },
        ],
      },
      cta: {
        eyebrow: 'Accès rapide',
        title: "Vous préférez parcourir d'abord ?",
        description:
          'Explorez nos catalogues machines et pièces de rechange, puis contactez-nous avec des références précises.',
        viewProducts: 'Voir les machines',
        viewSpareParts: 'Voir les pièces',
      },
    },
    admin: {
      editNavigation: {
        browsing: 'Navigation',
        browsingEntity: 'Navigation {{entity}}',
        position: '{{current}} sur {{total}}',
        totalItems: '{{total}} {{entity}}',
        products: 'produits',
        spareParts: 'pièces de rechange',
        previous: 'Précédent',
        next: 'Suivant',
        cancel: 'Annuler',
        saving: 'Enregistrement...',
        unsavedTitle: 'Enregistrer les modifications avant de quitter ?',
        unsavedDescription:
          'Vous avez des modifications non enregistrées. Enregistrez-les avant d’ouvrir l’élément suivant, continuez sans enregistrer ou annulez pour rester ici.',
        continueWithoutSaving: 'Ne pas enregistrer',
        saveAndContinue: 'Enregistrer et continuer',
      },
      navLabels: {
        dashboard: 'Tableau de bord',
        search: 'Recherche globale',
        products: 'Produits',
        brands: 'Marques',
        showrooms: 'Showrooms',
        producttypes: 'Types de produits',
        spareparts: 'Pièces de rechange',
        requests: 'Requêtes',
        promos: 'Promos',
        users: 'Utilisateurs',
        team: 'Équipe',
        divers: 'Divers',
        trash: 'Corbeille',
        audit: 'Historique',
        health: 'Santé opérationnelle',
      },
      navChildren: {
        products: {
          add: 'Ajouter un produit',
          list: 'Liste des produits',
          types: 'Types de produits',
          addBrand: 'Ajouter une marque',
          brandsList: 'Liste des marques',
        },
        brands: {
          add: 'Ajouter une marque',
          list: 'Liste des marques',
        },
        showrooms: {
          add: 'Ajouter un showroom',
          list: 'Liste des showrooms',
        },
        spareparts: {
          add: 'Ajouter une pièce',
          list: 'Liste des pièces',
          categories: 'Catégories',
        },
        requests: {
          list: 'Demandes utilisateur',
        },
        promos: {
          list: 'Liste des promos',
          add: 'Ajouter une promo',
        },
        users: {
          add: 'Ajouter un utilisateur',
          list: 'Liste des utilisateurs',
        },
        team: {
          add: 'Ajouter un membre',
          list: "Liste de l'équipe",
        },
        divers: {
          guides: 'Guides',
          audit: 'Historique',
          health: 'Santé opérationnelle',
        },
      },
      guides: {
        title: 'Carnet de guides',
        pageTitle: 'Carnet de guides',
        pageSubtitle: "Une bibliothèque d'aide rapide quand un admin est bloqué.",
        introEyebrow: 'Aide',
        introTitle: 'Commencez par la tâche dont vous avez besoin',
        introDescription:
          "Ouvrez une carte de guide pour voir le chemin le plus court pour une tâche, puis allez à la page d'administration correspondante. Sur cette page, le bouton ? ouvre la visite ciblée.",
        step1Label: 'Étape 1',
        step1Text: 'Choisissez un guide',
        step2Label: 'Étape 2',
        step2Text: 'Ouvrez la page liée',
        step3Label: 'Étape 3',
        step3Text: 'Utilisez le bouton ?',
        quickReferencesEyebrow: 'Aperçu rapide',
        quickReferencesTitle: 'Les trois repères à garder ouverts',
        quickReferencesDescription: 'Un mémo, un dépannage rapide et des exemples de flux courants.',
        referenceLabel: 'Référence',
        referenceText: 'Rappel rapide pour le support',
        cardCount: '{{count}} guides',
        focusedTourReminder: 'Utilisez le bouton ? sur chaque page pour une visite ciblée.',
        subtitle: 'Une bibliothèque d’aide rapide quand un admin est bloqué.',
        introEyebrow: 'Aide',
        introTitle: 'Commencez par la tâche dont vous avez besoin',
        introDescription:
          'Ouvrez une carte de guide pour voir le chemin le plus court pour une tâche, puis allez à la page admin correspondante. Sur cette page, le bouton ? ouvre la visite ciblée.',
        searchPlaceholder: 'Rechercher des guides, des pages ou des tâches...',
        loadingTitle: 'Chargement des guides...',
        loadingDescription: 'Préparation de la bibliothèque d’aide.',
        noPermission: "Vous n'avez pas l'autorisation d'accéder à la bibliothèque de guides.",
        emptyTitle: 'Aucun guide trouvé',
        emptyDescription: 'Essayez un autre mot-clé ou parcourez tous les guides ci-dessous.',
        openPage: 'Ouvrir la page',
      },
      sidebar: {
        collapse: 'Réduire la barre latérale',
        expand: 'Étendre la barre latérale',
        lightMode: 'Mode clair',
        darkMode: 'Mode sombre',
        exitToWebsite: 'Retour au site',
        profileSettings: 'Paramètres du profil',
        logout: 'Déconnexion',
      },
      header: {
        sessionExpiresIn: 'Session expire dans',
        live: 'En ligne',
        searchPlaceholder: 'Rechercher produits, utilisateurs, historique...',
        search: 'Rechercher',
        notifications: 'Notifications',
        noNewEvents: 'Aucune notification pour le moment.',
        noNotificationsDescription:
          "Il n'y a aucune notification pour le moment. Les nouvelles activités apparaîtront ici.",
        dismissNotification: 'Fermer la notification',
      },
      notifications: {
        newAccountCreated: 'Nouveau compte créé',
        newUserAccountCreated: 'Un nouveau compte utilisateur a été créé.',
        quoteRequestTitle: 'Demande de devis {{requestNumber}}',
        quoteRequestDescription: 'Un client a soumis une nouvelle demande de devis.',
        quoteRequestDescriptionWithCustomer:
          'Un client a soumis une nouvelle demande de devis pour {{customerName}}.',
        quoteRequestSource: 'Demandes de devis',
        legacyNotification: 'Notification migree',
        adminPanel: 'Panneau admin',
        moreAvailable: '{{count}} notifications supplémentaires disponibles',
        centerViewAll: 'Voir toutes les notifications',
        centerTitle: 'Centre de notifications',
        centerSubtitle: "Consultez les dernières activités admin au même endroit.",
        centerEyebrow: 'Tableau de bord',
        centerClearAll: 'Tout effacer',
        centerEmptyTitle: 'Aucune notification pour le moment',
        centerEmptyDescription:
          "Les nouvelles demandes de devis, inscriptions utilisateurs et autres activités apparaîtront ici.",
        centerBackToDashboard: 'Retour au tableau de bord',
        centerOpenLabel: 'Ouvrir',
        justNow: "À l'instant",
        minutesAgo: 'il y a {{count}} min',
        hoursAgo: 'il y a {{count}} h',
        daysAgoWithDate: 'il y a {{count}} j ({{date}} {{time}})',
      },
      session: {
        expired: 'Session expirée. Veuillez vous reconnecter.',
        expiringSoon: 'La session va expirer bientôt. Reconnectez-vous.',
      },
      entry: {
        redirecting: 'Redirection vers l administration...',
      },
      login: {
        title: 'ETC Admin',
        subtitle: 'Connectez-vous pour gérer les produits',
        adminEmail: 'Email admin',
        emailPlaceholder: 'admin@example.com',
        bootstrapHint: 'Utilisez l email admin configure et le mot de passe bootstrap pour la premiere connexion admin.',
        legacyHint: 'Laissez vide pour utiliser la connexion admin héritée.',
        password: 'Mot de passe',
        passwordPlaceholder: 'Entrez le mot de passe',
        invalidCredentials: 'Identifiants invalides',
        loginFailed: 'Échec de connexion',
        passwordRequired: 'Le mot de passe est requis.',
        tooManyRequests: 'Trop de tentatives de connexion. Reessayez plus tard.',
        roleNotAllowed: 'Ce role utilisateur n est pas autorise pour l acces admin.',
        notConfigured: 'La connexion admin n est pas configuree sur ce deploiement.',
        bootstrapNotConfigured: 'La connexion bootstrap admin n est pas configuree sur ce deploiement.',
        databaseUnavailable: 'La connexion a la base de donnees a echoue.',
        loggingIn: 'Connexion...',
        login: 'Connexion',
        backToWebsite: 'Retour au site',
      },
      brands: {
        addTourLabel: 'Visite d’ajout de marque',
        addTourIntroTitle: 'Créer une fiche marque',
        addTourIntroDescription:
          "Utilisez ce formulaire guidé pour nommer la marque, téléverser un logo et enregistrer une fiche réutilisable dans tout le catalogue.",
        addTourIntroHint: "Commencez par l’identité",
        addTourNameTitle: 'Nom de la marque',
        addTourNameDescription:
          "Saisissez le nom officiel de la marque tel qu’il doit apparaître dans les sélecteurs, les badges et les fiches produit.",
        addTourNameHint: 'Nommez la marque clairement',
        addTourLogoTitle: 'Logo de la marque',
        addTourLogoDescription:
          "Téléversez le logo utilisé dans le sélecteur afin de garder une identité cohérente partout où la marque apparaît.",
        addTourLogoHint: "Ajoutez l’identité visuelle",
        addTourSaveTitle: 'Enregistrer ou annuler',
        addTourSaveDescription:
          "Utilisez la barre d’actions pour enregistrer la marque ou annuler puis revenir à la liste une fois les détails prêts.",
        addTourSaveHint: 'Terminez le formulaire',
      },
      profile: {
        noPermission: "Vous n'avez pas l'autorisation d'accéder au profil.",
        defaultEmail: 'admin@etc-company.local',
        defaultRole: 'Admin',
        uploadFailed: 'Échec du téléversement',
        pictureUploaded: 'Photo de profil téléversée.',
        saveFailed: 'Échec de sauvegarde du profil.',
        saveSuccess: 'Profil enregistré.',
        layoutTitle: 'Paramètres du profil',
        layoutSubtitle: 'Mettez à jour les informations affichées dans la barre admin.',
        accountSettings: 'Paramètres du compte',
        accountDescription: 'Gérez votre profil admin et les informations visibles',
        displayName: 'Nom affiché',
        nameRequired: 'Le nom affiché est requis.',
        email: 'Email',
        roleLabel: 'Rôle',
        saving: 'Enregistrement...',
        saveChanges: 'Enregistrer',
        discard: 'Annuler',
        upload: 'Téléverser',
        uploadHint: 'Ajoutez une photo pour personnaliser votre compte admin.',
        removePhoto: 'Retirer la photo',
      },
      health: {
        title: 'Santé opérationnelle',
        subtitle: 'Surveillez le runtime, la base de données et la fiabilité du système.',
        noPermission: "Vous n'avez pas l'autorisation de voir la santé opérationnelle.",
        loadFailed: 'Échec du chargement de la santé opérationnelle.',
        loadingTitle: 'Chargement des métriques de santé...',
        loadingDescription: 'Vérification du système et de la base de données.',
        unavailable: 'Santé opérationnelle indisponible',
        noData: 'Aucune donnée retournée par le point de terminaison de santé.',
        warning: 'Alerte de vérification de santé',
        checkedAt: 'Vérifié à',
        refreshing: 'Actualisation...',
        refresh: 'Actualiser',
        apiResponse: 'Réponse API',
        dbLatency: 'Latence BD',
        unavailableShort: 'Indisponible',
        uptime: 'Uptime',
        auditFailures1h: "Échecs d'audit (1h)",
        database: 'Base de données',
        runtime: 'Runtime',
        datasetCounts: 'Volumes de données',
        status: 'Statut',
        connected: 'Connectée',
        disconnected: 'Déconnectée',
        connectionState: 'État de connexion',
        latency: 'Latence',
        error: 'Erreur',
        environment: 'Environnement',
        nodeVersion: 'Node',
        processId: 'PID',
        memoryRss: 'Mémoire RSS',
        heapUsed: 'Heap utilisé',
        products: 'Produits',
        users: 'Utilisateurs',
        auditLogs: "Journaux d'audit",
        failures24h: 'Échecs (24h)',
      },
      audit: {
        title: 'Historique',
        subtitle: 'Suivez les actions admin dans le tableau de bord.',
        noPermission: "Vous n'avez pas l'autorisation de voir l'historique.",
        tourLabel: 'Visite de l’historique',
        tourIntroTitle: 'Historique d’activité en un coup d’œil',
        tourIntroDescription:
          "Cette visite vous montre où consulter l’activité, filtrer le journal et ouvrir les enregistrements liés lorsque vous devez retracer un changement.",
        tourIntroHint: 'Commencez par les filtres',
        tourFiltersTitle: 'Filtrer le journal',
        tourFiltersDescription:
          "Choisissez un statut, affinez la recherche et videz le journal quand vous avez besoin d’une vue plus ciblée des actions récentes.",
        tourFiltersHint: 'Ciblez la chronologie',
        tourTableTitle: 'Examiner les événements et les détails',
        tourTableDescription:
          "Parcourez les lignes d’activité, ouvrez la colonne des détails et suivez l’entité ou l’acteur lié pour comprendre ce qui s’est passé.",
        tourTableHint: 'Relisez la liste',
        loadFailed: "Échec du chargement de l'historique.",
        clearFailed: "Échec de suppression de l'historique.",
        cleared: 'Historique supprimé.',
        loadingTitle: "Chargement de l'historique...",
        loadingDescription: 'Récupération des activités récentes.',
        failedTitle: "Échec du chargement de l'historique",
        clearing: 'Suppression...',
        clearHistory: "Vider l'historique",
        allStatuses: 'Tous statuts',
        succèssOnly: 'Succès uniquement',
        failureOnly: 'Échec uniquement',
        searchPlaceholder: 'Rechercher action, acteur, entité...',
        emptyText: 'Aucun événement historique.',
        when: 'Quand',
        action: 'Action',
        entity: 'Entité',
        actor: 'Acteur',
        status: 'Statut',
        détails: 'Détails',
        administrator: 'Administrateur',
        unknown: 'inconnu',
        deleteTitle: "Supprimer l'historique ?",
        deleteDescription: 'Voulez-vous vraiment supprimer ?',
        delete: 'Supprimer',
      },
      promo: {
        title: 'Promotion',
        productHint: 'Mettez ce produit en avant avec un badge promo ou un prix remisé.',
        sparePartHint: 'Mettez cette pièce de rechange en avant avec un badge promo ou un prix remisé.',
        active: 'Active',
        inactive: 'Inactive',
        enable: 'Activer la promo',
        featured: 'Afficher dans les listes',
        kind: 'Type de promo',
        colorTone: 'Tonalité de couleur',
        discountPercent: 'Remise (%)',
        discountPercentPlaceholder: '20',
        discountPercentHint: 'Indiquez le pourcentage de remise, par exemple 20 pour 20 %.',
        labelEn: 'Libellé du badge (EN)',
        labelEnPlaceholder: 'Promo',
        labelFr: 'Libellé du badge (FR)',
        labelFrPlaceholder: 'Promo',
        startsAt: 'Début',
        startsAtPlaceholder: 'Sélectionnez une date et une heure',
        endsAt: 'Fin',
        endsAtPlaceholder: 'Sélectionnez une date et une heure',
        kindBadgeOnly: 'Badge uniquement',
        kindDiscountedPrice: 'Prix remisé',
        colorOrange: 'Orange',
        colorBeige: 'Beige',
        colorSecondary: 'Secondaire',
        colorBlack: 'Noir',
      },
      promos: {
        title: 'Promos',
        subtitle: 'Consultez toutes les promos actives, à venir et expirées au même endroit.',
        noPermission: "Vous n'avez pas l'autorisation de voir les promos.",
        loadingTitle: 'Chargement des promos...',
        loadingDescription: 'Collecte des offres des produits et des pièces.',
        loadFailed: 'Échec du chargement des promos.',
        saveDisabledHint: 'Activez la promo pour enregistrer les changements.',
        savePromo: 'Enregistrer la promo',
        searchPlaceholder: 'Rechercher par ID, élément, promo, type ou statut...',
        emptyText: 'Aucune promo ne correspond aux filtres actuels.',
        helper: 'Utilisez les filtres pour cibler les promos par type, style ou statut.',
        all: 'Toutes',
        active: 'Active',
        upcoming: 'À venir',
        expired: 'Expirées',
        products: 'Produits',
        spareParts: 'Pièces de rechange',
        product: 'Produit',
        sparePart: 'Pièce de rechange',
        badgeOnly: 'Badge uniquement',
        discountedPrice: 'Prix réduit',
        totalPromos: 'Total promos',
        activePromos: 'Promos actives',
        upcomingPromos: 'Promos à venir',
        expiredPromos: 'Promos expirées',
        featuredPromos: 'Promos mises en avant',
        discountedPromos: 'Promos à prix réduit',
        addPromo: 'Ajouter une promo',
        addHelper: 'Choisissez un élément et configurez sa promo uniquement depuis ce formulaire.',
        addTourLabel: 'Visite d’ajout de promo',
        addTourIntroTitle: 'Créer une promo',
        addTourIntroDescription:
          "Utilisez cet éditeur pour choisir l’élément cible, configurer la règle de promo et valider les détails avant de la publier.",
        addTourIntroHint: 'Commencez par l’élément',
        addTourSelectionTitle: 'Choisir l’élément',
        addTourSelectionDescription:
          "Commencez par décider si la promo concerne un produit ou une pièce de rechange, puis sélectionnez l’enregistrement exact dans le catalogue.",
        addTourSelectionHint: 'Sélectionnez la cible',
        addTourFieldsTitle: 'Configurer la promo',
        addTourFieldsDescription:
          "Définissez le libellé, les dates, la visibilité et les options de remise pour que la promotion corresponde à la campagne souhaitée.",
        addTourFieldsHint: 'Définissez les règles',
        addTourSaveTitle: 'Enregistrer ou supprimer',
        addTourSaveDescription:
          "Utilisez les boutons d’action pour enregistrer la promo ou la supprimer une fois la campagne terminée.",
        addTourSaveHint: 'Terminez l’éditeur',
        editPromo: 'Modifier la promo',
        editHelper: "Mettez à jour la promo de l'élément sélectionné depuis ce formulaire.",
        updatePromo: 'Mettre à jour la promo',
        editPromoAction: 'Modifier la promo',
        listModeTitle: 'Liste des promos',
        listModeDescription: 'Consultez les promos actives et planifiées sans le formulaire.',
        removePromo: 'Supprimer la promo',
        removing: 'Suppression...',
        removed: 'Promo supprimée.',
        confirmRemove: 'Supprimer cette promo ?',
        item: 'Élément',
        id: 'ID',
        type: 'Type',
        promoKind: 'Type de promo',
        status: 'Statut',
        period: 'Période',
        featured: 'Mis en avant',
        price: 'Prix',
        actions: 'Actions',
        openItem: "Ouvrir l'élément",
        managePromos: 'Gérer les promos',
        quickAdd: 'Ajout rapide',
        addProductPromo: 'Ajouter une promo produit',
        addSparePartPromo: 'Ajouter une promo pour pièce de rechange',
      },
      search: {
        title: 'Recherche globale',
        subtitle: 'Recherchez produits, utilisateurs et audits depuis un seul endroit.',
        noPermission: "Vous n'avez pas l'autorisation d'utiliser la recherche globale.",
        loadTitle: 'Chargement de la recherche...',
        loadDescription: 'Préparation des résultats de recherche unifiés.',
        searchFailed: 'Échec de la recherche.',
        searchPlaceholder: 'Rechercher par nom, email, action...',
        allEntities: 'Toutes les entités',
        products: 'Produits',
        users: 'Utilisateurs',
        auditOnly: 'Audit uniquement',
        anyStatus: 'Tous statuts',
        succèss: 'Succès',
        failure: 'Échec',
        hint: 'Laissez la recherche vide pour voir les éléments récents selon les filtres.',
        searching: 'Recherche...',
        search: 'Rechercher',
        totalMatches: 'Total correspondances',
        failedTitle: 'Échec de la recherche',
        noProductMatches: 'Aucune correspondance produit.',
        noUserMatches: 'Aucune correspondance utilisateur.',
        noAuditMatches: 'Aucune correspondance audit.',
        noPermissionEntity: "Aucune autorisation pour voir cette entité.",
        unnamedUser: 'Utilisateur sans nom',
        noSlug: 'pas-de-slug',
        showMore: 'Afficher {{count}} de plus',
        showLess: 'Afficher moins',
      },
      userRequests: {
        title: 'Demandes utilisateur',
        subtitle: 'Consultez les demandes de devis, calculez les tarifs et envoyez la demande de devis finale.',
        tourLabel: 'Visite des demandes',
        tourIntroTitle: 'Consultez les demandes de devis en un coup d’œil',
        tourIntroDescription:
          'Cette page vous permet de suivre les demandes entrantes, d’affiner la file et d’ouvrir une demande dès qu’elle doit être examinée.',
        tourIntroHint: 'Commencez par la file',
        tourArchiveTitle: 'Archivage automatique',
        tourArchiveDescription:
          'Les demandes envoyées ou refusées sont archivées automatiquement après 7 jours, ce qui vous indique quand les anciennes demandes quittent la file active.',
        tourArchiveHint: 'Aucun nettoyage manuel',
        tourFiltersTitle: 'Rechercher et filtrer la file',
        tourFiltersDescription:
          'Utilisez ensemble le statut, le client et la recherche pour isoler les demandes par client, date ou état actuel.',
        tourFiltersHint: 'Affinez la liste',
        tourTableTitle: 'Lire le tableau des demandes',
        tourTableDescription:
          'Chaque ligne affiche le numéro, le client, le nombre d’articles, le statut, le total et la date de création pour comparer rapidement les demandes.',
        tourTableHint: 'Lisez les colonnes clés',
        tourActionsTitle: 'Ouvrir une demande',
        tourActionsDescription:
          'Utilisez le bouton Consulter dans la dernière colonne pour ouvrir une demande et passer à l’éditeur détaillé.',
        tourActionsHint: 'Accédez au détail',
        reviewTourLabel: 'Visite de revue de demande',
        reviewTourIntroTitle: 'Revoir une demande de devis en détail',
        reviewTourIntroDescription:
          'Utilisez cette page pour examiner le client, ajuster le devis et terminer la demande avec un PDF enregistré ou une réponse envoyée.',
        reviewTourIntroHint: 'Commencez par le résumé',
        reviewTourTopActionsTitle: 'Retour, aperçu, enregistrement et impression',
        reviewTourTopActionsDescription:
          'Ces boutons vous ramènent à la liste, ouvrent un aperçu PDF en direct, enregistrent une copie PDF ou impriment la demande de devis.',
        reviewTourTopActionsHint: 'Commencez par les outils',
        reviewTourOverviewTitle: 'Résumé de la demande',
        reviewTourOverviewDescription:
          'Cette carte affiche le numéro, les dates, l’identité du client, les totaux et les notes pour comprendre rapidement le contexte.',
        reviewTourOverviewHint: 'Vérifiez le résumé',
        reviewTourItemsTitle: 'Lignes du devis',
        reviewTourItemsDescription:
          'Ajustez ici le prix de chaque ligne. Les totaux se mettent à jour immédiatement pour comparer les valeurs demandées et devisées.',
        reviewTourItemsHint: 'Ajustez chaque ligne',
        reviewTourSummaryTitle: 'Statut et totaux',
        reviewTourSummaryDescription:
          'Utilisez le panneau récapitulatif pour vérifier le statut du mail, l’état de la demande, le sous-total demandé, le sous-total devis, l’intérêt et le total final.',
        reviewTourSummaryHint: 'Contrôlez les chiffres',
        reviewTourActionsTitle: 'Notes admin et actions finales',
        reviewTourActionsDescription:
          'Ajoutez des notes internes ou un motif de refus, puis enregistrez un brouillon, envoyez le devis, refusez la demande ou archivez-la.',
        reviewTourActionsHint: 'Terminez le workflow',
        archiveNoticeTitle: "Avis d'archivage automatique",
        archiveNoticeText: 'Les demandes envoyées ou refusées sont archivées automatiquement après 7 jours.',
        archiveNoticeHint: 'Aucun nettoyage manuel requis',
        clientFilter: 'Client',
        allClients: 'Tous les clients',
        clientFilterSearch: 'Rechercher des clients...',
        noClients: 'Aucun client trouvé',
        loadFailed: 'Échec du chargement des demandes.',
        errorTitle: 'Impossible de charger les demandes',
        forbidden: "Vous n'avez pas l'autorisation de voir les demandes de devis.",
        searchPlaceholder: 'Rechercher par numéro de demande, client ou statut',
        empty: 'Aucune demande de devis pour le moment',
        filterStatus: 'Filtrer le statut',
        refresh: 'Actualiser',
        requestNo: 'Demande #',
        customer: 'Client',
        items: 'Articles',
        status: 'Statut',
        total: 'Total',
        createdAt: 'Créée',
        actions: 'Actions',
        review: 'Consulter',
        purchaseOrder: 'Demande de devis',
        reviewTitle: 'Revue de la demande',
        reviewSubtitle: 'Préparez la demande de devis, ajoutez un intérêt ou refusez avec un motif.',
        backToList: 'Retour à la liste',
        exportPdf: 'Exporter PDF',
        savePdf: 'Enregistrer en PDF',
        previewPdf: 'Aperçu PDF',
        previewPdfLoadingButton: "Préparation de l'aperçu...",
        previewPdfTitle: 'Aperçu PDF',
        previewPdfEyebrow: 'Aperçu PDF',
        previewPdfSubtitle: 'Consultez la demande de devis générée sans quitter la page.',
        previewPdfLoading: "Chargement de l'aperçu PDF...",
        previewPdfEmpty: 'Aucun PDF disponible.',
        previewPdfFailed: "Impossible d'ouvrir l'aperçu PDF.",
        previewPdfFrame: 'Aperçu PDF',
        closePreview: 'Fermer',
        savingPdf: 'Enregistrement du PDF...',
        htmlSource: 'Code HTML',
        printPdf: 'Imprimer',
        printingPdf: 'Impression...',
        pdfSaved: 'PDF enregistré.',
        pdfFailed: "Impossible d'enregistrer le PDF.",
        printFailed: "Impossible d'ouvrir la boîte de dialogue d'impression.",
        printUnavailable: "L'impression n'est pas disponible dans ce navigateur.",
        mailStatus: 'Statut mail',
        mailStatusFailed: 'Échec du chargement du statut mail.',
        mailChecking: 'Vérification...',
        mailConnected: 'Mail connecté',
        mailNotConfigured: 'Mail non configuré',
        mailPreviewTo: 'Copie de test',
        requestedSubtotal: 'Sous-total demande',
        quotedSubtotal: 'Sous-total devis',
        currentStatus: 'Statut actuel',
        updatedAt: 'Mis à jour',
        contactDetails: 'Coordonnées',
        customerNote: 'Note client',
        noCustomerNote: 'Aucune note client fournie.',
        noPhone: 'Aucun téléphone fourni',
        noRejectionReason: 'Aucun motif de refus pour le moment.',
        quoteItems: 'Lignes du devis',
        quoteItemsHelp: "Ajustez le prix de chaque ligne avant d'envoyer la demande de devis.",
        quotePrice: 'Prix devis',
        quantity: 'Quantité',
        unit: 'unité',
        lineTotal: 'Total ligne',
        summary: 'Résumé',
        interestPercent: 'Intérêt %',
        interestAmount: "Montant de l'intérêt",
        tvaPercent: 'TVA %',
        tvaAmount: 'Montant de la TVA',
        productTvaLabel: 'Produit',
        sparePartTvaLabel: 'Pièce de rechange',
        pdfRequiresSave: 'Enregistrez la demande avant de générer le PDF.',
        finalTotal: 'Total final',
        adminNote: 'Note admin',
        adminNotePlaceholder: 'Ajoutez ici les notes de paiement, livraison ou stock',
        rejectionReason: 'Motif de refus',
        rejectionReasonPlaceholder: 'Expliquez pourquoi la demande a été refusée',
        signature: 'Signature autorisée',
        signaturePlaceholder: "Zone d'approbation et de cachet",
        saving: 'Enregistrement...',
        sending: 'Envoi...',
        rejecting: 'Refus...',
        archiving: 'Archivage...',
        saveQuote: 'Enregistrer le brouillon',
        sendQuote: 'Envoyer le devis',
        rejectRequest: 'Refuser la demande',
        archiveRequest: 'Archiver la demande',
        sendConfirmTitle: 'Envoyer ce devis au client ?',
        sendConfirmDescription:
          'Le client recevra l’e-mail de devis avec les prix, l’intérêt et les totaux actuels. Vérifiez toutes les lignes avant d’envoyer.',
        sendConfirm: 'Envoyer le devis',
        rejectConfirmTitle: 'Refuser cette demande de devis ?',
        rejectConfirmDescription:
          'La demande sera marquée comme refusée et le motif de refus sera enregistré. Vous pouvez encore modifier le motif depuis léditeur avant de confirmer.',
        rejectConfirm: 'Refuser la demande',
        cancelConfirm: 'Annuler',
        quoteSaved: 'Brouillon enregistré avec succès.',
        quoteSent: 'Devis envoyé avec succès.',
        requestDeclined: 'Demande refusée.',
        requestArchived: 'Demande archivée.',
        saveFailed: 'Échec de sauvegarde de la demande.',
        rejectionReasonRequired: 'Veuillez ajouter un motif de refus avant de refuser.',
        archivedAtLabel: 'Archivée le {{date}} - lecture seule.',
        saveQuoteLockedReason: 'Enregistrer le brouillon reste disponible pour ramener une demande envoyée ou refusée à un brouillon modifiable.',
        archivedActionsReason: 'Cette demande est archivée, les actions admin sont en lecture seule.',
        sendQuoteLockedAfterSent: 'Le devis a déjà été envoyé au client. Enregistrez d abord un brouillon pour rouvrir la demande.',
        sendQuoteLockedAfterDeclined: 'La demande a été refusée, l envoi d un nouveau devis est désactivé.',
        rejectLockedAfterSent: 'Une demande envoyée ne peut pas être refusée. Archivez-la ou enregistrez d abord un brouillon.',
        rejectLockedAfterDeclined: 'Cette demande a déjà été refusée.',
        archiveLockedAlreadyArchived: 'Cette demande est déjà archivée.',
        clearSelection: 'Effacer la sélection',
        selectedCount: '{{count}} sélectionnée(s)',
        bulkDelete: 'Supprimer {{count}}',
        bulkDeleteTitle: 'Supprimer les demandes sélectionnées ?',
        bulkDeleteDescription:
          '{{count}} demande sera déplacée dans la corbeille. Vous pourrez la restaurer depuis la page corbeille plus tard.',
        bulkDeleteConfirm: 'Supprimer {{count}}',
        bulkDeleteSuccess: '{{count}} demande déplacée dans la corbeille.',
        singleDeleteTitle: 'Supprimer cette demande ?',
        singleDeleteDescription:
          'La demande {{requestNumber}} ({{customerName}}) sera déplacée dans la corbeille. Vous pourrez la restaurer depuis la page corbeille plus tard.',
        singleDeleteConfirm: 'Supprimer la demande',
        deleteFailed: 'Échec de la suppression de la demande.',
        deleteSuccess: 'Demande {{requestNumber}} déplacée dans la corbeille.',
      },
      trash: {
        title: 'Corbeille',
        subtitle: "Récupérez les produits, types de produits, pièces, showrooms, membres d'équipe et utilisateurs supprimés.",
        noPermission: "Vous n'avez pas l'autorisation de voir la corbeille.",
        loadFailed: 'Échec du chargement de la corbeille.',
        restoreFailed: "Échec de restauration de l'élément.",
        restoreSuccess: 'Élément restauré avec succès.',
        restoreItemsFailed: 'Échec de restauration des éléments.',
        deleteItemsFailed: 'Échec de suppression des éléments.',
        restoredCount: 'Restauré',
        deletedCount: 'Supprimé',
        loadingTitle: 'Chargement de la corbeille...',
        loadingDescription: 'Récupération des éléments supprimés.',
        failedTitle: 'Échec du chargement de la corbeille',
        restoring: 'Restauration...',
        restoreAll: 'Tout restaurer',
        deleting: 'Suppression...',
        deleteAll: 'Tout supprimer',
        searchPlaceholder: 'Rechercher les éléments supprimés...',
        emptyText: 'La corbeille est vide.',
        entity: 'Entité',
        item: 'Element',
        deletedAt: 'Supprimé le',
        deletedBy: 'Supprimé par',
        restore: 'Restaurer',
        administrator: 'Administrateur',
        deleteTitle: 'Supprimer tous les éléments de la corbeille ?',
        deleteDescription: 'Voulez-vous vraiment supprimer ?',
        deleteAllLabel: 'Tout supprimer',
        allEntities: 'Toutes les entités',
        products: 'Produits',
        productTypes: 'Types de produits',
        spareParts: 'Pièces de rechange',
        showrooms: 'Showrooms',
        teamMembers: "Membres de l'équipe",
        users: 'Utilisateurs',
        product: 'Produit',
        productType: 'Type de produit',
        sparePart: 'Pièce de rechange',
        showroom: 'Showroom',
        team: "Membre d'équipe",
        user: 'Utilisateur',
        unknown: 'Inconnu',
      },
      dashboard: {
        title: 'Tableau de bord',
        subtitle: "Surveillez les produits, les utilisateurs et la maintenance en un coup d'œil.",
        noPermission: "Vous n'avez pas l'autorisation d'accéder au tableau de bord.",
        tourLabel: 'Visite du tableau de bord',
        tourIntroTitle: 'Bienvenue sur le tableau de bord',
        tourIntroDescription:
          "Utilisez cette visite pour repérer les problèmes de santé du site, actualiser les données et ouvrir les commandes de maintenance sans quitter la page.",
        tourIntroHint: 'Commencez par les commandes principales',
        tourMaintenanceTitle: 'Commandes de maintenance',
        tourMaintenanceDescription:
          "Ce panneau vous permet d’activer ou désactiver le mode maintenance, de choisir sa durée et d’appliquer le changement en toute sécurité.",
        tourMaintenanceHint: 'Mettez le site en pause au besoin',
        tourFiltersTitle: 'Période de reporting et actualisation',
        tourFiltersDescription:
          "Choisissez une période de reporting, activez l’actualisation automatique ou récupérez le dernier instantané pour garder des chiffres à jour.",
        tourFiltersHint: 'Réglez le rapport',
        tourMetricsTitle: 'Cartes KPI',
        tourMetricsDescription:
          "Ces cartes résument les indicateurs essentiels : nouveaux produits, croissance des utilisateurs, valeur du stock, alertes et évolutions.",
        tourMetricsHint: 'Lisez les chiffres clés',
        tourTrendsTitle: 'Graphiques et tendances',
        tourTrendsDescription:
          "Utilisez les graphiques et la répartition par catégorie pour comprendre ce qui progresse, ce qui ralentit et l’état du stock dans le temps.",
        tourTrendsHint: 'Comparez ce qui bouge',
        tourActivityTitle: 'Activité récente',
        tourActivityDescription:
          "Les événements récents liés aux produits, aux utilisateurs et à l’audit apparaissent ici pour ouvrir rapidement les derniers changements.",
        tourActivityHint: 'Ouvrez les derniers enregistrements',
        activityJustNow: "À l'instant",
        activityMinutesAgo: 'il y a {{count}} min',
        activityHoursAgo: 'il y a {{count}} h',
        activityYesterday: 'Hier',
        activityDaysAgo: 'il y a {{count}} j',
        activityStatusSuccess: 'Réussi',
        activityStatusFailure: 'Échoué',
        activityBy: 'par {{name}}',
        activityRoleAdmin: 'Admin',
        activityRoleEditor: 'Éditeur',
        activityRoleViewer: 'Lecteur',
        activityViewRecord: 'Voir l’enregistrement',
        activityEntityProduct: 'Produit',
        activityEntityUser: 'Utilisateur',
        activityEntitySparePart: 'Pièce détachée',
        activityEntityAdmin: 'Admin',
        activityEntitySession: 'Session',
        activityEntityBrand: 'Marque',
        activityEntityShowroom: 'Showroom',
        activityEntityPromo: 'Promo',
        activityEntityRequest: 'Demande',
        tourRecordsTitle: 'Enregistrements récents',
        tourRecordsDescription:
          "Les produits et utilisateurs récents restent visibles ici pour garder un œil sur les dernières mises à jour, même sans le journal d’audit.",
        tourRecordsHint: 'Consultez les dernières entrées',
        productsOverviewFailed: 'Échec du chargement de la vue produits.',
        usersOverviewFailed: 'Échec du chargement de la vue utilisateurs.',
        loadFailed: 'Échec du chargement du tableau de bord.',
        loadDataFailed: "Les données du tableau de bord n'ont pas pu être chargées.",
        loadingTitle: 'Chargement du tableau de bord...',
        loadingDescription: "Collecte des indicateurs et de l'activité.",
        incompleteTitle: 'Les données du tableau de bord sont incomplètes',
        analyticsWindow: 'Fenêtre de reporting',
        comparedPrevious: 'comparée à la période équivalente précédente',
        lastUpdated: 'Dernière mise à jour',
        to: 'a',
        autoRefresh: 'Actualisation auto',
        refreshing: 'Actualisation...',
        refreshNow: 'Actualiser maintenant',
        qualityNotes: 'Notes sur la qualité des données',
        excludedRecords: 'Enregistrements exclus des tendances (dates manquantes/invalides).',
        productAnomalies: 'Anomalies produits',
        invalidPrices: 'prix invalides',
        invalidStockValues: 'stocks invalides',
        rangeLast7: '7 derniers jours',
        rangeLast30: '30 derniers jours',
        rangeLast90: '90 derniers jours',
        rangeLast12m: '12 derniers mois',
        rangeCustom: 'Plage personnalisée',
        liveReport: 'Rapport en direct',
        overviewEyebrow: 'Aperçu',
        overviewDescription: "Indicateurs clés au premier coup d'œil.",
        moreMetricsEyebrow: 'Plus de métriques',
        newProducts: 'Nouveaux produits',
        newUsers: 'Nouveaux utilisateurs',
        inventoryValueAdded: 'Valeur de stock ajoutée',
        stockAlerts: 'Alertes stock',
        outOfStock: 'en rupture',
        productVelocityDay: 'Vitesse produits / jour',
        userVelocityDay: 'Vitesse utilisateurs / jour',
        inStockCoverage: 'Couverture en stock',
        averageProductPrice: 'Prix moyen produit',
        total: 'Total',
        prev: 'Préc.',
        products: 'produits',
        averageStock: 'Stock moyen',
        units: 'unités',
        uncategorized: 'Sans catégorie',
        prevPerDay: 'Préc. {{value}}/jour',
        stockHealth: 'Santé du stock',
        stockHealthy: 'Sain (>5)',
        stockLow: 'Faible (1-5)',
        stockOut: 'Rupture (0)',
        kpiDepth: 'Indicateurs clés',
        lowStockRisk: 'Risque stock faible',
        outOfStockRisk: 'Risque rupture',
        productsCreatedPerDay: 'Produits créés / jour',
        usersCreatedPerDay: 'Utilisateurs créés / jour',
        excludedDateRecords: 'Enregistrements de dates exclus',
        invalidProductValues: 'Valeurs produit invalides',
        productsCountHint: '{{count}} produits',
        dayWindow: 'fenêtre de {{days}} jours',
        excludedDateHint: '{{productCount}} produit + {{userCount}} utilisateur',
        invalidValuesHint: '{{priceCount}} prix + {{stockCount}} stock',
        topInventoryValue: 'Valeur totale du stock',
        viewAll: 'Voir tout',
        noProductsYet: 'Aucun produit pour le moment.',
        stockAtPrice: 'Stock : {{stock}} @ {{price}}',
        analysisEyebrow: 'Analyse',
        analysisBlockTitle: "Vue d'ensemble des analyses",
        analysisBlockDescription:
          "Tendances clés, mix des catégories et santé du stock en un coup d'œil.",
        analysisDescription:
          'Évolution mensuelle des produits et des utilisateurs sur la période sélectionnée.',
        categoryMomentum: 'Dynamique des catégories',
        compositionEyebrow: 'Composition',
        groups: '{{count}} groupes',
        noCategoryTrendData: 'Aucune tendance catégorie disponible.',
        noCategoryData: 'Aucune donnée catégorie disponible.',
        currentPrevious: 'Actuel {{current}} | Précédent {{previous}}',
        statusEyebrow: 'État',
        diagnosticsEyebrow: 'Diagnostics',
        leadersEyebrow: 'Leaders',
        momentumEyebrow: 'Momentum',
        catalogEyebrow: 'Catalogue',
        peopleEyebrow: 'Utilisateurs',
        auditLogEyebrow: "Journal d'audit",
        recentProducts: 'Produits récents',
        noDate: 'Sans date',
        noUsersYet: 'Aucun utilisateur pour le moment.',
        userAvatarAlt: 'Avatar utilisateur',
        recentUsers: 'Utilisateurs récents',
        quickActions: 'Actions rapides',
        addProduct: 'Ajouter produit',
        addUser: 'Ajouter utilisateur',
        operationalHealth: 'Santé opérationnelle',
        profileSettings: 'Paramètres du profil',
        coverEyebrow: 'Aperçu admin',
        coverTitle: 'Centre de contrôle administrateur',
        coverDescription:
          "Suivez la maintenance, les produits, les utilisateurs et l'activité récente depuis un seul endroit.",
        coverTimeLabel: 'Heure actuelle',
        coverDateLabel: 'Date actuelle',
        coverBadge: 'Vue opérationnelle',
        coverCaption:
          "Statut de maintenance, changements de contenu et activité des comptes en un coup d'œil.",
        siteMaintenanceTitle: 'Contrôle de maintenance',
        siteMaintenanceControl: 'Réglages',
        siteMaintenanceDescription:
          "Mettez le site public en pause pendant vos modifications côté serveur. L'accès admin reste disponible pendant toute la durée.",
        siteMaintenanceActive: 'La maintenance est activée.',
        siteMaintenanceInactive: 'La maintenance est désactivée.',
        siteMaintenanceEnabledNotice:
          'Les visiteurs seront redirigés vers la page de maintenance.',
        siteMaintenanceDisabledNotice:
          'Les visiteurs peuvent accéder normalement au site public.',
        siteMaintenanceSaving: 'Enregistrement du paramètre de maintenance...',
        siteMaintenanceToastOn: 'Mode maintenance activé.',
        siteMaintenanceToastOff: 'Mode maintenance désactivé.',
        siteMaintenanceDurationTitle: 'Durée',
        siteMaintenanceDurationSummary: '{{amount}} {{unit}}',
        siteMaintenanceDurationNone: 'Aucun',
        siteMaintenanceDurationIndefinite: 'Bientôt disponible',
        siteMaintenanceDurationLong: 'Bientôt disponible',
        siteMaintenancePresetNone: 'Aucun',
        siteMaintenancePresetLong: 'Bientôt disponible',
        siteMaintenanceDurationMinute: 'Minute',
        siteMaintenanceDurationMinutes: 'Minutes',
        siteMaintenanceDurationHours: 'Heures',
        siteMaintenanceDurationHour: 'Heure',
        siteMaintenanceDurationDays: 'Jours',
        siteMaintenanceDurationDay: 'Jour',
        siteMaintenanceDurationAmount: 'Quantité',
        siteMaintenanceCustomTime: 'Temps personnalisé',
        siteMaintenanceCustomUnit: 'Unité',
        siteMaintenanceCustomHint: "Jusqu'à 12 heures",
        siteMaintenanceEndsAt: 'Se termine à',
        siteMaintenanceApply: 'Appliquer',
        siteMaintenancePendingChanges: 'Modifications non enregistrées',
        siteMaintenanceNoChanges: 'Aucune modification à appliquer',
        siteMaintenanceTimeLeft: 'Temps restant',
        siteMaintenanceOverviewState: 'État',
        siteMaintenanceOverviewDuration: 'Durée',
        siteMaintenanceOverviewChanges: 'Modifications',
        siteMaintenanceOverviewLive: 'En ligne',
        siteMaintenanceOverviewMaintenance: 'Maintenance',
        siteMaintenanceOverviewVisitors: 'Accès visiteurs',
        siteMaintenanceOverviewVisitorsOpen: 'Ouvert',
        siteMaintenanceOverviewVisitorsPaused: 'En pause',
        siteMaintenanceOverviewAdmin: 'Accès admin',
        siteMaintenanceOverviewAdminOnline: 'En ligne',
        siteMaintenanceOverviewPending: 'En attente',
        siteMaintenanceOverviewReady: 'Prêt',
        recentActivity: 'Activité récente',
        openAuditTrail: "Ouvrir l'historique d'audit",
        noRecentAuditEvents: "Aucun événement d'audit récent.",
        growthTrendLast6Months: 'Tendance de croissance (6 derniers mois)',
        trendProductsUsers: 'Produits {{products}} | Utilisateurs {{users}}',
        productsLabel: 'Produits',
        usersLabel: 'Utilisateurs',
        categoryMix: 'Mix de catégories',
        durationMinutes15: '15m',
        durationMinutes30: '30m',
        durationMinutes45: '45m',
        durationHours1: '1h',
        durationHours3: '3h',
        durationHours6: '6h',
        durationHours12: '12h',
        durationDays1: '1j',
        durationSeconds15: '15s',
        durationSeconds30: '30s',
        durationSeconds60: '60s',
        durationSeconds120: '120s',
        toolsEyebrow: 'Commandes secondaires',
        adminTools: 'Outils administrateur',
        toolsDescription:
          "Le mode maintenance, la fenêtre de reporting et l'actualisation sont ici pour garder le tableau de bord facile à parcourir.",
        insightsTab: 'Aperçu',
        stockTab: 'Stock',
        recordsTab: 'Enregistrements',
        usersTab: 'Utilisateurs',
        diagnosticsTab: 'Diagnostics',
        usersEyebrow: 'Utilisateurs',
        userSignupTrend: 'Tendance des inscriptions',
        userSignupTrendDescription:
          "Ce graphique montre l'évolution des nouveaux comptes au cours des six derniers mois à partir des dates existantes.",
        userRoleMix: 'Répartition des rôles',
        successRate: 'Taux de réussite',
        failures: 'Échecs',
        snapshot: 'Aperçu',
        auditSnapshot: "Aperçu de l'activité",
        latestActivity: 'Dernière activité',
        topActor: 'Acteur principal',
        auditCoverage: "Couverture de l'audit",
        adminLogin: 'Connexion admin',
        adminProfileUpdate: 'Mise à jour du profil admin',
        productCreate: 'Produit créé',
        productUpdate: 'Produit mis à jour',
        productDelete: 'Produit supprimé',
        userCreate: 'Utilisateur créé',
        userUpdate: 'Utilisateur mis à jour',
        userDelete: 'Utilisateur supprimé',
        newSpareParts: 'Nouvelles pièces détachées',
        sparePartsLabel: 'Pièces détachées',
        sparePartsOverviewFailed: 'Échec du chargement de la vue pièces détachées.',
        keyMetrics: 'Indicateurs clés',
        totalUsers: 'Total utilisateurs',
        dataQuality: 'Qualité des données',
        windowOverview: 'Aperçu de la fenêtre',
        quickSignals: 'Signaux rapides',
        tourActivityTitle: 'Activité récente',
        tourActivityDescription:
          "Les produits, utilisateurs et événements d'audit récents apparaissent ici pour ouvrir rapidement les derniers changements.",
        tourActivityHint: 'Consultez les derniers enregistrements',
        tourRecordsTitle: 'Enregistrements récents',
        tourRecordsDescription:
          "Les produits et utilisateurs récents sont regroupés ici pour rester visibles même sans le journal d'audit.",
        tourRecordsHint: 'Vérifiez les dernières entrées',
      },
      maintenance: {
        title: 'Nous sommes temporairement hors ligne',
        description: 'Le site web est temporairement indisponible pendant nos mises à jour.',
        eyebrow: 'Mode maintenance',
        secondary:
          "Le tableau de bord admin reste disponible, afin que les travaux côté serveur puissent continuer en toute sécurité.",
        adminAccess: 'Accès admin',
        noteLabel: 'Statut',
        noteTitle: 'Merci de revenir bientôt',
        noteBody:
          'Nous améliorons le système en arrière-plan et le site public sera rétabli une fois le travail terminé.',
        durationLabel: 'Durée',
        durationHour: 'heure',
        durationHours: 'heures',
        durationDay: 'jour',
        durationDays: 'jours',
        durationValue: '{{amount}} {{unit}}',
        indefinite: 'Bientôt disponible',
        endsAtLabel: 'Se termine à',
        noEndDate: 'Aucune date de fin fixe',
        timeRemainingLabel: 'Temps restant',
        autoReturnNote: 'Le site web redeviendra accessible automatiquement quand le compteur se termine.',
        comingSoonNote: 'Nous serons de retour bientôt.',
        remainingDaysHours: '{{days}}j {{hours}}h restantes',
      },
      users: {
        title: 'Utilisateurs',
        subtitle: 'Créer, modifier et supprimer des comptes avec rôles.',
        manageSubtitle: 'Gérer les utilisateurs et les rôles.',
        loadingTitle: 'Chargement des utilisateurs...',
        loadingDescription: 'Récupération des comptes et rôles.',
        noReadPermission: "Vous n'avez pas l'autorisation de voir les utilisateurs.",
        noWritePermission: "Vous n'avez pas l'autorisation d'ajouter des utilisateurs.",
        noDeletePermission: "Vous n'avez pas l'autorisation de supprimer des utilisateurs.",
        noEditPermission: "Vous n'avez pas l'autorisation de modifier des utilisateurs.",
        tourLabel: 'Visite des utilisateurs',
        tourIntroTitle: 'Les utilisateurs en un coup d’œil',
        tourIntroDescription:
          "Cette page sert à consulter les comptes, rechercher des utilisateurs et garder les accès à jour.",
        tourIntroHint: 'Commencez par l’annuaire',
        tourToolbarTitle: 'Actions groupées et export',
        tourToolbarDescription:
          "Utilisez la barre d’outils pour supprimer les utilisateurs sélectionnés, exporter les enregistrements et garder les modifications de liste bien organisées.",
        tourToolbarHint: 'Gérez les comptes',
        tourTableTitle: 'Rechercher et consulter les utilisateurs',
        tourTableDescription:
          "Recherchez par nom, e-mail, téléphone ou rôle, puis triez et sélectionnez plusieurs lignes quand vous devez agir sur plusieurs comptes.",
        tourTableHint: 'Inspectez le tableau',
        addTourLabel: 'Visite d’ajout d’utilisateur',
        addTourIntroTitle: 'Créer un compte utilisateur',
        addTourIntroDescription:
          "Utilisez ce formulaire pour ajouter la personne, définir un mot de passe et téléverser un avatar avant d’enregistrer le compte.",
        addTourIntroHint: 'Commencez par les bases',
        addTourBasicsTitle: 'Informations d’identité',
        addTourBasicsDescription:
          "Renseignez le prénom, le nom, l’e-mail et le numéro de téléphone afin d’identifier rapidement le compte.",
        addTourBasicsHint: 'Saisissez les coordonnées',
        addTourAccessTitle: 'Mot de passe',
        addTourAccessDescription:
          "Définissez un mot de passe avant de créer le compte afin que l’utilisateur puisse se connecter en toute sécurité.",
        addTourAccessHint: 'Créez un accès sécurisé',
        addTourAvatarTitle: 'Photo de profil',
        addTourAvatarDescription:
          "Téléversez une photo de profil pour que l’utilisateur soit plus facile à reconnaître dans les listes, notifications et références internes.",
        addTourAvatarHint: 'Ajoutez l’avatar',
        addTourSaveTitle: 'Enregistrer ou abandonner',
        addTourSaveDescription:
          "Utilisez les boutons du bas pour créer l’utilisateur ou effacer le brouillon et recommencer.",
        addTourSaveHint: 'Terminez le formulaire',
        loadFailed: 'Échec du chargement des utilisateurs.',
        cannotCreateTitle: "Impossible de créer l'utilisateur",
        createFailed: "Échec de création de l'utilisateur.",
        createdSuccess: 'Utilisateur créé avec succès.',
        unexpectedError: 'Erreur inattendue, veuillez reessayer.',
        firstNameRequired: 'Le prénom est requis.',
        lastNameRequired: 'Le nom est requis.',
        phoneRequired: 'Le téléphone est requis.',
        avatarRequired: 'La photo de profil est requise.',
        emailRequired: "L'email est requis.",
        invalidEmail: 'Veuillez saisir une adresse email valide.',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caracteres.',
        passwordRequired: 'Le mot de passe est requis.',
        deletedSuccess: 'Utilisateur supprimé avec succès.',
        deleteFailed: 'Échec de suppression.',
        exportFailed: "Échec de l'export.",
        importFailed: "Échec de l'import.",
        uploadFailed: 'Échec du téléversement',
        failedTitle: 'Échec du chargement des utilisateurs',
        searchPlaceholder: 'Rechercher des utilisateurs...',
        emptyText: 'Aucun utilisateur trouve.',
        saveChanges: 'Enregistrer',
        saving: 'Enregistrement...',
        discard: 'Annuler',
        upload: 'Téléverser',
        uploadHint: 'Ajoutez une photo pour personnaliser le compte.',
        removePhoto: 'Retirer la photo',
        photoUploaded: 'Photo téléversée.',
        accountSettings: 'Paramètres du compte',
        publicProfileHint: 'Gérer les informations publiques du profil',
        firstName: 'Prénom',
        firstNamePlaceholder: 'Jane',
        lastName: 'Nom',
        lastNamePlaceholder: 'Doe',
        emailAddress: 'Adresse email',
        emailPlaceholder: 'jane@example.com',
        phone: 'Téléphone',
        phonePlaceholder: '+216 00 000 000',
        role: 'Rôle',
        password: 'Mot de passe',
        passwordPlaceholder: 'Minimum 6 caracteres',
        editor: 'Editeur',
        viewer: 'Lecteur',
        user: 'Utilisateur',
        unnamedUser: 'Utilisateur sans nom',
        newAccountDescription: '{{fullName}} ({{email}}) - Nouveau compte créé',
        bulkDeleteSuccess: '{{count}} utilisateur(s) supprimé(s).',
        bulkDeleteFailed: "{{count}} utilisateur(s) n'ont pas pu être supprimés.",
        exportedAs: 'Utilisateurs exportés en {{format}}.',
        importComplete: 'Import terminé : {{created}} créés, {{updated}} mis à jour, {{skipped}} ignorés.',
        selectAllUsers: 'Sélectionner tous les utilisateurs',
        userCol: 'Utilisateur',
        emailCol: 'Email',
        phoneCol: 'Téléphone',
        roleCol: 'Rôle',
        createdCol: 'Créé le',
        actionsCol: 'Actions',
        editUser: "Modifier l'utilisateur",
        deleteUser: "Supprimer l'utilisateur",
        editTitle: "Modifier l'utilisateur",
        editSubtitle: "Mettre à jour les détails de l'utilisateur.",
        loadingSingleTitle: "Chargement de l'utilisateur...",
        loadingSingleDescription: "Récupération des détails de l'utilisateur.",
        loadSingleFailed: "Échec du chargement de l'utilisateur.",
        userNotFound: 'Utilisateur introuvable.',
        updateFailed: "Échec de mise à jour de l'utilisateur.",
        updatedSuccess: 'Utilisateur mis à jour avec succès.',
        unableSave: "Impossible d'enregistrer l'utilisateur",
        reloadUser: "Recharger l'utilisateur",
        adminRoleLocked: "Le rôle admin est verrouillé et ne peut pas être modifié.",
        newPassword: 'Nouveau mot de passe',
        keepCurrentPassword: 'Laisser vide pour conserver le mot de passe actuel',
        deleteSelected: 'Supprimer les utilisateurs sélectionnés ?',
        deleteSingle: 'Supprimer cet utilisateur ?',
        deleteManyDesc: 'Cela supprimera définitivement',
        deleteManyDescWithCount: 'Cela supprimera définitivement {{count}} utilisateur(s).',
        actionUndone: 'Cette action est irreversible.',
        delete: 'Supprimer',
      },
      products: {
        title: 'Produits',
        subtitle: 'Créer, mettre à jour et supprimer des produits.',
        loadingTitle: 'Chargement des produits...',
        loadingDescription: 'Récupération des derniers produits.',
        loadingSingleTitle: 'Chargement du produit...',
        loadingSingleDescription: 'Récupération des détails du produit.',
        noReadPermission: "Vous n'avez pas l'autorisation de voir les produits.",
        noWritePermission: "Vous n'avez pas l'autorisation d'ajouter des produits.",
        noDeletePermission: "Vous n'avez pas l'autorisation de supprimer des produits.",
        noEditPermission: "Vous n'avez pas l'autorisation de modifier des produits.",
        tourLabel: 'Visite des produits',
        addTourLabel: 'Visite d’ajout de produit',
        tourIntroTitle: 'Les produits en un coup d’œil',
        tourIntroDescription:
          "Utilisez cette page pour parcourir le catalogue, rechercher des produits et garder les fiches alignées avec le stock actuel.",
        tourIntroHint: 'Commencez par la liste',
        tourToolbarTitle: 'Actions groupées et imports',
        tourToolbarDescription:
          "Cette barre d’outils gère les sélections groupées, les exports, les imports et la saisie JSON pour que vous puissiez mettre à jour plusieurs éléments plus vite.",
        tourToolbarHint: 'Gérez plusieurs éléments',
        tourTableTitle: 'Rechercher, filtrer et modifier les lignes',
        tourTableDescription:
          "Utilisez la recherche, les filtres de type, le tri et les cases à cocher pour cibler exactement les produits dont vous avez besoin.",
        tourTableHint: 'Affinez le tableau',
        addTourIntroTitle: 'Créer un produit',
        addTourIntroDescription:
          "Utilisez ce formulaire pour saisir le nom du produit, la description, le prix, la configuration du catalogue, la disponibilité et les images avant d’enregistrer.",
        addTourIntroHint: 'Commencez par les bases',
        addTourBasicsTitle: 'Langue, nom, description, prix et stock',
        addTourBasicsDescription:
          "Choisissez d’abord l’onglet de langue, puis saisissez le nom et la description du produit, ainsi que le prix et le stock, avant de passer aux autres champs du catalogue.",
        addTourBasicsHint: 'Rédigez le contenu public',
        addTourSpecsTitle: 'Marque et type de produit',
        addTourSpecsDescription:
          "Choisissez la marque et le type de produit, puis complétez les champs techniques qui s’appliquent à ce schéma.",
        addTourSpecsHint: 'Configurez les détails',
        addTourAvailabilityTitle: 'Disponibilité par showroom',
        addTourAvailabilityDescription:
          "Sélectionnez les showrooms où ce produit est disponible afin que le catalogue reflète correctement où les clients peuvent le trouver.",
        addTourAvailabilityHint: 'Choisissez où il est vendu',
        addTourMediaTitle: 'Images du produit',
        addTourMediaDescription:
          "Téléversez les principales photos du produit, puis réorganisez-les pour que la meilleure image apparaisse en premier dans la galerie.",
        addTourMediaHint: 'Organisez la galerie',
        addTourSaveTitle: 'Enregistrer ou abandonner',
        addTourSaveDescription:
          "Utilisez la barre d’actions pour enregistrer le nouveau produit ou abandonner le brouillon et revenir au catalogue.",
        addTourSaveHint: 'Terminez le formulaire',
        loadFailed: 'Échec du chargement des produits.',
        failedTitle: 'Échec du chargement des produits',
        productNameRequired: 'Le nom du produit est requis.',
        categoryRequired: 'La catégorie du produit est requise.',
        brandRequired: 'La marque du produit est requise.',
        requiredSpecField: 'Le champ {{field}} est requis.',
        invalidPrice: 'Le prix doit être un nombre positif valide.',
        invalidStock: 'Le stock doit être un nombre positif valide.',
        createFailed: 'Impossible de créer le produit.',
        createdSuccess: 'Produit créé avec succès.',
        deletedSuccess: 'Produit supprimé avec succès.',
        updatedSuccess: 'Produit mis à jour.',
        updateFailed: 'Échec de mise à jour du produit.',
        loadSingleFailed: 'Échec du chargement du produit.',
        deleteFailed: 'Échec de suppression.',
        exportFailed: "Échec de l'export.",
        importFailed: "Échec de l'import.",
        uploadFailed: 'Échec du téléversement',
        imageUploaded: 'Image téléversée.',
        saveAll: 'Tout enregistrer',
        addViaJson: 'Ajouter via JSON',
        searchPlaceholder: 'Rechercher des produits...',
        emptyText: 'Aucun produit.',
        typeFilter: 'Type',
        settingsTitle: 'Paramètres produit',
        settingsHint: 'Gérez les détails et le stock du produit',
        productName: 'Nom du produit',
        productType: 'Type de produit',
        productTypeHint: 'Sélectionnez un type pour charger ses champs techniques.',
        showroomsTitle: 'Disponibilité',
        showroomsHint: 'Choisissez où ce produit est disponible.',
        addShowroom: 'Ajouter un showroom',
        showroomLabel: 'Showroom',
        showroomName: 'Nom du showroom',
        showroomAddress: 'Adresse',
        showroomPhone: 'Téléphone',
        showroomEmail: 'Email',
        showroomAvailable: 'Disponible',
        showroomUnavailable: 'Indisponible',
        removeShowroom: 'Retirer le showroom',
        showroomsEmpty: 'Aucun showroom ajouté.',
        namePlaceholder: 'Produit premium',
        price: 'Prix',
        pricePlaceholder: '0,000',
        stock: 'Stock',
        stockPlaceholder: '0',
        specNumberPlaceholder: '0',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez les caractéristiques, matières et usages du produit.',
        cannotCreate: 'Impossible de créer le produit',
        saving: 'Enregistrement...',
        saveChanges: 'Enregistrer',
        discard: 'Annuler',
        addImage: 'Ajouter image',
        imageHint: 'Ajoutez des visuels pour améliorer la fiche produit.',
        imageLimitHint: "{{current}} / {{count}} images téléversées. Vous pouvez téléverser jusqu'à {{count}} images.",
        imageLimitReached: "Vous pouvez téléverser jusqu'à {{count}} images seulement.",
        removeImage: 'Retirer image',
        imagePreviewAlt: 'aperçu',
        selectAllProducts: 'Sélectionner tous les produits',
        nameCol: 'Nom',
        priceCol: 'Prix',
        stockCol: 'Stock',
        specsCol: 'Spécifications',
        specsNone: 'Aucune spécification',
        imagesCol: 'Images',
        actionsCol: 'Actions',
        saveChangesAction: 'Enregistrer les changements',
        savingChangesAction: 'Enregistrement des changements',
        bulkSaveSuccess: '{{count}} produit(s) enregistré(s).',
        bulkSaveFailed: "{{count}} produit(s) n'ont pas pu être enregistrés.",
        bulkDeleteSuccess: '{{count}} produit(s) supprimé(s).',
        bulkDeleteFailed: "{{count}} produit(s) n'ont pas pu être supprimés.",
        exportedAs: 'Produits exportés en {{format}}.',
        importComplete: 'Import terminé : {{created}} créés, {{updated}} mis à jour, {{skipped}} ignorés.',
        jsonRequired: 'La saisie JSON est requise.',
        jsonObjectOrArray: "Le JSON doit être un objet ou un tableau d'objets.",
        invalidJson: 'Format JSON invalide.',
        jsonModalHint: 'Collez uniquement du JSON valide. Objet ou tableau requis.',
        jsonPlaceholder: '[{"name":"Produit","price":10,"stock":5}]',
        importJson: 'Importer JSON',
        importingJson: 'Import en cours...',
        editProduct: 'Modifier le produit',
        editTitle: 'Modifier le produit',
        editSubtitle: 'Mettre à jour les détails du produit.',
        unableSave: "Impossible d'enregistrer le produit",
        reloadItem: 'Recharger le produit',
        deleteProduct: 'Supprimer le produit',
        deleteSelected: 'Supprimer les produits sélectionnés ?',
        deleteSingle: 'Supprimer ce produit ?',
        deleteManyDesc: 'Cela supprimera définitivement',
        deleteManyDescWithCount: 'Cela supprimera définitivement {{count}} produit(s).',
        actionUndone: 'Cette action est irreversible.',
        delete: 'Supprimer',
        unclassifiedType: 'Non classé',
        noTechnicalFieldsYet: 'Aucun champ technique spécifique pour ce type pour le moment.',
      },
      showrooms: {
        title: 'Showrooms',
        subtitle: 'Gérer les showrooms et leurs contacts.',
        listTitle: 'Showrooms',
        listSubtitle: 'Gérer les showrooms et leurs contacts.',
        addTitle: 'Ajouter un showroom',
        addSubtitle: 'Créer un nouveau showroom.',
        editTitle: 'Modifier un showroom',
        editSubtitle: 'Mettre à jour les détails du showroom.',
        nameLabel: 'Nom du showroom',
        nameLabelEn: 'Nom du showroom (anglais)',
        nameLabelFr: 'Nom du showroom (français)',
        addressLabel: 'Adresse',
        addressLabelEn: 'Adresse (anglais)',
        addressLabelFr: 'Adresse (français)',
        contactLabel: 'Contact',
        actionsLabel: 'Actions',
        statusLabel: 'Statut',
        statusActive: 'Actif — cliquer pour désactiver',
        statusDisabled: 'Désactivé — cliquer pour activer',
        statusActiveTitle: 'Visible sur le site public',
        statusDisabledTitle: 'Masqué du site public',
        statusActiveShort: 'Actif',
        statusDisabledShort: 'Désactivé',
        statusUpdating: 'Mise à jour...',
        activeLabel: 'Actif (visible sur le site public)',
        activeHelp:
          'Désactivez cette option pour masquer le showroom des produits, de la page de contact et de la page de pièces détachées sans le supprimer.',
        enabledSuccess: 'Le showroom est maintenant visible sur le site public.',
        disabledSuccess: 'Le showroom est maintenant masqué du site public.',
        phoneLabel: 'Téléphone',
        emailLabel: 'Email',
        namePlaceholder: 'Showroom principal',
        namePlaceholderEn: 'Main Showroom',
        namePlaceholderFr: 'Showroom principal',
        addressPlaceholder: 'Adresse du showroom',
        addressPlaceholderEn: 'Showroom address',
        addressPlaceholderFr: 'Adresse du showroom',
        phonePlaceholder: '+216 00 000 000',
        emailPlaceholder: 'sales@example.com',
        addTourLabel: 'Visite de création de showroom',
        addTourIntroTitle: 'Créer un showroom',
        addTourIntroDescription:
          'Utilisez ce formulaire pour ajouter le nom du showroom, les coordonnées et l’emplacement avant l’enregistrement.',
        addTourIntroHint: 'Commencez par les bases',
        addTourBasicsTitle: 'Informations de contact',
        addTourBasicsDescription:
          'Saisissez le nom du showroom, l’adresse, le téléphone et l’e-mail pour que les clients puissent le joindre facilement.',
        addTourBasicsHint: 'Ajoutez les coordonnées',
        addTourLocationTitle: 'Aperçu de l’emplacement',
        addTourLocationDescription:
          'Renseignez la latitude et la longitude pour prévisualiser le showroom sur la carte avant de le publier.',
        addTourLocationHint: 'Vérifiez la carte',
        addTourSaveTitle: 'Enregistrer ou abandonner',
        addTourSaveDescription:
          'Utilisez la barre d’actions pour enregistrer le showroom ou abandonner le brouillon et revenir à la liste.',
        addTourSaveHint: 'Terminez le formulaire',
        addShowroom: 'Ajouter un showroom',
        saveChanges: 'Enregistrer',
        saving: 'Enregistrement...',
        discard: 'Annuler',
        editShowroom: 'Modifier showroom',
        deleteShowroom: 'Déplacer le showroom vers la corbeille',
        delete: 'Déplacer vers la corbeille',
        deleteSelected: 'Déplacer les showrooms sélectionnés vers la corbeille ?',
        deleteManyDescWithCount: '{{count}} showroom(s) seront déplacés vers la corbeille.',
        bulkDeleteSuccess: '{{count}} showroom(s) déplacés vers la corbeille.',
        bulkDeleteFailed: 'Échec de suppression de {{count}} showroom(s).',
        selectAllShowrooms: 'Sélectionner tous les showrooms',
        selectShowroom: 'Sélectionner le showroom',
        confirmDelete: 'Déplacer ce showroom vers la corbeille ?',
        confirmDeleteDescription: 'Vous pourrez restaurer ce showroom plus tard depuis la corbeille.',
        loadFailed: 'Échec du chargement des showrooms.',
        createFailed: 'Échec de création du showroom.',
        updateFailed: 'Échec de mise à jour du showroom.',
        deleteFailed: 'Échec de suppression du showroom.',
        createdSuccess: 'Showroom créé.',
        updatedSuccess: 'Showroom mis à jour.',
        deletedSuccess: 'Showroom déplacé vers la corbeille.',
        movedToInactiveSuccess:
          'Le showroom est encore référencé par des produits, il a donc été masqué du site public au lieu d’être supprimé. Vous pourrez le supprimer une fois les liens produit retirés.',
        failedTitle: 'Échec du chargement des showrooms',
        searchPlaceholder: 'Rechercher des showrooms...',
        emptyText: 'Aucun showroom.',
        nameRequired: 'Le nom du showroom est requis.',
        nameEnRequired: 'Le nom du showroom en anglais est requis.',
        nameFrRequired: 'Le nom du showroom en français est requis.',
        addressEnRequired: 'L’adresse du showroom en anglais est requise.',
        addressFrRequired: 'L’adresse du showroom en français est requise.',
        phoneRequired: 'Le téléphone est requis.',
        emailRequired: 'L’e-mail est requis.',
        invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
        loading: 'Chargement des showrooms...',
        loadingTitle: 'Chargement du showroom...',
        loadingDescription: 'Récupération des détails du showroom.',
        cannotCreate: 'Impossible de créer le showroom',
        unableSave: "Impossible d'enregistrer le showroom",
        reloadItem: 'Recharger le showroom',
        noReadPermission: "Vous n'avez pas l'autorisation de voir les showrooms.",
        noWritePermission: "Vous n'avez pas l'autorisation d'ajouter des showrooms.",
        noEditPermission: "Vous n'avez pas l'autorisation de modifier les showrooms.",
        noDeletePermission: "Vous n'avez pas l'autorisation de supprimer les showrooms.",
        mapUnavailableTitle: 'Aperçu de la carte indisponible',
        mapUnavailableDescription:
          'Google Maps est bloqué dans ce navigateur. Ouvrez directement l’emplacement dans Google Maps à la place.',
        openExternalMap: 'Ouvrir dans Google Maps',
        unnamed: 'Sans nom',
      },
      team: {
        title: 'Équipe',
        subtitle: "Gérer les membres de l'équipe et leurs photos publiques.",
        listTitle: 'Équipe',
        listSubtitle: "Gérer les membres de l'équipe et leurs photos publiques.",
        addTitle: 'Ajouter un membre',
        addSubtitle: "Créer un nouveau membre pour la page À propos.",
        editTitle: 'Modifier membre',
        editSubtitle: "Mettre à jour les informations et la photo du membre.",
        addTeamMember: 'Ajouter un membre',
        nameLabel: 'Nom complet',
        namePlaceholder: 'Jane Doe',
        genderLabel: 'Genre',
        genderPlaceholder: 'Choisir le genre',
        genderMaleOption: 'Masculin (M.)',
        genderFemaleOption: 'Féminin (Mme)',
        roleLabel: 'Rôle',
        rolePlaceholder: 'Rôle',
        roleEnLabel: 'Rôle (EN)',
        roleEnPlaceholder: 'Rôle',
        roleFrLabel: 'Rôle (FR)',
        roleFrPlaceholder: 'Rôle',
        sortOrderLabel: 'Ordre',
        dragHint: "Déplacez n'importe quelle ligne pour modifier l'ordre d’affichage public. La modification est enregistrée automatiquement au relâchement.",
        orderUpdated: 'Ordre des membres mis à jour.',
        orderUpdateFailed: "Échec de la mise à jour de l'ordre des membres.",
        photoTitle: 'Photo du membre',
        photoHint: "Téléchargez une image portrait pour la section équipe.",
        previewTitle: 'Aperçu',
        previewHint: "Voici le rendu du contenu du membre dans l'éditeur admin.",
        previewLanguageEnglish: 'Anglais',
        previewLanguageFrench: 'Français',
        previewName: "Membre d'équipe",
        rolePreview: 'Rôle',
        uploadImage: 'Télécharger image',
        uploadHint: 'Déposez une image ici ou cliquez pour télécharger',
        uploadHelper: 'Les images portrait fonctionnent le mieux pour le carrousel.',
        removeImage: "Retirer l'image",
        imageUploaded: 'Image téléchargée.',
        uploading: 'Téléchargement...',
        uploadFailed: 'Échec du téléchargement.',
        photoColumn: 'Photo',
        actionsLabel: 'Actions',
        editMember: 'Modifier membre',
        deleteMember: 'Supprimer membre',
        delete: 'Supprimer',
        deleteSelected: 'Déplacer les membres sélectionnés vers la corbeille ?',
        deleteManyDescWithCount: '{{count}} membre(s) seront déplacés vers la corbeille.',
        bulkDeleteSuccess: '{{count}} membre(s) déplacés vers la corbeille.',
        bulkDeleteFailed: 'Échec de suppression de {{count}} membre(s).',
        selectAllMembers: 'Sélectionner tous les membres',
        selectMember: 'Sélectionner membre',
        confirmDelete: 'Déplacer ce membre vers la corbeille ?',
        confirmDeleteDescription: 'Vous pourrez restaurer ce membre plus tard depuis la corbeille.',
        loadFailed: 'Échec du chargement des membres.',
        createFailed: 'Échec de création du membre.',
        updateFailed: 'Échec de mise à jour du membre.',
        deleteFailed: 'Échec de suppression du membre.',
        createdSuccess: 'Membre créé.',
        updatedSuccess: 'Membre mis à jour.',
        deletedSuccess: 'Membre déplacé vers la corbeille.',
        failedTitle: 'Échec du chargement des membres',
        searchPlaceholder: 'Rechercher des membres...',
        emptyText: 'Aucun membre pour le moment.',
        nameRequired: 'Le nom du membre est requis.',
        genderRequired: 'Le genre du membre est requis.',
        roleRequired: 'Le rôle du membre est requis.',
        imageRequired: 'La photo du membre est requise.',
        roleEnRequired: 'Le rôle en anglais est requis.',
        roleFrRequired: 'Le rôle en français est requis.',
        bioEnRequired: 'La biographie en anglais est requise.',
        bioFrRequired: 'La biographie en français est requise.',
        loadingTitle: 'Chargement du membre...',
        loadingDescription: 'Récupération des détails du membre.',
        cannotCreate: 'Impossible de créer le membre',
        unableSave: "Impossible d'enregistrer le membre",
        reloadItem: 'Recharger le membre',
        noReadPermission: "Vous n'avez pas l'autorisation de voir les membres.",
        noWritePermission: "Vous n'avez pas l'autorisation d'ajouter des membres.",
        noEditPermission: "Vous n'avez pas l'autorisation de modifier les membres.",
        noDeletePermission: "Vous n'avez pas l'autorisation de supprimer les membres.",
        unnamed: 'Sans nom',
        addTourLabel: 'Visite de création de membre',
        addTourIntroTitle: 'Créer un membre de l’équipe',
        addTourIntroDescription:
          'Utilisez ce formulaire pour ajouter la photo, le nom affiché, les détails du rôle et l’ordre d’affichage avant de publier le profil.',
        addTourIntroHint: 'Commencez par les bases',
        addTourPhotoTitle: 'Photo du membre',
        addTourPhotoDescription:
          'Téléversez un portrait pour que le membre apparaisse avec la bonne identité visuelle sur la page À propos.',
        addTourPhotoHint: 'Ajoutez la photo en premier',
        addTourDetailsTitle: 'Nom et rôle',
        addTourDetailsDescription:
          'Renseignez le nom du membre, le genre, l’ordre d’affichage et le texte du rôle dans les deux langues.',
        addTourDetailsHint: 'Décrivez le membre',
        addTourPreviewTitle: 'Aperçu en direct',
        addTourPreviewDescription:
          'Utilisez la carte d’aperçu pour vérifier l’affichage de la photo et du rôle sur le site public.',
        addTourPreviewHint: 'Vérifiez le rendu final',
        addTourSaveTitle: 'Enregistrer ou abandonner',
        addTourSaveDescription:
          'Utilisez la barre d’actions pour enregistrer le nouveau membre ou abandonner le brouillon et revenir à la liste.',
        addTourSaveHint: 'Terminez le formulaire',
      },
      productTypes: {
        title: 'Types de produits',
        subtitle: 'Gérez des schémas dynamiques pour les spécifications des produits',
        noPermission: "Vous n'avez pas l'autorisation de gérer les types de produits.",
        loadFailed: 'Échec du chargement des types de produits.',
        typeKeyRequired: 'La clé du type est requise.',
        typeLabelRequired: 'Le libellé du type est requis.',
        saveFailed: 'Échec de sauvegarde du type de produit.',
        createdSuccess: 'Type de produit créé.',
        updatedSuccess: 'Type de produit mis à jour.',
        deleteFailed: 'Échec de suppression du type de produit.',
        deletedSuccess: 'Type de produit déplacé vers la corbeille.',
        uploadFailed: 'Échec du téléversement',
        imageUploaded: 'Image téléversée.',
        typeKeyFormatInvalid:
          'La clé du type doit contenir uniquement des lettres minuscules, des chiffres et des tirets bas',
        versionInvalid: 'La version doit être un nombre positif.',
        typeKeyExists: 'La clé du type existe déjà',
        typeNotFound: 'Type de produit introuvable',
        defaultRecreateBlocked: 'Les types de produits par défaut ne peuvent pas être recréés.',
        defaultDeleteBlocked: 'Les types de produits par défaut ne peuvent pas être supprimés.',
        typeInUse: 'Le type de produit est actuellement utilisé par des produits.',
        typeLocked: 'Le type de produit est verrouillé et ne peut pas être supprimé.',
        lockDeletion: 'Verrouiller la suppression',
        unlockDeletion: 'Déverrouiller la suppression',
        locked: 'Verrouillé',
        unlocked: 'Déverrouillé',
        lockEnabled: 'Verrou de suppression activé',
        lockDisabled: 'Verrou de suppression désactivé',
        selectTypeToDelete: 'Sélectionnez un type à supprimer',
        defaultTypeLabel: {
          unclassified: 'Non classé',
          forklift: 'Chariot élévateur',
          pallet_truck: 'Transpalette',
          tractor: 'Tracteur',
          stacker: 'Gerbeur',
        },
        loadingTitle: 'Chargement des types de produits...',
        loadingDescription: 'Récupération des définitions de schéma.',
        errorTitle: 'Erreur de gestion des types de produits',
        availableTypes: 'Types disponibles',
        selectType: 'Sélectionner le type',
        new: 'Nouveau',
        typeKey: 'Clé du type',
        label: 'Libellé',
        labelEnOptional: 'Libellé EN (optionnel)',
        labelFrOptional: 'Libellé FR (optionnel)',
        newTypeTourLabel: 'Visite de création de type',
        newTypeTourIntroTitle: 'Choisir ou créer un type de produit',
        newTypeTourIntroDescription:
          'Utilisez la liste à gauche pour consulter les types de schémas existants, verrouiller ou déverrouiller la suppression, ou démarrer un nouveau type réutilisable pour le catalogue.',
        newTypeTourIntroHint: 'Commencez par la structure du catalogue',
        newTypeTourBasicsTitle: 'Clé, libellés et version',
        newTypeTourBasicsDescription:
          'Définissez la clé machine qui alimente le schéma, rédigez le libellé public, ajoutez les libellés traduits et choisissez une version pour garder les évolutions organisées.',
        newTypeTourBasicsHint: 'Définissez l’identité du schéma',
        newTypeTourImageTitle: 'Image du type',
        newTypeTourImageDescription:
          'Téléversez une image bannière pour que le type soit facile à reconnaître dans les sélecteurs, les cartes et les galeries, puis utilisez le panneau d’aperçu pour vérifier le recadrage.',
        newTypeTourImageHint: 'Ajoutez le repère visuel',
        newTypeTourFieldsTitle: 'Champs techniques et règles',
        newTypeTourFieldsDescription:
          'Ajoutez les champs techniques que chaque produit de ce type doit collecter, puis ouvrez un champ pour régler la localisation, les unités, les règles de validation et les options de liste.',
        newTypeTourFieldsHint: 'Structurez le schéma',
        newTypeTourSaveTitle: 'Enregistrer ou abandonner',
        newTypeTourSaveDescription:
          'Utilisez la barre d’actions pour créer ou mettre à jour le type, le déplacer à la corbeille lorsqu’il n’est plus utile, ou effacer le formulaire et recommencer.',
        newTypeTourSaveHint: 'Terminez le formulaire',
        typeImage: 'Image du type',
        typeImageHint: 'Téléversez une image pour ce type de produit.',
        dragDropTypeImage: 'Glissez-déposez une image ici ou cliquez pour parcourir',
        uploadTypeImage: 'Téléverser image type',
        removeTypeImage: "Retirer l'image",
        imageSettings: "Paramètres d'image",
        imageRecommendedSize: 'Téléversez une image haute résolution. Taille recommandée : 1200x800px.',
        imageFooterHint:
          "Les changements d'image sont enregistrés quand vous cliquez sur Créer le type ou Mettre à jour le type.",
        version: 'Version',
        technicalFields: 'Champs techniques',
        addField: 'Ajouter un champ',
        noFieldsYet: 'Aucun champ pour ce type.',
        fieldKeyPlaceholder: 'clé',
        fieldLabelPlaceholder: 'libellé',
        fieldLabelEnOptional: 'libellé champ EN (optionnel)',
        fieldLabelFrOptional: 'libellé champ FR (optionnel)',
        fieldTypeText: 'texte',
        fieldTypeNumber: 'nombre',
        fieldTypeBoolean: 'booléen',
        fieldTypeSelect: 'liste',
        fieldUnitPlaceholder: 'unité',
        fieldMinPlaceholder: 'min',
        fieldMaxPlaceholder: 'max',
        fieldOptionsPlaceholder: 'options (séparées par des virgules)',
        required: 'Requis',
        remove: 'Retirer',
        saving: 'Enregistrement...',
        updateType: 'Mettre à jour le type',
        createType: 'Créer le type',
        newType: 'Nouveau type',
        deleting: 'Déplacement vers la corbeille...',
        deleteType: 'Déplacer le type vers la corbeille',
      },
      spareParts: {
        title: 'Pièces de rechange',
        subtitle: 'Créer, mettre à jour et supprimer des pièces.',
        loadingTitle: 'Chargement des pièces...',
        loadingDescription: 'Récupération des dernières pièces.',
        loadingSingleTitle: 'Chargement de la pièce...',
        loadingSingleDescription: 'Récupération des détails de la pièce.',
        noReadPermission: "Vous n'avez pas l'autorisation de voir les pièces.",
        noWritePermission: "Vous n'avez pas l'autorisation d'ajouter des pièces.",
        noDeletePermission: "Vous n'avez pas l'autorisation de supprimer des pièces.",
        noEditPermission: "Vous n'avez pas l'autorisation de modifier des pièces.",
        loadFailed: 'Échec du chargement des pièces.',
        failedTitle: 'Échec du chargement des pièces',
        nameRequired: 'Le nom de la pièce est requis.',
        invalidPrice: 'Le prix doit être un nombre positif valide.',
        invalidStock: 'Le stock doit être un nombre positif valide.',
        createFailed: 'Échec de création de la pièce.',
        createdSuccess: 'Pièce créée avec succès.',
        deletedSuccess: 'Pièce supprimée avec succès.',
        updatedSuccess: 'Pièce mise à jour.',
        updateFailed: 'Échec de mise à jour de la pièce.',
        loadSingleFailed: 'Échec du chargement de la pièce.',
        deleteFailed: 'Échec de suppression.',
        exportFailed: "Échec de l'export.",
        importFailed: "Échec de l'import.",
        uploadFailed: 'Échec du téléversement',
        imageUploaded: 'Image téléversée.',
        saveAll: 'Tout enregistrer',
        addViaJson: 'Ajouter via JSON',
        categoryFilter: 'Catégorie',
        searchPlaceholder: 'Rechercher des pièces...',
        emptyText: 'Aucune pièce.',
        settingsTitle: 'Paramètres pièce',
        settingsHint: 'Gérez les détails et le stock de la pièce',
        partName: 'Nom de la pièce',
        namePlaceholder: 'Pièce premium',
        price: 'Prix',
        pricePlaceholder: '0,000',
        stock: 'Stock',
        stockPlaceholder: '0',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez les caractéristiques, matières et usages de la pièce.',
        cannotCreate: 'Impossible de créer la pièce',
        addTourLabel: 'Visite de création de pièce',
        addTourIntroTitle: 'Créer une pièce de rechange',
        addTourIntroDescription:
          'Utilisez ce formulaire pour saisir le nom de la pièce, la catégorie, le prix et les images avant d’enregistrer la fiche.',
        addTourIntroHint: 'Commencez par les bases',
        addTourBasicsTitle: 'Nom et description',
        addTourBasicsDescription:
          'Choisissez d’abord l’onglet de langue, puis remplissez le nom et la description de la pièce pour chaque langue à publier.',
        addTourBasicsHint: 'Rédigez le contenu public',
        addTourCategoryTitle: 'Catégorie et prix',
        addTourCategoryDescription:
          'Définissez le prix et le stock, puis choisissez la catégorie qui correspond le mieux à la pièce dans le catalogue.',
        addTourCategoryHint: 'Organisez la fiche',
        addTourMediaTitle: 'Images de la pièce',
        addTourMediaDescription:
          'Téléversez les principales images et réorganisez-les pour que la meilleure photo apparaisse en premier.',
        addTourMediaHint: 'Organisez la galerie',
        addTourSaveTitle: 'Enregistrer ou abandonner',
        addTourSaveDescription:
          'Utilisez la barre d’actions pour enregistrer la pièce ou abandonner le brouillon et revenir à la liste.',
        addTourSaveHint: 'Terminez le formulaire',
        saving: 'Enregistrement...',
        saveChanges: 'Enregistrer',
        discard: 'Annuler',
        addImage: 'Ajouter image',
        imageHint: 'Ajoutez des visuels pour améliorer la fiche pièce.',
        imageLimitHint: "{{current}} / {{count}} images téléversées. Vous pouvez téléverser jusqu'à {{count}} images.",
        imageLimitReached: "Vous pouvez téléverser jusqu'à {{count}} images seulement.",
        removeImage: 'Retirer image',
        imagePreviewAlt: 'aperçu',
        selectAllParts: 'Sélectionner toutes les pièces',
        nameCol: 'Nom',
        priceCol: 'Prix',
        stockCol: 'Stock',
        imagesCol: 'Images',
        actionsCol: 'Actions',
        saveChangesAction: 'Enregistrer les changements',
        savingChangesAction: 'Enregistrement des changements',
        bulkSaveSuccess: '{{count}} pièce(s) enregistrée(s).',
        bulkSaveFailed: "{{count}} pièce(s) n'ont pas pu être enregistrées.",
        bulkDeleteSuccess: '{{count}} pièce(s) supprimée(s).',
        bulkDeleteFailed: "{{count}} pièce(s) n'ont pas pu être supprimées.",
        exportedAs: 'Pièces exportées en {{format}}.',
        importComplete: 'Import terminé : {{created}} créés, {{updated}} mis à jour, {{skipped}} ignorés.',
        jsonRequired: 'La saisie JSON est requise.',
        jsonObjectOrArray: "Le JSON doit être un objet ou un tableau d'objets.",
        invalidJson: 'Format JSON invalide.',
        jsonModalHint: 'Collez uniquement du JSON valide. Objet ou tableau requis.',
        jsonPlaceholder: '[{"name":"Pièce","price":10,"stock":5}]',
        importJson: 'Importer JSON',
        importingJson: 'Import en cours...',
        editPart: 'Modifier la pièce',
        editTitle: 'Modifier la pièce',
        editSubtitle: 'Mettre à jour les détails de la pièce.',
        unableSave: "Impossible d'enregistrer la pièce",
        reloadItem: 'Recharger la pièce',
        deletePart: 'Supprimer la pièce',
        deleteSelected: 'Supprimer les pièces sélectionnées ?',
        deleteSingle: 'Supprimer cette pièce ?',
        deleteManyDesc: 'Cela supprimera définitivement',
        deleteManyDescWithCount: 'Cela supprimera définitivement {{count}} pièce(s).',
        actionUndone: 'Cette action est irreversible.',
        delete: 'Supprimer',
      },
      sparePartCategories: {
        title: 'Catégories de pièces de rechange',
        subtitle: 'Créer et organiser les libellés de catégories de pièces de rechange.',
        loadingTitle: 'Chargement des catégories de pièces de rechange...',
        loadingDescription: 'Préparation du gestionnaire de catégories.',
        refreshing: 'Actualisation des catégories...',
        listTitle: 'Bibliothèque de catégories',
        items: 'catégories',
        newCategory: 'Nouvelle catégorie',
        addCategory: 'Ajouter une catégorie',
        empty: 'Aucune catégorie pour le moment.',
        newDraft: 'Nouveau brouillon de catégorie',
        editTitle: 'Modifier la catégorie',
        createTitle: 'Créer une catégorie',
        editHint: 'Mettre à jour le libellé et l’état de verrouillage de cette catégorie.',
        createHint: 'Ajouter une nouvelle catégorie réutilisable pour les pièces de rechange.',
        label: 'Libellé',
        required: 'Obligatoire',
        labelHint: 'C’est le nom de la catégorie affiché dans le gestionnaire et utilisé pour générer la clé.',
        labelEnOptional: 'Libellé EN (optionnel)',
        labelFrOptional: 'Libellé FR (optionnel)',
        key: 'Clé',
        locked: 'Verrouillé',
        loadFailed: 'Échec du chargement des catégories de pièces de rechange.',
        noPermission: "Vous n'avez pas l'autorisation de gérer les catégories de pièces de rechange.",
        labelRequired: 'Le libellé de la catégorie est requis.',
        labelEnRequired: 'Le libellé anglais de la catégorie est requis.',
        labelFrRequired: 'Le libellé français de la catégorie est requis.',
        saveFailed: 'Échec de sauvegarde de la catégorie de pièce de rechange.',
        createdSuccess: 'Catégorie de pièce de rechange créée.',
        updatedSuccess: 'Catégorie de pièce de rechange mise à jour.',
        lockedDeleteBlocked: 'Les catégories verrouillées ne peuvent pas être supprimées.',
        deleteFailed: 'Échec de suppression de la catégorie de pièce de rechange.',
        deletedSuccess: 'Catégorie de pièce de rechange supprimée.',
        deleteTitle: 'Supprimer cette catégorie ?',
        deleteDescription: 'Cette action déplacera la catégorie vers la corbeille si elle n’est pas verrouillée ou utilisée.',
        itemCount: '{{count}} pièce(s) de rechange',
      },
    },
  },
};
